// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0yMCAwIDI0IDQwIiB3aWR0aD0iMjQiIGhlaWdodD0iNDAiPjxnIHRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHBhdGggZD0ibTAgMGg1djIzaDIzdjVoLTI4eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDN2MjNoMjN2M2gtMjZ6IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMjQgNDAiIHdpZHRoPSIyNCIgaGVpZ2h0PSI0MCI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMC0waDI4djI4aC01di0yM2gtMjN6IiBvcGFjaXR5PSIuNCIvPjxwYXRoIGQ9Im0xIDFoMjZ2MjZoLTN2LTIzaC0yM3oiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMTggMTciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMCAwaDd2LTdoNXY3aDd2NWgtN3Y3aC01di03aC03eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDd2LTdoM3Y3aDd2M2gtN3Y3aC0zdi03aC03eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Generated on: Thu Jan 30 2020 12:02:03 GMT+0000 (Coordinated Universal Time) */
/* ==========================================================================
   normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css
   ========================================================================== */
/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */

:root {
  --grey-faint: #cbd5e0;
  --grey-lighter: #cbd5e0;
  --grey-background: #f7fafc;
  --grey: #718096;
}

html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
[hidden],
template {
  display: none;
}
a {
  background-color: transparent;
}
a:active,
a:hover {
  outline: 0;
}
abbr[title] {
  border-bottom: 1px dotted;
}
b,
strong {
  font-weight: bold;
}
dfn {
  font-style: italic;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
mark {
  background: #ff0;
  color: #000;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
img {
  border: 0;
}
svg:not(:root) {
  overflow: hidden;
}
figure {
  margin: 1em 40px;
}
hr {
  box-sizing: content-box;
  height: 0;
}
pre {
  overflow: auto;
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}
button {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html input[type="button"],
input[type="reset"] {
  -webkit-appearance: button;
  cursor: pointer;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
input {
  line-height: normal;
}
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
input[type="search"] {
  -webkit-appearance: none;
}
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  border: 0;
  padding: 0;
}
textarea {
  overflow: auto;
}
optgroup {
  font-weight: bold;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
td,
th {
  padding: 0;
}

/* ==========================================================================
   Start of base Webflow CSS - If you're looking for some ultra-clean CSS, skip the boilerplate and see the unminified code below.
   ========================================================================== */
@font-face {
  font-family: "webflow-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format("truetype");
  font-weight: normal;
  font-style: normal;
}
[class^="w-icon-"],
[class*=" w-icon-"] {
  font-family: "webflow-icons" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.w-icon-slider-right:before {
  content: "\\e600";
}
.w-icon-slider-left:before {
  content: "\\e601";
}
.w-icon-nav-menu:before {
  content: "\\e602";
}
.w-icon-arrow-down:before,
.w-icon-dropdown-toggle:before {
  content: "\\e603";
}
.w-icon-file-upload-remove:before {
  content: "\\e900";
}
.w-icon-file-upload-icon:before {
  content: "\\e903";
}
* {
  box-sizing: border-box;
}
html {
  height: 100%;
}
body {
  margin: 0;
  min-height: 100%;
  background-color: #fff;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333;
}
img {
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
}
html.w-mod-touch * {
  background-attachment: scroll !important;
}
.w-block {
  display: block;
}
.w-inline-block {
  max-width: 100%;
  display: inline-block;
}
.w-clearfix:before,
.w-clearfix:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-clearfix:after {
  clear: both;
}
.w-hidden {
  display: none;
}
.w-button {
  display: inline-block;
  padding: 9px 15px;
  background-color: #3898ec;
  color: white;
  border: 0;
  line-height: inherit;
  text-decoration: none;
  cursor: pointer;
  border-radius: 0;
}
input.w-button {
  -webkit-appearance: button;
}
html[data-w-dynpage] [data-w-cloak] {
  color: transparent !important;
}
.w-webflow-badge,
.w-webflow-badge * {
  position: static;
  left: auto;
  top: auto;
  right: auto;
  bottom: auto;
  z-index: auto;
  display: block;
  visibility: visible;
  overflow: visible;
  overflow-x: visible;
  overflow-y: visible;
  box-sizing: border-box;
  width: auto;
  height: auto;
  max-height: none;
  max-width: none;
  min-height: 0;
  min-width: 0;
  margin: 0;
  padding: 0;
  float: none;
  clear: none;
  border: 0 none transparent;
  border-radius: 0;
  background: none;
  background-image: none;
  background-position: 0 0;
  background-size: auto auto;
  background-repeat: repeat;
  background-origin: padding-box;
  background-clip: border-box;
  background-attachment: scroll;
  background-color: transparent;
  box-shadow: none;
  opacity: 1;
  transform: none;
  transition: none;
  direction: ltr;
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  line-height: inherit;
  font-style: inherit;
  font-variant: inherit;
  text-align: inherit;
  letter-spacing: inherit;
  text-decoration: inherit;
  text-indent: 0;
  text-transform: inherit;
  list-style-type: disc;
  text-shadow: none;
  font-smoothing: auto;
  vertical-align: baseline;
  cursor: inherit;
  white-space: inherit;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
}
.w-webflow-badge {
  position: fixed !important;
  display: inline-block !important;
  visibility: visible !important;
  z-index: 2147483647 !important;
  top: auto !important;
  right: 12px !important;
  bottom: 12px !important;
  left: auto !important;
  color: #aaadb0 !important;
  background-color: #fff !important;
  border-radius: 3px !important;
  padding: 6px 8px 6px 6px !important;
  font-size: 12px !important;
  opacity: 1 !important;
  line-height: 14px !important;
  text-decoration: none !important;
  transform: none !important;
  margin: 0 !important;
  width: auto !important;
  height: auto !important;
  overflow: visible !important;
  white-space: nowrap;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.w-webflow-badge > img {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
  vertical-align: middle !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: bold;
  margin-bottom: 10px;
}
h1 {
  font-size: 38px;
  line-height: 44px;
  margin-top: 20px;
}
h2 {
  font-size: 32px;
  line-height: 36px;
  margin-top: 20px;
}
h3 {
  font-size: 24px;
  line-height: 30px;
  margin-top: 20px;
}
h4 {
  font-size: 18px;
  line-height: 24px;
  margin-top: 10px;
}
h5 {
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
}
h6 {
  font-size: 12px;
  line-height: 18px;
  margin-top: 10px;
}
p {
  margin-top: 0;
  margin-bottom: 10px;
}
blockquote {
  margin: 0 0 10px 0;
  padding: 10px 20px;
  border-left: 5px solid #e2e2e2;
  font-size: 18px;
  line-height: 22px;
}
figure {
  margin: 0;
  margin-bottom: 10px;
}
figcaption {
  margin-top: 5px;
  text-align: center;
}
ul,
ol {
  margin-top: 0;
  margin-bottom: 10px;
  padding-left: 40px;
}
.w-list-unstyled {
  padding-left: 0;
  list-style: none;
}
.w-embed:before,
.w-embed:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-embed:after {
  clear: both;
}
.w-video {
  width: 100%;
  position: relative;
  padding: 0;
}
.w-video iframe,
.w-video object,
.w-video embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
fieldset {
  padding: 0;
  margin: 0;
  border: 0;
}
button,
html input[type="button"],
input[type="reset"] {
  border: 0;
  cursor: pointer;
  -webkit-appearance: button;
}
.w-form {
  margin: 0 0 15px;
}
.w-form-done {
  display: none;
  padding: 20px;
  text-align: center;
  background-color: #dddddd;
}
.w-form-fail {
  display: none;
  margin-top: 10px;
  padding: 10px;
  background-color: #ffdede;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.field-label-height {
  margin-top: 67px;
}
.w-input,
.w-select {
  display: block;
  width: 100%;
  height: 38px;
  padding: 8px 12px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333333;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
}
.w-input:-moz-placeholder,
.w-select:-moz-placeholder {
  color: #999;
}
.w-input::-moz-placeholder,
.w-select::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.w-input:-ms-input-placeholder,
.w-select:-ms-input-placeholder {
  color: #999;
}
.w-input::-webkit-input-placeholder,
.w-select::-webkit-input-placeholder {
  color: #999;
}
.w-input:focus,
.w-select:focus {
  border-color: #3898ec;
  outline: 0;
}
.w-input[disabled],
.w-select[disabled],
.w-input[readonly],
.w-select[readonly],
fieldset[disabled] .w-input,
fieldset[disabled] .w-select {
  cursor: not-allowed;
  background-color: #eeeeee;
}
textarea.w-input,
textarea.w-select {
  height: auto;
}
.w-select {
  background-color: #f3f3f3;
}
.w-select[multiple] {
  height: auto;
}
.w-form-label {
  display: inline-block;
  cursor: pointer;
  font-weight: normal;
  margin-bottom: 0;
}
.w-radio {
  display: block;
  margin-bottom: 5px;
  padding-left: 20px;
}
.w-radio:before,
.w-radio:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-radio:after {
  clear: both;
}
.w-radio-input {
  margin: 4px 0 0;
  margin-top: 1px \\9;
  line-height: normal;
  float: left;
  margin-left: -20px;
}
.w-radio-input {
  margin-top: 3px;
}
.w-file-upload {
  display: block;
  margin-bottom: 10px;
}
.w-file-upload-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -100;
}
.w-file-upload-default,
.w-file-upload-uploading,
.w-file-upload-success {
  display: inline-block;
  color: #333333;
}
.w-file-upload-error {
  display: block;
  margin-top: 10px;
}
.w-file-upload-default.w-hidden,
.w-file-upload-uploading.w-hidden,
.w-file-upload-error.w-hidden,
.w-file-upload-success.w-hidden {
  display: none;
}
.w-file-upload-uploading-btn {
  display: flex;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
  margin: 0;
  padding: 8px 12px;
  border: 1px solid #cccccc;
  background-color: #fafafa;
}
.w-file-upload-file {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  margin: 0;
  padding: 8px 9px 8px 11px;
  border: 1px solid #cccccc;
  background-color: #fafafa;
}
.w-file-upload-file-name {
  font-size: 14px;
  font-weight: normal;
  display: block;
}
.w-file-remove-link {
  margin-top: 3px;
  margin-left: 10px;
  width: auto;
  height: auto;
  padding: 3px;
  display: block;
  cursor: pointer;
}
.w-icon-file-upload-remove {
  margin: auto;
  font-size: 10px;
}
.w-file-upload-error-msg {
  display: inline-block;
  color: #ea384c;
  padding: 2px 0;
}
.w-file-upload-info {
  display: inline-block;
  line-height: 38px;
  padding: 0 12px;
}
.w-file-upload-label {
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
  margin: 0;
  padding: 8px 12px;
  border: 1px solid #cccccc;
  background-color: #fafafa;
}
.w-icon-file-upload-icon,
.w-icon-file-upload-uploading {
  display: inline-block;
  margin-right: 8px;
  width: 20px;
}
.w-icon-file-upload-uploading {
  height: 20px;
}
.w-container {
  margin-left: auto;
  margin-right: auto;
  max-width: 940px;
}
.w-container:before,
.w-container:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-container:after {
  clear: both;
}
.w-container .w-row {
  margin-left: -10px;
  margin-right: -10px;
}
.w-row:before,
.w-row:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-row:after {
  clear: both;
}
.w-row .w-row {
  margin-left: 0;
  margin-right: 0;
}
.w-col {
  position: relative;
  float: left;
  width: 100%;
  min-height: 1px;
  padding-left: 10px;
  padding-right: 10px;
}
.w-col .w-col {
  padding-left: 0;
  padding-right: 0;
}
.w-col-1 {
  width: 8.33333333%;
}
.w-col-2 {
  width: 16.66666667%;
}
.w-col-3 {
  width: 25%;
}
.w-col-4 {
  width: 33.33333333%;
}
.w-col-5 {
  width: 41.66666667%;
}
.w-col-6 {
  width: 50%;
}
.w-col-7 {
  width: 58.33333333%;
}
.w-col-8 {
  width: 66.66666667%;
}
.w-col-9 {
  width: 75%;
}
.w-col-10 {
  width: 83.33333333%;
}
.w-col-11 {
  width: 91.66666667%;
}
.w-col-12 {
  width: 100%;
}
.w-hidden-main {
  display: none !important;
}
@media screen and (max-width: 991px) {
  .w-container {
    max-width: 728px;
  }
  .w-hidden-main {
    display: inherit !important;
  }
  .w-hidden-medium {
    display: none !important;
  }
  .w-col-medium-1 {
    width: 8.33333333%;
  }
  .w-col-medium-2 {
    width: 16.66666667%;
  }
  .w-col-medium-3 {
    width: 25%;
  }
  .w-col-medium-4 {
    width: 33.33333333%;
  }
  .w-col-medium-5 {
    width: 41.66666667%;
  }
  .w-col-medium-6 {
    width: 50%;
  }
  .w-col-medium-7 {
    width: 58.33333333%;
  }
  .w-col-medium-8 {
    width: 66.66666667%;
  }
  .w-col-medium-9 {
    width: 75%;
  }
  .w-col-medium-10 {
    width: 83.33333333%;
  }
  .w-col-medium-11 {
    width: 91.66666667%;
  }
  .w-col-medium-12 {
    width: 100%;
  }
  .w-col-stack {
    width: 100%;
    left: auto;
    right: auto;
  }
}
@media screen and (max-width: 767px) {
  .w-hidden-main {
    display: inherit !important;
  }
  .w-hidden-medium {
    display: inherit !important;
  }
  .w-hidden-small {
    display: none !important;
  }
  .w-row,
  .w-container .w-row {
    margin-left: 0;
    margin-right: 0;
  }
  .w-col {
    width: 100%;
    left: auto;
    right: auto;
  }
  .w-col-small-1 {
    width: 8.33333333%;
  }
  .w-col-small-2 {
    width: 16.66666667%;
  }
  .w-col-small-3 {
    width: 25%;
  }
  .w-col-small-4 {
    width: 33.33333333%;
  }
  .w-col-small-5 {
    width: 41.66666667%;
  }
  .w-col-small-6 {
    width: 50%;
  }
  .w-col-small-7 {
    width: 58.33333333%;
  }
  .w-col-small-8 {
    width: 66.66666667%;
  }
  .w-col-small-9 {
    width: 75%;
  }
  .w-col-small-10 {
    width: 83.33333333%;
  }
  .w-col-small-11 {
    width: 91.66666667%;
  }
  .w-col-small-12 {
    width: 100%;
  }
}
@media screen and (max-width: 479px) {
  .w-container {
    max-width: none;
  }
  .w-hidden-main {
    display: inherit !important;
  }
  .w-hidden-medium {
    display: inherit !important;
  }
  .w-hidden-small {
    display: inherit !important;
  }
  .w-hidden-tiny {
    display: none !important;
  }
  .w-col {
    width: 100%;
  }
  .w-col-tiny-1 {
    width: 8.33333333%;
  }
  .w-col-tiny-2 {
    width: 16.66666667%;
  }
  .w-col-tiny-3 {
    width: 25%;
  }
  .w-col-tiny-4 {
    width: 33.33333333%;
  }
  .w-col-tiny-5 {
    width: 41.66666667%;
  }
  .w-col-tiny-6 {
    width: 50%;
  }
  .w-col-tiny-7 {
    width: 58.33333333%;
  }
  .w-col-tiny-8 {
    width: 66.66666667%;
  }
  .w-col-tiny-9 {
    width: 75%;
  }
  .w-col-tiny-10 {
    width: 83.33333333%;
  }
  .w-col-tiny-11 {
    width: 91.66666667%;
  }
  .w-col-tiny-12 {
    width: 100%;
  }
}
.w-widget {
  position: relative;
}
.w-widget-map {
  width: 100%;
  height: 400px;
}
.w-widget-map label {
  width: auto;
  display: inline;
}
.w-widget-map img {
  max-width: inherit;
}
.w-widget-map .gm-style-iw {
  text-align: center;
}
.w-widget-map .gm-style-iw > button {
  display: none !important;
}
.w-widget-twitter {
  overflow: hidden;
}
.w-widget-twitter-count-shim {
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 28px;
  height: 20px;
  text-align: center;
  background: white;
  border: #758696 solid 1px;
  border-radius: 3px;
}
.w-widget-twitter-count-shim * {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
.w-widget-twitter-count-shim .w-widget-twitter-count-inner {
  position: relative;
  font-size: 15px;
  line-height: 12px;
  text-align: center;
  color: #999;
  font-family: serif;
}
.w-widget-twitter-count-shim .w-widget-twitter-count-clear {
  position: relative;
  display: block;
}
.w-widget-twitter-count-shim.w--large {
  width: 36px;
  height: 28px;
  margin-left: 7px;
}
.w-widget-twitter-count-shim.w--large .w-widget-twitter-count-inner {
  font-size: 18px;
  line-height: 18px;
}
.w-widget-twitter-count-shim:not(.w--vertical) {
  margin-left: 5px;
  margin-right: 8px;
}
.w-widget-twitter-count-shim:not(.w--vertical).w--large {
  margin-left: 6px;
}
.w-widget-twitter-count-shim:not(.w--vertical):before,
.w-widget-twitter-count-shim:not(.w--vertical):after {
  top: 50%;
  left: 0;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.w-widget-twitter-count-shim:not(.w--vertical):before {
  border-color: rgba(117, 134, 150, 0);
  border-right-color: #5d6c7b;
  border-width: 4px;
  margin-left: -9px;
  margin-top: -4px;
}
.w-widget-twitter-count-shim:not(.w--vertical).w--large:before {
  border-width: 5px;
  margin-left: -10px;
  margin-top: -5px;
}
.w-widget-twitter-count-shim:not(.w--vertical):after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: white;
  border-width: 4px;
  margin-left: -8px;
  margin-top: -4px;
}
.w-widget-twitter-count-shim:not(.w--vertical).w--large:after {
  border-width: 5px;
  margin-left: -9px;
  margin-top: -5px;
}
.w-widget-twitter-count-shim.w--vertical {
  width: 61px;
  height: 33px;
  margin-bottom: 8px;
}
.w-widget-twitter-count-shim.w--vertical:before,
.w-widget-twitter-count-shim.w--vertical:after {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.w-widget-twitter-count-shim.w--vertical:before {
  border-color: rgba(117, 134, 150, 0);
  border-top-color: #5d6c7b;
  border-width: 5px;
  margin-left: -5px;
}
.w-widget-twitter-count-shim.w--vertical:after {
  border-color: rgba(255, 255, 255, 0);
  border-top-color: white;
  border-width: 4px;
  margin-left: -4px;
}
.w-widget-twitter-count-shim.w--vertical .w-widget-twitter-count-inner {
  font-size: 18px;
  line-height: 22px;
}
.w-widget-twitter-count-shim.w--vertical.w--large {
  width: 76px;
}
.w-widget-gplus {
  overflow: hidden;
}
.w-background-video {
  position: relative;
  overflow: hidden;
  height: 500px;
  color: white;
}
.w-background-video > video {
  background-size: cover;
  background-position: 50% 50%;
  position: absolute;
  margin: auto;
  width: 100%;
  height: 100%;
  right: -100%;
  bottom: -100%;
  top: -100%;
  left: -100%;
  object-fit: cover;
  z-index: -100;
}
.w-background-video > video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}
.w-slider {
  position: relative;
  height: 300px;
  text-align: center;
  background: #dddddd;
  clear: both;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
}
.w-slider-mask {
  position: relative;
  display: block;
  overflow: hidden;
  z-index: 1;
  left: 0;
  right: 0;
  height: 100%;
  white-space: nowrap;
}
.w-slide {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 100%;
  height: 100%;
  white-space: normal;
  text-align: left;
}
.w-slider-nav {
  position: absolute;
  z-index: 2;
  top: auto;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  padding-top: 10px;
  height: 40px;
  text-align: center;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
}
.w-slider-nav.w-round > div {
  border-radius: 100%;
}
.w-slider-nav.w-num > div {
  width: auto;
  height: auto;
  padding: 0.2em 0.5em;
  font-size: inherit;
  line-height: inherit;
}
.w-slider-nav.w-shadow > div {
  box-shadow: 0 0 3px rgba(51, 51, 51, 0.4);
}
.w-slider-nav-invert {
  color: #fff;
}
.w-slider-nav-invert > div {
  background-color: rgba(34, 34, 34, 0.4);
}
.w-slider-nav-invert > div.w-active {
  background-color: #222;
}
.w-slider-dot {
  position: relative;
  display: inline-block;
  width: 1em;
  height: 1em;
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  margin: 0 3px 0.5em;
  transition: background-color 100ms, color 100ms;
}
.w-slider-dot.w-active {
  background-color: #fff;
}
.w-slider-arrow-left,
.w-slider-arrow-right {
  position: absolute;
  width: 80px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  cursor: pointer;
  overflow: hidden;
  color: white;
  font-size: 40px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  user-select: none;
}
.w-slider-arrow-left [class^="w-icon-"],
.w-slider-arrow-right [class^="w-icon-"],
.w-slider-arrow-left [class*=" w-icon-"],
.w-slider-arrow-right [class*=" w-icon-"] {
  position: absolute;
}
.w-slider-arrow-left {
  z-index: 3;
  right: auto;
}
.w-slider-arrow-right {
  z-index: 4;
  left: auto;
}
.w-icon-slider-left,
.w-icon-slider-right {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 1em;
  height: 1em;
}
.w-dropdown {
  display: inline-block;
  position: relative;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  z-index: 900;
}
.w-dropdown-btn,
.w-dropdown-toggle,
.w-dropdown-link {
  position: relative;
  vertical-align: top;
  text-decoration: none;
  color: #222222;
  padding: 20px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  white-space: nowrap;
}
.w-dropdown-toggle {
  -webkit-user-select: none;
  user-select: none;
  display: inline-block;
  cursor: pointer;
  padding-right: 40px;
}
.w-icon-dropdown-toggle {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  margin-right: 20px;
  width: 1em;
  height: 1em;
}
.w-dropdown-list {
  position: absolute;
  background: #dddddd;
  display: none;
  min-width: 100%;
}
.w-dropdown-list.w--open {
  display: block;
}
.w-dropdown-link {
  padding: 10px 20px;
  display: block;
  color: #222222;
}
.w-dropdown-link.w--current {
  color: #0082f3;
}
.question-skip-logic {
  width: 510px;
  word-wrap: break-word;
}
@media screen and (max-width: 767px) {
  .w-nav-brand {
    padding-left: 10px;
  }
}
.w-lightbox-backdrop {
  color: #000;
  cursor: auto;
  font-family: serif;
  font-size: medium;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-height: normal;
  list-style: disc;
  text-align: start;
  text-indent: 0;
  text-shadow: none;
  text-transform: none;
  visibility: visible;
  white-space: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  color: #fff;
  font-family: "Helvetica Neue", Helvetica, Ubuntu, "Segoe UI", Verdana,
    sans-serif;
  font-size: 17px;
  line-height: 1.2;
  font-weight: 300;
  text-align: center;
  background: rgba(0, 0, 0, 0.9);
  z-index: 2000;
  outline: 0;
  opacity: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-transform: translate(0, 0);
}
.w-lightbox-backdrop,
.w-lightbox-container {
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.w-lightbox-content {
  position: relative;
  height: 100vh;
  overflow: hidden;
}
.w-lightbox-view {
  position: absolute;
  width: 100vw;
  height: 100vh;
  opacity: 0;
}
.w-lightbox-view:before {
  content: "";
  height: 100vh;
}
.w-lightbox-group,
.w-lightbox-group .w-lightbox-view,
.w-lightbox-group .w-lightbox-view:before {
  height: 86vh;
}
.w-lightbox-frame,
.w-lightbox-view:before {
  display: inline-block;
  vertical-align: middle;
}
.w-lightbox-figure {
  position: relative;
  margin: 0;
}
.w-lightbox-group .w-lightbox-figure {
  cursor: pointer;
}
.w-lightbox-img {
  width: auto;
  height: auto;
  max-width: none;
}
.w-lightbox-image {
  display: block;
  float: none;
  max-width: 100vw;
  max-height: 100vh;
}
.w-lightbox-group .w-lightbox-image {
  max-height: 86vh;
}
.w-lightbox-caption {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0.5em 1em;
  background: rgba(0, 0, 0, 0.4);
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.w-lightbox-embed {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.w-lightbox-control {
  position: absolute;
  top: 0;
  width: 4em;
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  transition: all 0.3s;
}
.w-lightbox-left {
  display: none;
  bottom: 0;
  left: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.w-lightbox-right {
  display: none;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.w-lightbox-close {
  right: 0;
  height: 2.6em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 18px;
}
.w-lightbox-strip {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 1vh;
  line-height: 0;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
.w-lightbox-item {
  display: inline-block;
  width: 10vh;
  padding: 2vh 1vh;
  box-sizing: content-box;
  cursor: pointer;
  -webkit-transform: translate3d(0, 0, 0);
}
.w-lightbox-active {
  opacity: 0.3;
}
.w-lightbox-thumbnail {
  position: relative;
  height: 10vh;
  background: #222;
  overflow: hidden;
}
.w-lightbox-thumbnail-image {
  position: absolute;
  top: 0;
  left: 0;
}
.w-lightbox-thumbnail .w-lightbox-tall {
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
}
.w-lightbox-thumbnail .w-lightbox-wide {
  left: 50%;
  height: 100%;
  transform: translate(-50%, 0);
}
.w-lightbox-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  margin-top: -20px;
  margin-left: -20px;
  border: 5px solid rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  animation: spin 0.8s infinite linear;
}
.w-lightbox-spinner:after {
  content: "";
  position: absolute;
  top: -4px;
  right: -4px;
  bottom: -4px;
  left: -4px;
  border: 3px solid transparent;
  border-bottom-color: #fff;
  border-radius: 50%;
}
.w-lightbox-hide {
  display: none;
}
.w-lightbox-noscroll {
  overflow: hidden;
}
@media (min-width: 768px) {
  .w-lightbox-content {
    height: 96vh;
    margin-top: 2vh;
  }
  .w-lightbox-view,
  .w-lightbox-view:before {
    height: 96vh;
  }
  .w-lightbox-group,
  .w-lightbox-group .w-lightbox-view,
  .w-lightbox-group .w-lightbox-view:before {
    height: 84vh;
  }
  .w-lightbox-image {
    max-width: 96vw;
    max-height: 96vh;
  }
  .w-lightbox-group .w-lightbox-image {
    max-width: 82.3vw;
    max-height: 84vh;
  }
  .w-lightbox-left,
  .w-lightbox-right {
    display: block;
    opacity: 0.5;
  }
  .w-lightbox-close {
    opacity: 0.8;
  }
  .w-lightbox-control:hover {
    opacity: 1;
  }
}
.w-lightbox-inactive,
.w-lightbox-inactive:hover {
  opacity: 0;
}
.w-richtext:before,
.w-richtext:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-richtext:after {
  clear: both;
}
.w-richtext[contenteditable="true"]:before,
.w-richtext[contenteditable="true"]:after {
  white-space: initial;
}
.w-richtext ol,
.w-richtext ul {
  overflow: hidden;
}
.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-video div:after,
.w-richtext .w-richtext-figure-selected[data-rt-type="video"] div:after {
  outline: 2px solid #2895f7;
}
.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-image div,
.w-richtext .w-richtext-figure-selected[data-rt-type="image"] div {
  outline: 2px solid #2895f7;
}
.w-richtext figure.w-richtext-figure-type-video > div:after,
.w-richtext figure[data-rt-type="video"] > div:after {
  content: "";
  position: absolute;
  display: none;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.w-richtext figure {
  position: relative;
  max-width: 60%;
}
.w-richtext figure > div:before {
  cursor: default !important;
}
.w-richtext figure img {
  width: 100%;
}
.w-richtext figure figcaption.w-richtext-figcaption-placeholder {
  opacity: 0.6;
}
.w-richtext figure div {
  font-size: 0;
  color: transparent;
}
.w-richtext figure.w-richtext-figure-type-image,
.w-richtext figure[data-rt-type="image"] {
  display: table;
}
.w-richtext figure.w-richtext-figure-type-image > div,
.w-richtext figure[data-rt-type="image"] > div {
  display: inline-block;
}
.w-richtext figure.w-richtext-figure-type-image > figcaption,
.w-richtext figure[data-rt-type="image"] > figcaption {
  display: table-caption;
  caption-side: bottom;
}
.w-richtext figure.w-richtext-figure-type-video,
.w-richtext figure[data-rt-type="video"] {
  width: 60%;
  height: 0;
}
.w-richtext figure.w-richtext-figure-type-video iframe,
.w-richtext figure[data-rt-type="video"] iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.w-richtext figure.w-richtext-figure-type-video > div,
.w-richtext figure[data-rt-type="video"] > div {
  width: 100%;
}
.w-richtext figure.w-richtext-align-center {
  margin-right: auto;
  margin-left: auto;
  clear: both;
}
.w-richtext figure.w-richtext-align-center.w-richtext-figure-type-image > div,
.w-richtext figure.w-richtext-align-center[data-rt-type="image"] > div {
  max-width: 100%;
}
.w-richtext figure.w-richtext-align-normal {
  clear: both;
}
.w-richtext figure.w-richtext-align-fullwidth {
  width: 100%;
  max-width: 100%;
  text-align: center;
  clear: both;
  display: block;
  margin-right: auto;
  margin-left: auto;
}
.w-richtext figure.w-richtext-align-fullwidth > div {
  display: inline-block;
  padding-bottom: inherit;
}
.w-richtext figure.w-richtext-align-fullwidth > figcaption {
  display: block;
}
.w-richtext figure.w-richtext-align-floatleft {
  float: left;
  margin-right: 15px;
  clear: none;
}
.w-richtext figure.w-richtext-align-floatright {
  float: right;
  margin-left: 15px;
  clear: none;
}
.w-nav {
  position: relative;
  background: #dddddd;
  z-index: 1000;
}
.w-nav:before,
.w-nav:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-nav:after {
  clear: both;
}
.w-nav-brand {
  position: relative;
  float: left;
  text-decoration: none;
  color: #333333;
}
.w-nav-link {
  position: relative;
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  color: #222222;
  padding: 20px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}
.w-nav-link.w--current {
  color: #0082f3;
}
.w-nav-menu {
  position: relative;
  float: right;
}
.w--nav-menu-open {
  display: block !important;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #c8c8c8;
  text-align: center;
  overflow: visible;
  min-width: 200px;
}
.w--nav-link-open {
  display: block;
  position: relative;
}
.w-nav-overlay {
  position: absolute;
  overflow: hidden;
  display: none;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
}
.w-nav-overlay .w--nav-menu-open {
  top: 0;
}
.w-nav[data-animation="over-left"] .w-nav-overlay {
  width: auto;
}
.w-nav[data-animation="over-left"] .w-nav-overlay,
.w-nav[data-animation="over-left"] .w--nav-menu-open {
  right: auto;
  z-index: 1;
  top: 0;
}
.w-nav[data-animation="over-right"] .w-nav-overlay {
  width: auto;
}
.w-nav[data-animation="over-right"] .w-nav-overlay,
.w-nav[data-animation="over-right"] .w--nav-menu-open {
  left: auto;
  z-index: 1;
  top: 0;
}
.w-nav-button {
  position: relative;
  float: right;
  padding: 18px;
  font-size: 24px;
  display: none;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  user-select: none;
}
.w-nav-button.w--open {
  background-color: #c8c8c8;
  color: white;
}
.w-nav[data-collapse="all"] .w-nav-menu {
  display: none;
}
.w-nav[data-collapse="all"] .w-nav-button {
  display: block;
}
.w--nav-dropdown-open {
  display: block;
}
.w--nav-dropdown-toggle-open {
  display: block;
}
.w--nav-dropdown-list-open {
  position: static;
}
@media screen and (max-width: 991px) {
  .w-nav[data-collapse="medium"] .w-nav-menu {
    display: none;
  }
  .w-nav[data-collapse="medium"] .w-nav-button {
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .w-nav[data-collapse="small"] .w-nav-menu {
    display: none;
  }
  .w-nav[data-collapse="small"] .w-nav-button {
    display: block;
  }
  .w-nav-brand {
    padding-left: 10px;
  }
}
@media screen and (max-width: 479px) {
  .w-nav[data-collapse="tiny"] .w-nav-menu {
    display: none;
  }
  .w-nav[data-collapse="tiny"] .w-nav-button {
    display: block;
  }
}
.w-tabs {
  position: relative;
}
.w-tabs:before,
.w-tabs:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-tabs:after {
  clear: both;
}
.w-tab-menu {
  position: relative;
}
.w-tab-link {
  position: relative;
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  padding: 9px 30px;
  text-align: left;
  cursor: pointer;
  color: #222222;
  background-color: #dddddd;
}
.w-tab-link.w--current {
  background-color: #c8c8c8;
}
.w-tab-content {
  position: relative;
  display: block;
  overflow: hidden;
}
.w-tab-pane {
  position: relative;
  display: none;
}
.w--tab-active {
  display: block;
}
@media screen and (max-width: 479px) {
  .w-tab-link {
    display: block;
  }
}
.w-ix-emptyfix:after {
  content: "";
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.w-dyn-empty {
  padding: 10px;
  background-color: #dddddd;
}
.w-dyn-hide {
  display: none !important;
}
.w-dyn-bind-empty {
  display: none !important;
}
.w-condition-invisible {
  display: none !important;
}

/* ==========================================================================
   Start of custom Webflow CSS
   ========================================================================== */
.w-checkbox {
  display: block;
  margin-bottom: 5px;
  padding-left: 20px;
}

.w-checkbox::before {
  content: " ";
  display: table;
  -ms-grid-column-span: 1;
  grid-column-end: 2;
  grid-column-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  grid-row-start: 1;
}

.w-checkbox::after {
  content: " ";
  display: table;
  -ms-grid-column-span: 1;
  grid-column-end: 2;
  grid-column-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  grid-row-start: 1;
  clear: both;
}

.w-checkbox-input {
  float: left;
  margin-bottom: 0px;
  margin-left: -20px;
  margin-right: 0px;
  margin-top: 4px;
  line-height: normal;
}

.w-checkbox-input--inputType-custom {
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-right-width: 1px;
  border-top-color: #ccc;
  border-bottom-color: #ccc;
  border-left-color: #ccc;
  border-right-color: #ccc;
  border-top-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-right-style: solid;
  width: 12px;
  height: 12px;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.w-checkbox-input--inputType-custom.w--redirected-checked {
  background-color: #3898ec;
  border-top-color: #3898ec;
  border-bottom-color: #3898ec;
  border-left-color: #3898ec;
  border-right-color: #3898ec;
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/static/custom-checkbox-checkmark.589d534424.svg);
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
}

.w-checkbox-input--inputType-custom.w--redirected-focus {
  box-shadow: 0px 0px 3px 1px #3898ec;
}

.w-form-formradioinput--inputType-custom {
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-right-width: 1px;
  border-top-color: #ccc;
  border-bottom-color: #ccc;
  border-left-color: #ccc;
  border-right-color: #ccc;
  border-top-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-right-style: solid;
  width: 12px;
  height: 12px;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
}

.w-form-formradioinput--inputType-custom.w--redirected-focus {
  box-shadow: 0px 0px 3px 1px #3898ec;
}

.w-form-formradioinput--inputType-custom.w--redirected-checked {
  border-top-width: 4px;
  border-bottom-width: 4px;
  border-left-width: 4px;
  border-right-width: 4px;
  border-top-color: #3898ec;
  border-bottom-color: #3898ec;
  border-left-color: #3898ec;
  border-right-color: #3898ec;
}

body {
  background-color: #f7fafc;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  color: #2d3748;
  font-size: 16px;
  line-height: 160%;
  cursor: default;
}

h1 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 28px;
  line-height: 120%;
  font-weight: 400;
}

h2 {
  max-width: 400px;
  margin-top: 0px;
  margin-bottom: 8px;
  font-size: 20px;
  line-height: 120%;
  font-weight: 400;
}

h3 {
  margin-top: 0px;
  margin-bottom: 4px;
  color: #718096;
  font-size: 16px;
  line-height: 120%;
  font-weight: 400;
}

h4 {
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 16px;
  line-height: 1.2em;
  font-weight: 600;
}

h5 {
  margin-top: 0px;
  margin-bottom: 4px;
  color: #718096;
  font-size: 14px;
  line-height: 1.2em;
  font-weight: 400;
}

h6 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 15px;
  line-height: 1.2em;
  font-weight: 400;
}

p {
  max-width: 600px;
  margin-bottom: 0px;
  line-height: 160%;
}

a {
  color: #320b85;
  text-decoration: none;
  cursor: pointer;
}

ul {
  margin-top: 0px;
  margin-bottom: 10px;
  padding-left: 40px;
}

img {
  display: inline-block;
  max-width: 100%;
}

label {
  display: block;
  margin-bottom: 4px;
  color: #4a5568;
  font-size: 14px;
  line-height: 100%;
  font-weight: 600;
  text-align: left;
}

strong {
  font-weight: 600;
}

blockquote {
  margin-bottom: 10px;
  padding: 10px 20px;
  border-left: 3px solid #ebebeb;
  font-size: 19px;
  line-height: 1.6em;
}

figure {
  margin-bottom: 10px;
}

figcaption {
  margin-top: 5px;
  margin-bottom: 80px;
  text-align: center;
}

.plan {
  margin-bottom: 8px;
  padding: 8px;
  border-style: solid;
  border-width: 1px;
  border-color: #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
}

.plan.active {
  border-color: #5f3dc4;
}

.project-hero-copy {
  width: 50%;
  padding-top: 60px;
  padding-bottom: 60px;
}

.hero-headline {
  font-size: 60px;
  line-height: 1.1em;
  font-weight: 400;
}

.style-guide-content {
  padding-top: 40px;
}

.style-guide-label {
  margin-top: 8px;
  margin-bottom: 32px;
  color: #1a202c;
  font-size: 11px;
  line-height: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.style-guide-label.cc-box {
  display: flex;
  justify-content: space-between;
}

.style-guide-section {
  position: relative;
  margin: 16px;
  padding: 64px 32px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 16px 64px 0 rgba(33, 37, 41, 0.2);
}

.body {
  font-size: 15px;
  line-height: 1.6em;
}

.button {
  position: relative;
  display: inline-block;
  margin-top: 16px;
  margin-bottom: 8px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  border: 2px solid transparent;
  border-radius: 4px;
  background-color: rgba(69, 23, 166, 0.1);
  box-shadow: none;
  transition: all 250ms ease;
  color: #320b85;
  font-weight: 600;
}

.button:hover {
  box-shadow: none;
  transform: translate(0px, -2px);
}

.button:active {
  border-color: #320b85;
}

.button:focus {
  z-index: 1;
  border-color: rgba(69, 23, 166, 0.22);
}

.button.small {
  margin-top: 8px;
  padding: 4px 8px;
  font-size: 14px;
}

.button.small.grouped.group-end.no-margin {
  flex: 0 0 auto;
}

.button.small.subtle.with-icon {
  flex: 0 0 auto;
}

.button.small.no-margin.move-left.subtle.is-icon {
  width: auto;
  height: auto;
  padding: 2px;
}

.button.small.no-margin.move-left.positive.is-icon {
  width: auto;
  height: auto;
  padding: 2px;
}

.button.small.no-margin.move-left.negative.is-icon {
  width: auto;
  height: auto;
  padding: 2px;
}

.button.small.no-margin.subtle.is-icon {
  width: auto;
  height: auto;
  padding: 2px;
}

.button.small.nudge-down.with-icon.disabled {
  background-color: #f7fafc;
  color: #718096;
}

.button.large {
  padding: 16px 32px;
  background-color: rgba(69, 23, 166, 0.1);
  font-size: 20px;
}

.button.large.grouped.group-end.no-margin.white {
  height: 52px;
  flex: 0 0 auto;
}

.button.default {
  border-style: solid;
  border-width: 2px;
  border-color: #4517a6;
  background-color: #fff;
  box-shadow: none;
  color: #320b85;
  font-weight: 600;
}

.button.primary {
  border-color: #4517a6;
  background-color: #4517a6;
  box-shadow: 0 8px 16px -4px rgba(69, 23, 166, 0.3);
  color: #fff;
}

.button.primary:hover {
  box-shadow: 0 12px 20px -4px rgba(156, 54, 181, 0.3);
}

.button.primary:focus {
  border-color: #e37cff;
}

.button.primary.is-grouped {
  position: relative;
  box-shadow: none;
}

.button.primary.is-grouped.group-end.is-icon {
  transform: none;
}

.button.primary.black {
  border-style: solid;
  border-color: #1a202c;
  background-color: #1a202c;
  box-shadow: 0 8px 16px -4px rgba(33, 37, 41, 0.3);
  color: #fff;
}

.button.primary.large {
  margin-bottom: 16px;
  box-shadow: 0 16px 32px -4px rgba(69, 23, 166, 0.3);
}

.button.primary.medium {
  width: 164px;
  text-align: center;
}

.button.subtle {
  padding-right: 8px;
  padding-left: 8px;
  border-style: solid;
  border-color: transparent;
  background-color: transparent;
  color: #320b85;
}

.button.subtle:hover {
  background-color: rgba(69, 23, 166, 0.1);
  transform: none;
}

.button.subtle:focus {
  border-style: solid;
  border-color: rgba(69, 23, 166, 0.22);
}

.button.subtle.is-small {
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 2px 2px 0px;
  line-height: 140%;
}

.button.subtle.is-small.danger {
  color: #c92a2a;
}

.button.subtle.is-small.danger:hover {
  background-color: rgba(250, 82, 82, 0.2);
}

.button.subtle.is-small.push-left {
  margin-right: 8px;
}

.button.subtle.is-small.warning {
  color: #f76707;
}

.button.subtle.is-small.warning:hover {
  background-color: rgba(255, 146, 43, 0.2);
}

.button.subtle.is-icon {
  height: auto;
}

.button.subtle.is-icon.is-table-action {
  position: absolute;
  top: -3px;
  right: 0px;
}

.button.subtle.small {
  padding: 0px 4px;
}

.button.subtle.small.push-left {
  margin-right: 8px;
}

.button.subtle.small.danger {
  color: #c92a2a;
}

.button.subtle.small.danger:hover {
  background-color: rgba(250, 82, 82, 0.2);
}

.button.subtle.small.warning {
  color: #f76707;
}

.button.subtle.small.with-icon.black {
  background-color: rgba(33, 37, 41, 0);
  color: #2d3748;
}

.button.subtle.small.with-icon.black:hover {
  background-color: #cbd5e0;
}

.button.subtle.small.with-icon.disabled {
  color: #718096;
}

.button.subtle.with-icon.small {
  padding-top: 2px;
}

.button.is-disabled {
  border-color: #edf2f7;
  background-color: #edf2f7;
  transition: none 0ms ease;
  color: #718096;
}

.button.is-disabled:hover {
  transform: none;
}

.button.is-warning {
  border-color: #ff922b;
  background-color: #ff922b;
  color: #1a202c;
}

.button.is-warning:active {
  border-color: rgba(69, 23, 166, 0.22);
}

.button.is-warning:focus {
  border-color: rgba(69, 23, 166, 0.22);
}

.button.danger {
  border-color: #fa5252;
  background-color: #fa5252;
  color: #fff;
}

.button.danger:focus {
  border-color: rgba(69, 23, 166, 0.22);
}

.button.danger.subtle {
  border-color: transparent;
  background-color: transparent;
  color: #c92a2a;
}

.button.danger.subtle:hover {
  background-color: rgba(250, 82, 82, 0.2);
}
.button.danger.subtle.padded.horizontal {
  padding: 6px 16px;
}

.button.dropdown {
  display: flex;
  justify-content: center;
  align-items: center;
}

.button.with-object {
  display: flex;
}

.button.with-object.is-subtle {
  margin-top: 0px;
  margin-bottom: 0px;
  background-color: transparent;
}

.button.with-object.is-subtle:hover {
  transform: none;
}

.button.with-object.is-subtle.no-spacing {
  padding-right: 0px;
  padding-left: 0px;
}

.button.with-object.is-subtle.muted {
  color: #4a5568;
}

.button.with-object.subtle.is-icon.is-table-action {
  position: static;
  margin-top: -3px;
  margin-bottom: 0px;
}

.button.wide {
  width: 100%;
  text-align: center;
}

.button.menu {
  text-align: center;
}

.button.wide.with-icon.no-margin.small.subtle {
  width: auto;
}

.button.grouped {
  margin-right: 2px;
  border-radius: 2px;
}

.button.grouped:hover {
  opacity: 0.7;
  transform: none;
}

.button.grouped.group-lead {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.button.grouped.group-end {
  margin-right: 0px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.button.grouped.primary {
  box-shadow: none;
}

.button.grouped.expand {
  text-align: center;
}

.button.is-icon {
  display: flex;
  width: 45px;
  height: 45px;
  padding: 0px;
}

.button.push-right {
  margin-left: 16px;
}

.button.black {
  border-style: none;
  background-color: rgba(33, 37, 41, 0.1);
  color: #2d3748;
}

.button.black.wide.no-margin {
  background-color: #eeebf7;
  color: #4517a6;
}

.button.black.wide.no-margin.throw-down {
  margin-top: 32px;
}

.button.white {
  border-style: none;
  background-color: hsla(0, 0%, 100%, 0.1);
  color: #fff;
}

.button.float-right {
  float: right;
}

.button.float-left {
  float: left;
}

.button.no-margin {
  margin-top: 0px;
  margin-bottom: 0px;
}

.button.no-margin.subtle.no-padding {
  padding: 0px;
}

.button.no-margin.subtle.is-icon {
  height: 45px;
}

.button.no-margin.subtle.is-icon.table-action {
  position: absolute;
  top: 50%;
  right: 0px;
  margin-top: -22.5px;
}

.button.no-margin.subtle.is-icon.table-action-icon {
  width: 32px;
  height: 16px;
}

.button.no-margin.subtle.is-icon.table-action-icon.anchor-top {
  top: 0px;
}

.button.no-margin.subtle.is-icon.table-action-icon.auto-height {
  height: auto;
}

.button.no-margin.move-right.align-center.no-shrink {
  flex: 0 0 auto;
}

.button.no-margin.with-icon.disabled {
  background-color: #f7fafc;
  color: #718096;
}

.button.no-margin.move-down {
  margin-top: 8px;
}

.button.tall {
  height: 100%;
}

.button.no-padding {
  padding: 0px;
}

.button.no-padding.subtle.with-icon.no-margin.black {
  padding: 2px 4px;
  background-color: transparent;
}

.button.no-padding.subtle.with-icon.small.black.no-margin.push-up {
  margin-bottom: 16px;
  padding: 0px;
}

.button.med-width {
  padding-right: 64px;
  padding-left: 64px;
}

.button.fill-height {
  width: auto;
}

.button.pink {
  background-color: rgba(230, 73, 128, 0.1);
  color: #e64980;
}

.button.green {
  background-color: rgba(130, 201, 30, 0.1);
  color: #82c91e;
}

.button.blue {
  background-color: rgba(77, 171, 247, 0.1);
  color: #4dabf7;
}

.project-content {
  display: block;
}

.project-content figure {
  margin-top: 10px;
  margin-bottom: 50px;
}

.project-content img {
  display: block;
}

.project-hero-section {
  padding-top: 60px;
}

.project-hero-container {
  display: flex;
  width: 90%;
  max-width: 1000px;
  margin-right: auto;
  margin-left: auto;
  justify-content: flex-start;
  align-items: center;
}

.project-details-container {
  display: block;
  width: 90%;
  max-width: 1000px;
  margin-right: auto;
  margin-left: auto;
}

.project-services {
  padding-left: 0px;
}

.project-services ul {
  padding-left: 20px;
  font-size: 14px;
  line-height: 30px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.project-hero-logo {
  display: flex;
  width: 50%;
  padding: 60px;
  justify-content: center;
  align-items: center;
}

.navbar {
  position: fixed;
  display: flex;
  width: 100%;
  height: 60px;
  justify-content: center;
  background-color: #f5f5f5;
}

.container-2 {
  display: flex;
  width: 80%;
  height: 100%;
  max-width: 1000px;
  margin-right: 0px;
  margin-left: 0px;
  justify-content: center;
}

.back-button {
  display: flex;
  height: 100%;
  float: left;
  align-items: center;
}

.body {
  font-family: "Proxima Nova", sans-serif;
  color: #2d3748;
}

.type-column-2 {
  padding-top: 30px;
  padding-left: 20px;
}

.type-column-1 {
  padding-right: 20px;
}

.style-guide-title {
  position: absolute;
  left: 0px;
  top: 0px;
  display: inline-block;
  margin-top: 0px;
  padding-top: 16px;
  padding-left: 28px;
  color: #1a202c;
  font-size: 22px;
  line-height: 44px;
  font-weight: 500;
  text-transform: uppercase;
}

.color-block {
  height: 70px;
  margin-top: 30px;
  border-radius: 4px;
  background-color: #ebebeb;
}

.color-block.cc-black {
  background-color: #1a202c;
}

.color-block.cc-grey-dark {
  background-color: #1a202c;
}

.color-block.cc-purple {
  background-color: #4517a6;
}

.color-block.cc-purple.with-object-inside {
  padding: 16px;
}

.color-block.cc-purple-dark {
  background-color: #320b85;
}

.color-block.cc-purple-light {
  background-color: rgba(69, 23, 166, 0.22);
}

.color-block.cc-brand-color-4 {
  background-color: #f7fafc;
}

.color-block.cc-negative {
  background-color: #fa5252;
}

.color-block.cc-neutral {
  background-color: #fcc419;
}

.color-block.cc-dark-grey-1 {
  background-color: #4a5568;
}

.color-block.cc-dark-grey-2 {
  background-color: #2d3748;
}

.color-block.cc-grey {
  background-color: #2d3748;
}

.color-block.cc-grey-light {
  background-color: #4a5568;
}

.color-block.cc-grey-lighter {
  background-color: #718096;
}

.color-block.cc-grey-faint {
  background-color: #cbd5e0;
}

.color-block.cc-grey-background {
  background-color: #f7fafc;
}

.color-block.cc-positive {
  background-color: #40c057;
}

.color-block.cc-brand-color-1 {
  background-color: #9775fa;
}

.color-block.cc-brand-color-2 {
  background-color: #4dabf7;
}

.color-block.cc-brand-color-3 {
  background-color: #38d9a9;
}

.color-block.cc-brand-color-4 {
  background-color: #82c91e;
}

.color-block.cc-brand-color-5 {
  background-color: #e64980;
}

.color-block.cc-purple-lighter {
  background-color: rgba(69, 23, 166, 0.1);
}

.color-block.cc-important {
  background-color: #ff922b;
}

.color-block.cc-violet {
  background-color: #7950f2;
}

.color-block.cc-violet.with-object-inside {
  padding: 16px;
}

.color-block.cc-grey-background-2 {
  background-color: #edf2f7;
}

.color-block.cc-important-light {
  background-color: rgba(255, 146, 43, 0.2);
}

.color-block.cc-important-dark {
  background-color: #f76707;
}

.color-block.cc-positive-light {
  background-color: rgba(64, 192, 87, 0.2);
}

.color-block.cc-positive-dark {
  background-color: #2b8a3e;
}

.color-block.cc-neutral-light {
  background-color: rgba(250, 176, 5, 0.2);
}

.color-block.cc-neutral-dark {
  background-color: #e67700;
}

.color-block.cc-negative-light {
  background-color: rgba(250, 82, 82, 0.2);
}

.color-block.cc-negative-dark {
  background-color: #c92a2a;
}

.color-block.cc-grey-fade {
  background-color: #e2e8f0;
}

.style-guide-title-section {
  margin-bottom: 10px;
}

.subhead {
  margin-top: 20px;
  margin-bottom: 40px;
  padding: 20px;
  border-radius: 4px;
  background-color: #edf2f7;
  color: #2d3748;
}

.subhead.inverse {
  background-color: #1a202c;
  color: #718096;
}

.subhead.inverse.no-margin.move-down {
  margin-top: 8px;
}

.subhead.inverse.no-margin.with-icon.nudge-down {
  margin-top: 4px;
}

.subhead.no-margin.move-down {
  margin-top: 8px;
}

.style-guide-label-column {
  min-height: 44px;
}

.style-guide-wrap {
  background-color: #f7fafc;
}

.style-guide-logo-box {
  display: flex;
  padding: 40px;
  justify-content: center;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-color: #cbd5e0;
  border-radius: 4px;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f1e3dfef2d0_transparent.gif");
  background-position: 0px 0px;
  background-size: 16px;
}

.style-guide-logo-box.cc-dark {
  background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),
    url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f1e3dfef2d0_transparent.gif");
  background-position: 0px 0px, 0px 0px;
  background-size: auto, 16px;
}

.style-guide-logo-box.cc-light {
  background-image: linear-gradient(
      180deg,
      hsla(0, 0%, 100%, 0.5),
      hsla(0, 0%, 100%, 0.5)
    ),
    url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f1e3dfef2d0_transparent.gif");
  background-position: 0px 0px, 0px 0px;
  background-size: auto, 16px;
}

.style-guide-logo-box.cc-white {
  background-color: #fff;
  background-image: none;
  background-position: 0px 0px;
  background-size: auto;
}

.divider {
  width: 100%;
  height: 1px;
  margin-top: 16px;
  margin-bottom: 8px;
  background-color: #cbd5e0;
}

.divider.spacer {
  width: 100%;
  margin-top: 32px;
  margin-bottom: 32px;
}

.divider.no-top-margin {
  margin-top: 0px;
}

.divider.darker {
  background-color: #2d3748;
}

.divider.no-margin.push-up {
  margin-bottom: 16px;
}

.divider.no-margin.move-up {
  margin-bottom: 8px;
}

.divider.push-up {
  background-color: #e2e8f0;
}

.divider.push-up.in-sidebar {
  margin-bottom: 16px;
  background-color: #e8ddff;
}

.divider.in-sidebar {
  margin-top: 32px;
  margin-bottom: 32px;
}

.link {
  display: block;
  color: #320b85;
}

.link.inline.small {
  font-size: 14px;
}

.style-guide-label-link {
  display: inline-block;
  font-size: 11px;
  line-height: 11px;
  font-weight: 500;
  text-decoration: none;
}

.style-guide-label-link:hover {
  text-decoration: underline;
}

.input {
  height: 36px;
  margin-bottom: 0px;
  padding-right: 8px;
  padding-left: 8px;
  border-style: none;
  border-width: 1px;
  border-color: #718096;
  border-radius: 4px;
  background-color: #e2e8f0;
  transition: all 250ms ease;
  color: #1a202c;
  line-height: 100%;
}

.input.filter {
  width: 19px;
  height: 20px;
  margin-left: 0px;
  padding: 0px 2px;
  background-color: #e4e0f1;
  font-size: 12px;
}

.input.survey-search {
  background-color: rgba(0, 0, 0, 0);
  width: 240px;
  height: auto;
  padding-top: 8px;
  font-size: 16px;
}

.input:hover {
  border-color: #4a5568;
  background-color: #cbd5e0;
}

.input:focus {
  border-style: solid;
  border-width: 2px;
  border-color: #4517a6;
  background-color: #fff;
}

.input::placeholder {
  color: #4a5568;
}

.input.cc-long {
  height: auto;
  min-height: 150px;
  line-height: 24px;
}

.input.med {
  max-width: 250px;
}

.input.small {
  max-width: 120px;
}

.input.error {
  border: 2px solid #ff922b;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f4f22fef2d3_Group.svg");
  background-position: 98% 4px;
  background-size: 24px;
  background-repeat: no-repeat;
}

.input.error:focus {
  border-color: #4517a6;
}

.input.long {
  max-width: 500px;
}

.input.textarea {
  height: 100px;
  max-width: 400px;
}

.input.textarea.tall {
  height: 200px;
}

.input.textarea.large {
  height: 120px;
}

.input.textarea.fill {
  max-width: 100%;
}

.input.select {
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg"),
    linear-gradient(180deg, #e2e8f0, #e2e8f0);
  background-position: 98% 50%, 0px 0px;
  background-size: 16px, auto;
  background-repeat: no-repeat, repeat;
}

.input.select.large {
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg"),
    linear-gradient(180deg, null, null);
  background-size: 24px, auto;
}

.input.select.large.dark-bg {
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5d5564b2f5538359c0dad965_5b3e1bdab90c1f77ebfef2d7_Group%202.svg"),
    linear-gradient(180deg, transparent, transparent),
    linear-gradient(180deg, #2d3748, #2d3748);
  background-position: 98% 50%, 0px 0px, 0px 0px;
  background-size: 24px, auto, auto;
  background-repeat: no-repeat, repeat, repeat;
}

.input.large {
  height: 52px;
  flex: 0 1 auto;
  font-size: 16px;
}

.input.large.date-picker {
  background-position: 98% 50%;
  background-size: 24px;
}

.input.large.dark-bg {
  background-color: #2d3748;
  color: #fff;
}

.input.grouped {
  margin-right: 4px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.input.date-picker {
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b617afc6d61a0044b9da687_calendar.svg");
  background-position: 99% 50%;
  background-size: 16px;
  background-repeat: no-repeat;
}

.input.disabled {
  opacity: 0.4;
}

.input.disabled.large {
  cursor: not-allowed;
}

.input.in-search {
  height: auto;
  padding-top: 12px;
  background-color: transparent;
  font-size: 12px;
}

.input.in-search:focus {
  border-style: none;
}

.survey {
  background-color: #fff !important;
  border: solid 1px #cbd5e0;
}

.survey-search:hover {
  border-color: #fff;
  background-color: #fff;
  border-radius: 7px;
}

.survey-search:focus {
  border-color: #fff;
  background-color: #fff;
  border-radius: 7px;
}

.form-success {
  background-color: #1cec88;
  color: #1cec88;
}

.success-message {
  border-radius: 4px;
  background-color: rgba(32, 206, 123, 0.1);
  color: #20ce7b;
}

.error-message {
  border-radius: 4px;
  background-color: rgba(236, 56, 114, 0.1);
  color: #ec3872;
  text-align: center;
}

.call-out {
  padding: 8px;
  border-radius: 8px;
  background-color: #eeebf7;
}

.callout.move-down {
  margin-top: 8px;
}
.callout {
  display: flex;
  margin-top: 4px;
  margin-bottom: 4px;
  padding: 16px;
  align-items: center;
  border-radius: 4px;
  background-color: rgba(76, 110, 245, 0.2);
}

.card {
  margin-bottom: 16px;
  flex: 1 1;
  border-style: none;
  border-width: 1px;
  border-color: #cbd5e0;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 16px 64px 0 rgba(33, 37, 41, 0.1);
  transition: all 250ms ease;
  text-decoration: none;
}

.card.horizontal {
  display: flex;
  flex: 0 0 auto;
}

.card.horizontal.m-wrap {
  flex: 0 0 auto;
}

.card.horizontal.m-wrap.full-height {
  flex: 1 1;
}

.card.horizontal.m-wrap.expand {
  flex: 1 1;
}

.card.vertical {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
}

.card.active {
  cursor: pointer;
}

.card.active:hover {
  transform: translate(0px, -4px);
}

.card.dark {
  background-color: #1a202c;
}

.card.muted {
  background-color: #cbd5e0;
}

.card.muted.active {
  cursor: pointer;
}

.card.m-side-scroll.active {
  flex: 0 1 auto;
  cursor: pointer;
}

.card.m-side-scroll.active.flex {
  display: flex;
  height: 100%;
  flex-direction: column;
  flex: 0 0 auto;
}

.card.m-side-scroll.active.full {
  height: 100%;
}

.card.m-side-scroll.flex {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
}

.card.m-side-scroll.flex.full {
  height: 100%;
}

.card.m-side-scroll.spaced {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 0 0 auto;
}

.card-title {
  margin-top: 0px;
}

.card-paragraph {
  margin-bottom: 0px;
}

.row {
  display: flex;
  margin-right: -8px;
  margin-left: -8px;
  padding-right: 8px;
  padding-left: 8px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  flex: 0 0 auto;
  border-radius: 4px;
  background-color: transparent;
}

.row.right {
  justify-content: flex-end;
}

.row.spaced {
  justify-content: space-between;
}

.row.spaced.align-bottom {
  align-items: flex-end;
}

.row.spaced.baseline {
  align-items: baseline;
}

.row.in-card {
  margin-bottom: 0px;
}

.row.center {
  align-items: center;
}

.row.center.spaced.push-up {
  justify-content: space-between;
}

.row.center.no-padding.push-up.spaced.bottom {
  padding-right: 16px;
  padding-left: 16px;
}

.row.center.no-padding.push-up.spaced.bottom-fill {
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
}

.row.center.no-padding.push-up.spaced.bottom-fill.no-margin.push-up {
  margin-bottom: 16px;
}

.row.has-cards {
  margin-right: -16px;
  margin-left: -16px;
  align-items: stretch;
}

.row.has-cards.move-down.align-top {
  align-items: flex-start;
}

.row.has-cards.align-top {
  align-items: flex-start;
}

.row.has-cards._80 {
  width: 80%;
}

.row.has-cards._80.push-right {
  margin-left: -8px;
}

.row.has-cards.wrap {
  flex-wrap: wrap;
}

.row.has-cards.wrap.sticky {
  position: sticky;
  top: 32px;
}

.row.has-cards.wrap.stretch {
  align-items: stretch;
}

.row.stretch {
  align-items: stretch;
}

.row.baseline {
  align-items: baseline;
}

.row.expand {
  flex: 1 1;
}

.row.expand.align-end {
  justify-content: flex-end;
}

.row.no-margin {
  margin-right: 0px;
  margin-left: 0px;
}

.row.details {
  padding-bottom: 32px;
}

.row.push-down.full {
  width: 100%;
}

.row.align-right {
  justify-content: flex-end;
}

.card-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 50%;
}

.tab-pane {
  padding: 30px 40px 40px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.tab-link {
  margin-right: 10px;
  margin-left: 10px;
  padding-right: 5px;
  padding-left: 5px;
  background-color: transparent;
  color: #1a202c;
}

.tab-link:hover {
  color: #1a202c;
}

.tab-link.w--current {
  border-bottom: 2px solid #4517a6;
  background-color: transparent;
  box-shadow: inset 0 -1px 0 0 #2d3748;
  color: #320b85;
}

.tab-menu {
  display: flex;
  padding-right: 0px;
  padding-left: 0px;
  border-bottom: 1px solid #e2e8f0;
}

.tabs {
  border-radius: 4px;
}

.data {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  color: #1a202c;
  font-size: 20px;
  line-height: 120%;
  font-weight: 600;
}

.data.huge {
  font-size: 36px;
}

.data.huge.no-margin {
  margin-bottom: 0px;
}

.data.huge.violet {
  color: #5f3dc4;
}

.data.small {
  font-size: 16px;
  line-height: 140%;
}

.data.small.white-text {
  color: #fff;
}

.data.small.fill {
  max-width: 100%;
}

.data.large {
  font-size: 28px;
}

.data.tiny {
  font-size: 14px;
}

.data.positive {
  color: #2b8a3e;
}

.data.neutral {
  color: #e67700;
}

.data.negative {
  color: #c92a2a;
}

.data.brand-1 {
  color: #9775fa;
}

.data.brand-2 {
  height: auto;
  margin-top: 0px;
  margin-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  background-image: none;
  background-size: auto;
  background-repeat: repeat;
  color: #4dabf7;
}

.data.brand-3 {
  color: #38d9a9;
}

.data.white-text.large.primary {
  color: #4517a6;
}

.data.option-1 {
  color: #9775fa;
}

.data.micro {
  font-size: 12px;
}

.data.positive-2 {
  color: #364fc7;
}

.data.violet-text.muted {
  opacity: 0.6;
}

.bold-text {
  color: #1a202c;
}

.avatar {
  display: flex;
  width: 40px;
  height: 40px;
  padding-top: 2px;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  border-radius: 100%;
  background-color: rgba(69, 23, 166, 0.1);
  color: #320b85;
  font-size: 20px;
  line-height: 100%;
}

.avatar.large {
  width: 60px;
  height: 60px;
  font-size: 24px;
}

.avatar.huge {
  width: 100px;
  height: 100px;
  padding-top: 4px;
  font-size: 32px;
}

.avatar.with-picture {
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1fd400fef2dc_Screen%20Shot%202018-06-24%20at%208.24.20%20PM.png");
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
  color: transparent;
}

.avatar.with-picture.visa {
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b9cf129e60a716bbf6c755c_instantlogosearch-visa.png");
}

.avatar.with-picture.move-left.positive {
  box-shadow: 0 0 0 2px #4c6ef5;
}

.avatar.with-picture.move-left.negative {
  box-shadow: 0 0 0 2px #fa5252;
}

.avatar.with-picture.kemdi {
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da7abf73e54880be5d6cd81_download-21.png");
}

.avatar.small {
  width: 24px;
  height: 24px;
}

.avatar.small.twitter-logo {
  background-color: #cbd5e0;
  background-image: linear-gradient(
      180deg,
      rgba(222, 226, 230, 0.4),
      rgba(222, 226, 230, 0.4)
    ),
    url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b605f007803b544df4340b1_twitter.svg");
  background-position: 0px 0px, 50% 58%;
  background-size: auto, 16px;
  background-repeat: repeat, no-repeat;
  color: transparent;
}

.avatar.small.news-icon {
  background-color: #cbd5e0;
  background-image: linear-gradient(
      180deg,
      rgba(222, 226, 230, 0.4),
      rgba(222, 226, 230, 0.4)
    ),
    url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b6058e8d9b73f4d48b557b1_file-text.svg");
  background-position: 0px 0px, 50% 50%;
  background-size: auto, 16px;
  background-repeat: repeat, no-repeat;
  color: transparent;
}

.avatar.small.other-icon {
  background-color: #cbd5e0;
  background-image: linear-gradient(
      180deg,
      rgba(222, 226, 230, 0.4),
      rgba(222, 226, 230, 0.4)
    ),
    url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b6059a6bb5a83e0672518c4_globe.svg");
  background-position: 0px 0px, 50% 50%;
  background-size: auto, 18px;
  background-repeat: repeat, no-repeat;
  color: transparent;
}

.avatar.small.facebook-logo {
  background-color: #cbd5e0;
  background-image: linear-gradient(
      180deg,
      rgba(222, 226, 230, 0.4),
      rgba(222, 226, 230, 0.4)
    ),
    url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b605efe8b62147bc7f8294a_facebook%20(1).svg");
  background-position: 0px 0px, 50% 50%;
  background-size: auto, 16px;
  background-repeat: repeat, no-repeat;
  color: transparent;
}

.avatar.small.instagram-logo {
  background-color: #cbd5e0;
  background-image: linear-gradient(
      180deg,
      rgba(222, 226, 230, 0.4),
      rgba(222, 226, 230, 0.4)
    ),
    url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b605efe71d5d24664553498_instagram.svg");
  background-position: 0px 0px, 50% 50%;
  background-size: auto, 16px;
  background-repeat: repeat, no-repeat;
  color: transparent;
}

.avatar.alpha {
  background-color: #4c6ef5;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da7a2b8c8514314bfbb8aae_%CE%B1.svg");
  background-position: 0px 0px;
  background-size: contain;
}

.avatar img {
  border-radius: 50%;
}

.avatar img.positive {
  box-shadow: 0 0 0 2px #4c6ef5;
}

.avatar img.negative {
  box-shadow: 0 0 0 2px #fa5252;
}

.banner {
  display: flex;
  width: 100%;
  padding: 16px 32px;
  justify-content: center;
  background-color: #4517a6;
  background-image: linear-gradient(135deg, #4517a6, #7950f2);
  color: #fff;
  text-align: center;
}

.banner.error {
  background-color: #fa5252;
  background-image: none;
  color: #fff;
}

.banner.warning {
  background-color: #ff922b;
  background-image: none;
  color: #1a202c;
}

.banner.important {
  background-color: rgba(255, 146, 43, 0.2);
  background-image: none;
}

.badge {
  display: inline-block;
  padding: 3px 8px 2px;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  background-color: #cbd5e0;
  color: #1a202c;
  font-size: 14px;
  line-height: 100%;
  font-weight: 600;
}

.badge.bold {
  background-color: #4517a6;
  color: #fff;
}

.badge.white {
  background-color: #fff;
  color: #320b85;
}

.badge.important {
  background-color: #ff922b;
  color: #fff;
}

.badge.push-right {
  margin-left: 8px;
}

.badge.in-nav {
  margin-right: 16px;
}

.in-banner {
  margin-left: 16px;
  color: #fff;
}

.banner-action {
  margin-left: 16px;
}

.icon {
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  opacity: 0.6;
  transform: none;
}

.icon.push-left {
  margin-right: 8px;
}

.icon.move-left.orange {
  opacity: 1;
  color: #e67700;
}

.icon.push-right {
  margin-left: 8px;
}

.icon.green {
  opacity: 1;
  color: #40c057;
}

.icon.black {
  color: #1a202c;
}

.icon.white {
  color: #fff;
}

.icon.important {
  opacity: 1;
  color: #ff922b;
}

.icon.is-dropdown {
  border-radius: 24px;
  transition: background-color 250ms ease;
  cursor: pointer;
}

.icon.is-dropdown:hover {
  background-color: rgba(33, 37, 41, 0.2);
}

.icon.loading {
  display: inline-block;
}

.icon.close {
  display: block;
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 100px;
  transform: translate(0px, -4px);
  transition: background-color 250ms ease;
  cursor: pointer;
}

.icon.close:hover {
  background-color: hsla(0, 0%, 100%, 0.2);
}

.icon.small {
  width: 16px;
  height: 16px;
}

.icon.small.source-icon {
  width: 20px;
  height: 20px;
  padding: 2px;
  border-radius: 20px;
  background-color: #cbd5e0;
}

.icon.small.nudge-right.active {
  cursor: pointer;
}

.icon.nudge-right.purple {
  color: #4517a6;
}

.icon.source-icon {
  padding: 4px;
  border-radius: 4px;
  background-color: #cbd5e0;
  color: #1a202c;
}

.icon.source-icon.in-baseline-row {
  transform: translate(0px, 4px);
}

.icon.source-icon.in-baseline-row.move-left.negative {
  background-color: rgba(250, 82, 82, 0.2);
  color: #c92a2a;
}

.icon.source-icon.in-baseline-row.move-left.positive {
  background-color: rgba(76, 110, 245, 0.2);
  color: #364fc7;
}

.icon.primary.move-left.move-up {
  transform: translate(0px, -1px);
}

.icon.in-input {
  position: absolute;
  top: 0px;
  right: 0px;
  margin-top: 34px;
  margin-right: 8px;
}

.icon.danger {
  color: #c92a2a;
}

.icon.danger:hover {
  background-color: rgba(250, 82, 82, 0.2);
}

.icon.large {
  width: 52px;
  height: 52px;
  padding: 12px;
  border-radius: 50%;
  background-color: rgba(69, 23, 166, 0.22);
  color: #320b85;
}

.icon.large.move-down.green {
  background-color: rgba(64, 192, 87, 0.2);
  color: #2b8a3e;
}

.icon.large.green {
  background-color: rgba(64, 192, 87, 0.2);
  color: #2b8a3e;
}

.icon.large.positive {
  background-color: rgba(76, 110, 245, 0.2);
  color: #4c6ef5;
}

.icon.large.positive.move-left {
  opacity: 1;
}

.icon.large.neutral {
  background-color: #cbd5e0;
  color: #4a5568;
}

.icon.large.neutral.move-left {
  opacity: 1;
}

.icon.large.negative {
  background-color: rgba(250, 82, 82, 0.2);
  color: #fa5252;
}

.icon.large.negative.move-left {
  opacity: 1;
}

.icon.positive-2 {
  color: #364fc7;
}

.icon.purple {
  color: #4517a6;
}

.icon.purple.med {
  display: block;
  width: 20px;
  height: 20px;
}

.checkbox {
  margin-top: 0px;
  filter: hue-rotate(20deg);
}

.radio {
  filter: hue-rotate(66deg);
}

.dropdown-list {
  position: absolute;
  left: 0px;
  top: 110%;
  z-index: 900;
  display: none;
  overflow: scroll;
  width: 160px;
  max-height: 90vh;
  padding: 8px;
  flex-direction: column;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 16px 32px 0 rgba(33, 37, 41, 0.2);
}

.dropdown-list.w--open {
  top: 100%;
  right: 0px;
  display: block;
  overflow: scroll;
  max-height: 80vh;
  padding: 8px;
  background-color: #fff;
  box-shadow: 0 16px 32px 0 rgba(52, 58, 64, 0.1);
}

.dropdown-list.align-top {
  top: auto;
  bottom: 110%;
}

.dropdown-list.align-right {
  left: auto;
  right: 0px;
  display: none;
}

.dropdown-list.align-right.w--open {
  top: 100%;
  right: 0px;
}

.dropdown-list.dropdown-right {
  left: auto;
  right: 0px;
}

.dropdown-list.dropdown-right.small {
  display: none;
  width: 120px;
}

.dropdown-list.dropdown-right.small.anchor-left {
  left: 0%;
  top: auto;
  right: auto;
  bottom: 100%;
  width: auto;
  white-space: nowrap;
  overflow: visible;
}

.dropdown-list.small {
  width: 80px;
}

.dropdown-list.medium {
  display: none;
  width: 260px;
}

.dropdown-list.temp {
  display: flex;
}

.dropdown-link {
  margin-bottom: 0px;
  padding: 8px;
  border-radius: 4px;
  transition: all 250ms ease;
  color: #320b85;
  font-size: 14px;
  font-weight: 600;
}

.dropdown-link:hover {
  background-color: rgba(69, 23, 166, 0.1);
}

.dropdown-link.w--current {
  background-color: rgba(69, 23, 166, 0.1);
  color: #320b85;
}

.dropdown-link.active {
  background-color: rgba(69, 23, 166, 0.1);
}

.has-group {
  display: flex;
  justify-content: flex-start;
}

.dropdown {
  position: relative;
  display: inline-block;
  margin-right: 0px;
  margin-left: 0px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.dropdown.more-action {
  position: absolute;
  top: 50%;
  right: 0px;
  z-index: 0;
  margin-top: -12px;
}

.dropdown.push-left {
  margin-right: 8px;
}

.dropdown.user-actions {
  position: relative;
  display: flex;
  align-items: center;
}

.dropdown.move-left.table-action {
  position: absolute;
  top: 50%;
  right: 0px;
  height: 32px;
  margin-top: -16px;
  margin-right: 0px;
}

.dropdown.table-action {
  position: absolute;
  top: 50%;
  right: 0px;
  margin-top: -8px;
}

.dropdown.table-action.anchor-top {
  top: 20px;
}

.toast {
  position: relative;
  display: flex;
  overflow: hidden;
  max-width: 360px;
  margin-bottom: 8px;
  padding: 16px;
  align-items: flex-start;
  flex: 1 1;
  border-style: none;
  border-width: 1px;
  border-color: #cbd5e0;
  border-radius: 4px;
  background-color: #1a202c;
  box-shadow: 0 32px 32px -8px rgba(52, 58, 64, 0.1),
    0 0 64px 0 rgba(33, 37, 41, 0.1);
  color: #f7fafc;
}

.toast.warning {
  border-color: #ff922b;
  background-color: #ff922b;
  box-shadow: 0 32px 32px -8px rgba(52, 58, 64, 0.1),
    0 0 64px 0 rgba(33, 37, 41, 0.1);
  color: #1a202c;
}

.toast.warning.dropdown {
  max-width: 100%;
}

.toast.danger {
  border-color: #fa5252;
  background-color: #fa5252;
  box-shadow: 0 32px 32px -8px rgba(52, 58, 64, 0.1),
    0 0 64px 0 rgba(33, 37, 41, 0.1);
  color: #fff;
}

.toast.with-dropdown-content {
  max-width: 100%;
}

.message-content {
  overflow: hidden;
  margin-left: 16px;
  padding-top: 4px;
  padding-right: 16px;
}

.bold {
  color: #1a202c;
  font-weight: 600;
}

.push-down {
  margin-top: 16px;
}

.push-down.button.primary.facebook {
  border-color: #4f69a8;
  background-color: #4f69a8;
  box-shadow: none;
}

.push-down.button.primary.large.facebook {
  border-color: #3b5998;
  background-color: #3b5998;
}

.push-down._50-width {
  width: 50%;
  max-width: 50%;
}

.push-down._50-width.pad {
  padding-left: 8px;
}

.dropdown-content {
  overflow: hidden;
  margin-left: 16px;
  padding-top: 4px;
  padding-right: 16px;
  flex: 1 1;
}

.floating-header {
  position: fixed;
  top: 0px;
  right: 0px;
  padding-top: 0px;
  padding-right: 16px;
}

.dropdown-header {
  margin-top: 16px;
  padding-left: 8px;
  color: #4a5568;
  font-size: 14px;
}

.dropdown-trigger {
  height: 24px;
  flex: 0 0 auto;
  border-radius: 24px;
  transition: background-color 250ms ease;
  cursor: pointer;
}

.dropdown-trigger:hover {
  background-color: hsla(0, 0%, 100%, 0.2);
}

.toast-container {
  position: fixed;
  left: 80px;
  bottom: 0px;
  z-index: 900;
  display: none;
  width: 420px;
  padding-bottom: 16px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
}

.toasty {
  display: flex;
  padding: 16px;
  align-items: flex-start;
  flex: 1 1;
}

.toast-wrapper {
  position: relative;
  display: flex;
  overflow: hidden;
  width: 100%;
  max-width: 360px;
  margin-right: 8px;
  margin-bottom: 0px;
  margin-left: 8px;
  align-items: flex-start;
  border-style: none;
  border-width: 1px;
  border-color: #cbd5e0;
  border-radius: 4px;
  background-color: transparent;
  box-shadow: 0 32px 32px -8px rgba(52, 58, 64, 0.1),
    0 0 64px 0 rgba(33, 37, 41, 0.1);
}

.toast-wrapper.warning {
  border-color: #ff922b;
  background-color: #ff922b;
  box-shadow: 0 32px 32px -8px rgba(255, 146, 43, 0.2);
  color: #1a202c;
}

.toast-wrapper.warning.dropdown {
  max-width: 100%;
}

.toast-wrapper.danger {
  border-color: #fa5252;
  background-color: #fa5252;
  box-shadow: 0 32px 32px -8px rgba(250, 82, 82, 0.2);
  color: #fff;
}

.toast-wrapper.with-dropdown-content {
  max-width: 100%;
}

.toast-wrapper.dropdown-wrapper {
  max-width: 100%;
}

.inline-message {
  position: relative;
  display: inline-block;
}

.inline-message-content {
  position: absolute;
  left: 0px;
  top: 100%;
  z-index: 10;
  display: none;
  overflow: hidden;
  width: 300px;
  flex-direction: column;
  border-style: solid;
  border-width: 1px;
  border-color: #cbd5e0;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 16px 32px -8px rgba(33, 37, 41, 0.2);
  font-size: 14px;
}

.inline-message-content.sentiment-message {
  left: 50%;
  top: 120%;
  display: flex;
  width: auto;
  margin-left: -70px;
}

.inline-message-content.small {
  width: auto;
}

.inline-message-content.top-right {
  left: 100%;
  top: 0%;
}

.inline-message-content.top-right.small {
  left: 103%;
}

.inline-message-content.anchor-right {
  left: auto;
  right: 0px;
}

.inline-message-content.anchor-right.temp {
  display: block;
}

.inline-message-content.temp {
  display: block;
}

.inline-message-trigger {
  display: flex;
  align-items: center;
}

.inline-message-trigger.small-text {
  font-size: 14px;
}

.chip {
  display: inline-block;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: #edf2f7;
  color: #4a5568;
  font-size: 10px;
  line-height: 100%;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.chip.bold {
  background-color: #4517a6;
  color: #fff;
}

.chip.bold.push-up.grey {
  background-color: #4a5568;
}

.chip.bold.push-up.blue {
  background-color: #4c6ef5;
  color: #fff;
}

.chip.bold.push-up.pink {
  background-color: #e64980;
  color: #fff;
}

.chip.white {
  background-color: #fff;
  color: #320b85;
}

.chip.important {
  background-color: rgba(255, 146, 43, 0.2);
  color: #f76707;
}

.chip.push-right {
  margin-left: 8px;
}

.chip.primary {
  margin-bottom: 4px;
  background-color: rgba(69, 23, 166, 0.1);
  color: #320b85;
}

.chip.warning {
  background-color: rgba(255, 146, 43, 0.2);
  color: #f76707;
}

.chip.pink {
  background-color: #fff0f6;
  color: #a61e4d;
}

.chip.blue {
  background-color: #edf2ff;
  color: #364fc7;
}

.chip.red {
  background-color: rgba(250, 82, 82, 0.2);
  color: #c92a2a;
}

.modal {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 20;
  display: none;
  overflow: auto;
  padding-top: 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(33, 37, 41, 0.8);
  color: #fff;
}

.modal.darker {
  display: none;
  background-color: rgba(33, 37, 41, 0.95);
  color: #718096;
}

.modal.dev {
  display: flex;
}

.modal.temp {
  display: flex;
}

.modal-card {
  position: relative;
  overflow: scroll;
  width: 100%;
  max-height: 90vh;
  border-radius: 4px;
  background-color: #fff;
  color: #2d3748;
}

.modal-header {
  display: flex;
  padding: 16px 32px 8px;
  align-items: baseline;
}

.modal-container {
  display: flex;
  width: 100%;
  max-width: 600px;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-start;
}

.modal-container.is-large {
  max-width: 800px;
}

.modal-container.is-huge {
  max-width: 940px;
}

.modal-container.is-small {
  max-width: 400px;
}

.modal-container.padded-bottom {
  overflow: auto;
}

.meta {
  display: inline-block;
  color: #718096;
  font-size: 14px;
  line-height: 120%;
}

.meta.push-right {
  margin-left: 8px;
}

.meta.push-left {
  margin-right: 8px;
}

.s-border {
  height: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  /* background-color: #40c057; */
}

.s-border.positive {
  background-color: #364fc7;
}

.s-border.negative {
  background-color: #c92a2a;
}

.s-border.neutral {
  background-color: #718096;
}

.modal-body {
  padding: 8px 32px 32px;
}

.paragraph {
  margin-top: 8px;
}

.modal-footer {
  display: flex;
  padding: 8px 32px 16px;
  justify-content: flex-start;
  align-items: baseline;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #edf2f7;
}

.modal-footer.center {
  align-items: center;
}

.modal-footer.spaced {
  justify-content: space-between;
}

.progress-tracker {
  overflow: hidden;
  width: 100%;
  height: 8px;
  max-width: 960px;
  border-radius: 4px;
  background-color: #cbd5e0;
}

.progress-tracker.black {
  background-color: #1a202c;
}

.progress-bar {
  width: 1%;
  height: 100%;
  border-radius: 4px;
  background-color: #4517a6;
}

.table.full {
  width: 100%;
}

.table-header {
  display: flex;
  align-items: baseline;
  border-bottom: 1px solid #cbd5e0;
}

.table-header-cell {
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 8px;
  flex: 1 1;
  border-bottom: 1px none #cbd5e0;
  color: #4a5568;
  line-height: 100%;
}

.table-header-cell._60 {
  width: 60%;
  flex: 0 0 auto;
}

.table-header-cell._40 {
  width: 40%;
  flex: 0 0 auto;
}

.table-header-cell._30 {
  width: 30%;
  flex: 0 0 auto;
}

.table-header-cell._20 {
  width: 20%;
  flex: 0 0 auto;
}

.table-header-cell._10 {
  width: 10%;
  flex: 0 0 auto;
}

.table-header-cell.small {
  padding-bottom: 4px;
  font-size: 12px;
}

.table-body {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.table-body.full {
  width: 100%;
}

.table-row {
  position: relative;
  display: flex;
  padding-top: 8px;
  padding-bottom: 8px;
  align-items: baseline;
  border-radius: 4px;
  transition: all 250ms ease;
}

.table-row:hover {
  background-color: #e2e8f0;
}

.table-row.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.table-row.comfy {
  padding-top: 16px;
  padding-bottom: 16px;
}

.table-row.news {
  flex: 0 0 auto;
}

.table-row.news:hover {
  background-color: #e2e8f0;
}

.table-row.news.dark-row {
  background-color: #f7fafc;
}

.table-row.news.dark-row:hover {
  background-color: #e2e8f0;
}

.table-row.ad {
  cursor: pointer;
}

.table-row.dark-row {
  background-color: #f7fafc;
}

.table-row.active {
  cursor: pointer;
}

.table-row.audience {
  cursor: pointer;
}

.table-body-cell {
  display: flex;
  padding-right: 16px;
  padding-left: 8px;
  align-items: center;
  flex: 1 1;
  color: #4a5568;
  text-align: left;
}

.table-body-cell.main {
  color: #2d3748;
}

.table-body-cell.main._20 {
  width: 20%;
  flex: 0 0 auto;
}

.table-body-cell.action {
  display: block;
  justify-content: flex-end;
  align-items: baseline;
}

.table-body-cell.right-align {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body-cell._40 {
  width: 40%;
  flex: 0 0 auto;
}

.table-body-cell.vertical {
  flex-direction: column;
}

.table-body-cell.shrink {
  flex: 0 1 auto;
}

.table-body-cell._50 {
  width: 50%;
  flex: 0 0 auto;
}

.table-body-cell._30 {
  width: 30%;
  flex: 0 1 auto;
}

.table-body-cell._20 {
  width: 20%;
  flex: 0 0 auto;
}

.table-body-cell._10 {
  width: 10%;
  flex: 0 0 auto;
}

.num {
  display: flex;
  width: 32px;
  height: 32px;
  margin-right: 4px;
  padding-top: 4px;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  border-radius: 100px;
  background-color: #edf2f7;
  font-size: 20px;
  text-align: center;
}

.num.positive {
  background-color: rgba(64, 192, 87, 0.2);
  color: #2b8a3e;
}

.num.neutral {
  background-color: rgba(250, 176, 5, 0.2);
  color: #e67700;
}

.num.negative {
  background-color: rgba(250, 82, 82, 0.2);
  color: #c92a2a;
}

.filters {
  display: flex;
  margin-bottom: 16px;
  padding-right: 8px;
  padding-left: 8px;
  align-items: baseline;
}

.filters.no-bottom-margin {
  margin-bottom: 0px;
}

.filter {
  margin-left: 8px;
}

.nav {
  display: flex;
  width: 100%;
  max-width: 1180px;
  justify-content: space-between;
  border-bottom: 1px solid #cbd5e0;
}

.nav-link {
  margin-right: 16px;
  margin-bottom: -1px;
  margin-left: 16px;
  padding: 16px 0px;
  background-color: transparent;
  transition: color 250ms ease;
  color: #4a5568;
  font-size: 20px;
  line-height: 100%;
}

.nav-link:hover {
  color: #320b85;
}

.nav-link.w--current {
  border-bottom: 2px solid #4517a6;
  background-color: transparent;
  color: #320b85;
}

.nav-link.with-badge {
  margin-right: 4px;
}

.nav-link.small {
  padding-top: 16px;
  padding-bottom: 8px;
  font-size: 14px;
}

.nav-link.small.w--current {
  color: #2d3748;
  font-size: 14px;
}

.nav-link.tiny {
  display: flex;
  margin-right: 8px;
  margin-left: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 12px;
}

.tabs-content-2 {
  overflow: visible;
  padding: 16px;
}

.tabs-content-2.small-padding {
  padding: 8px;
}

.tag {
  display: inline-block;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: #edf2f7;
  color: #2d3748;
  font-size: 12px;
  line-height: 100%;
  font-weight: 400;
}

.tag.bold {
  background-color: #4517a6;
  color: #fff;
}

.tag.white {
  background-color: #fff;
  color: #320b85;
}

.tag.important {
  background-color: #ff922b;
  color: #fff;
}

.tag.push-right {
  margin-left: 8px;
}

.tag.removable {
  padding-right: 20px;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f00e6fef2d5_x-circle.svg");
  background-position: 96% 50%;
  background-size: 8px;
  background-repeat: no-repeat;
  cursor: pointer;
}

.tag.primary {
  background-color: rgba(69, 23, 166, 0.22);
  color: #320b85;
}

.tag.big {
  padding-top: 6px;
  padding-bottom: 4px;
  font-size: 16px;
}

.tag.big.positive {
  background-color: rgba(64, 192, 87, 0.2);
}

.tag.big.option {
  background-color: rgba(230, 73, 128, 0.1);
  color: #e64980;
}

.tag.big.option._2 {
  background-color: rgba(130, 201, 30, 0.1);
  color: #82c91e;
}

.tag.big.option._3 {
  background-color: rgba(77, 171, 247, 0.1);
  color: #4dabf7;
}

.tag.big.option._4 {
  background-color: rgba(151, 117, 250, 0.1);
  color: #9775fa;
}

.tag.big.negative {
  background-color: rgba(250, 82, 82, 0.2);
}

.tag.short {
  padding-top: 6px;
  padding-bottom: 4px;
  font-size: 16px;
}

.tag.short.positive {
  background-color: rgba(64, 192, 87, 0.2);
}

.tag.short.option {
  padding-top: 3px;
  padding-bottom: 2px;
  background-color: rgba(230, 73, 128, 0.1);
  color: #e64980;
  font-size: 12px;
}

.tag.short.option._2 {
  background-color: rgba(130, 201, 30, 0.1);
  color: #82c91e;
}

.tag.short.option._3 {
  background-color: rgba(77, 171, 247, 0.1);
  color: #4dabf7;
}

.tag.short.option._4 {
  background-color: rgba(151, 117, 250, 0.1);
  color: #9775fa;
}

.tag.short.negative {
  background-color: rgba(250, 82, 82, 0.2);
}

.tag.positive {
  background-color: rgba(76, 110, 245, 0.2);
  color: #364fc7;
}

.tag.negative {
  background-color: rgba(250, 82, 82, 0.2);
}

.tag.purple {
  background-color: rgba(69, 23, 166, 0.1);
  color: #320b85;
}

.tag.violet {
  background-color: rgba(121, 80, 242, 0.1);
  color: #5f3dc4;
}

.tag.small {
  padding: 2px 4px;
  font-size: 12px;
}

.tag.small.purple {
  background-color: rgba(192, 79, 225, 0.1);
  color: #8d0db3;
}

.tag.nudge-right.small.blue {
  background-color: rgba(77, 171, 247, 0.1);
  color: #1864ab;
}

.tag.nudge-right.small.teal {
  background-color: rgba(56, 217, 169, 0.1);
  color: #087f5b;
}

.tag.nudge-right.small.yellow {
  background-color: rgba(252, 196, 25, 0.1);
  color: #e67700;
}

.thumb {
  position: relative;
  width: 100%;
  padding-bottom: 80%;
  border-radius: 8px;
  background-image: url(https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5f99d01d7eaf1e75233f23f9_Screenshot%202020-10-28%20at%208.57.52%20PM.png);
  background-position: 50% 50%;
  background-size: cover;
  cursor: pointer;
}

.thumb.audio {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5f99db7827b2c580277d20dc_audio.png);
}

.thumb.vid {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5f99d6a85b2bb119dd7642fb_Screenshot%202020-10-28%20at%209.37.14%20PM.png);
}

.text-block {
  position: absolute;
  right: 4px;
  bottom: 4px;
  padding-right: 8px;
  padding-left: 8px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1), 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  font-size: 12px;
}

.heading {
  font-weight: 600;
}

.helper {
  display: block;
  margin-top: 4px;
  margin-bottom: 16px;
  color: #4a5568;
  font-size: 14px;
  line-height: 120%;
  font-weight: 400;
  text-align: left;
}

.helper.error {
  color: #f76707;
}

.field-label {
  margin-top: 16px;
}

.field-label.white-text.large {
  font-size: 24px;
}

.field-label.large {
  color: #2d3748;
  font-size: 24px;
}

.control {
  position: relative;
  margin-bottom: 16px;
}

.column {
  display: flex;
  padding-right: 8px;
  padding-left: 8px;
  flex-direction: column;
  flex: 1 1;
}

.column._50 {
  width: 50%;
  flex: 0 1 auto;
}

.column._40 {
  width: 40%;
  flex: 0 0 auto;
}

.column.shrink {
  flex: 0 1 auto;
}

.column._30 {
  width: 30%;
  flex: 0 1 auto;
}

.column._33 {
  width: 33.333333333333336%;
  padding-top: 8px;
  padding-bottom: 8px;
  flex: 0 0 auto;
}

.column._20 {
  width: 20%;
  flex: 0 1 auto;
}

.column.relative {
  position: relative;
}

.column.third-width {
  width: 33.333333333333336%;
  flex: 0 0 auto;
}

.column.third-width.question {
  margin-top: 8px;
  margin-bottom: 8px;
}

.column.padded-right {
  padding-right: 32px;
}

.column.padded-right.no-padding-left {
  position: relative;
  padding-left: 0px;
}

.column.padded-left {
  padding-left: 32px;
}

.column.padded-left.rel {
  position: relative;
}

.column._25 {
  width: 25%;
  flex: 0 0 auto;
}

.column.align-right {
  align-items: flex-end;
}

.column.rel {
  position: relative;
}

.example-bg {
  display: flex;
  margin-top: 32px;
  margin-right: -8px;
  margin-left: -8px;
  padding: 32px 0px;
  flex-direction: column;
  flex-wrap: wrap;
  border-radius: 4px;
  background-color: #f7fafc;
}

.card-section {
  padding: 16px;
  flex: 0 1 auto;
}

.card-section.left-up:before {
  padding: 16px;
  left: -40px;
  top: 0;
}

.card-section.w--current {
  background-color: transparent;
}

.card-section.horizontal {
  display: inline-block;
  border-right: 1px solid #e2e8f0;
}

.card-section.horizontal.end {
  border-right-style: none;
}

.card-section.vertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid #cbd5e0;
}

.card-section.vertical.has-bottom-border.dark-border {
  border-bottom-color: #cdd3da;
}

.card-section.center {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.card-section.grey {
  background-color: #f7fafc;
}

.card-section.flex-row {
  display: flex;
}

.card-section.flex-row.align-center {
  align-items: center;
}

.card-section._8-padding {
  min-width: 120px;
  padding: 8px;
}

.card-section._8-padding.no-top-padding {
  padding-top: 0px;
}

.card-section.fill {
  flex: 1 1;
}

.card-section.expand.horizontal.detail-trigger {
  background-color: #fff;
}

.card-section.expand.horizontal.detail-trigger.w--current {
  border-bottom: 2px solid #4517a6;
}

.card-section.expand.detail-trigger.w--current {
  border-bottom: 2px solid #4517a6;
}

.card-section.expand.has-top-border {
  flex: 1 1;
}

.card-section.detail-trigger {
  transition: background-color 250ms ease;
  cursor: pointer;
}

.card-section.detail-trigger:hover {
  background-color: #f7fafc;
}

.card-section.detail-trigger.expand {
  background-color: #fff;
}

.card-section.empty {
  display: flex;
  height: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card-section.has-top-border {
  flex: 0 0 auto;
}

.card-section.align-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.card-section.padded {
  padding: 32px;
}

.card-section.padded-x {
  padding-right: 32px;
  padding-left: 32px;
}

.measure-bar {
  display: flex;
  width: 100%;
  height: 16px;
  min-width: 100px;
  margin-top: 0px;
}

.measure-bar.push-right {
  position: relative;
  margin-left: 8px;
}

.measure-bar.push-right.super-long {
  overflow: hidden;
  width: 460px;
  border-radius: 4px;
}

.measure-bar.push-right.no-margin {
  width: auto;
  margin-left: 0px;
}

.measure-bar.push-down {
  margin-top: 8px;
}

.measure-bar.short {
  height: 8px;
  border-radius: 4px;
  background-color: #edf2f7;
}

.measure-bar.short.push-right {
  position: relative;
}

.measure-bar.short.push-right.medium {
  overflow: hidden;
  width: 184px;
  border-radius: 4px;
}

.measure-bar.short.push-right.super-long {
  max-width: 400px;
}

.measure-bar.medium {
  width: 128px;
  min-width: 120px;
}

.measure-bar.tall {
  height: 24px;
}

.measure-bar.tall.push-right.medium {
  width: 184px;
}

.measure-bar.tall.push-right.med-long {
  width: 160px;
}

.measure-bar.tall.push-right.long {
  width: 100%;
  max-width: 260px;
}

.measure-bar.tall.cover {
  position: static;
  height: 8px;
  margin-bottom: 4px;
  border-radius: 4px;
  background-color: #edf2f7;
}

.measure-bar.tall.cover:hover {
  filter: brightness(97%);
}

.measure-bar.tall.cover.dark-bg {
  background-color: #edf2f7;
}

.measure-bar.scout-picker {
  height: 40px;
  border-style: solid;
  border-width: 1px;
  border-color: #cbd5e0;
  border-radius: 4px;
  background-color: #edf2f7;
}

.measure-bar.empty {
  background-color: #cbd5e0;
}

.measure-bar.empty.push-down {
  border-radius: 4px;
}

.measure-bar.dark-bg {
  background-color: #edf2f7;
}

.measure-bar.dark-bg.tiny {
  height: 8px;
  background-color: #cbd5e0;
}

.sentiment {
  height: 100%;
}

.sentiment.positive {
  width: 40%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #40c057;
}

.sentiment.positive._70 {
  width: 80%;
}

.sentiment.positive._20 {
  width: 20%;
}

.sentiment.positive._60 {
  width: 60%;
}

.sentiment.neutral {
  width: 20%;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  background-color: #fcc419;
}

.sentiment.neutral.single {
  border-radius: 4px;
}

.sentiment.negative {
  width: 40%;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #fa5252;
}

.sentiment.negative._60 {
  width: 60%;
}

.sentiment.negative.single {
  border-radius: 4px;
}

.sentiment.negative.single.test-data {
  width: 30%;
}

.sentiment.option-1 {
  width: 40%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #9775fa;
}

.sentiment.option-2 {
  width: 30%;
  background-color: rgba(151, 117, 250, 0.8);
}

.sentiment.option-3 {
  width: 25%;
  background-color: rgba(151, 117, 250, 0.6);
}

.sentiment.option-4 {
  width: 5%;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: rgba(151, 117, 250, 0.4);
}

.sentiment.option-4._60 {
  width: 60%;
}

.sentiment.positive-2 {
  width: 40%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #4c6ef5;
}

.sentiment.positive-2._70 {
  width: 80%;
}

.sentiment.positive-2._20 {
  width: 20%;
}

.sentiment.positive-2._60 {
  width: 60%;
}

.sentiment.positive-2.single {
  border-radius: 4px;
}

.sentiment.positive-2.single.test-data {
  width: 60%;
}

.sentiment.neutral-2 {
  width: 20%;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  background-color: #a0aec0;
}

.sentiment.neutral-2.single {
  border-radius: 4px;
}

.sentiment.neutral-2.single.test-data {
  width: 10%;
}

.measure-bar-legend {
  display: flex;
  width: 100%;
  padding-top: 4px;
  justify-content: space-between;
}

.bar-container {
  display: flex;
  overflow: hidden;
  align-items: center;
  flex: 0 1 auto;
  border-radius: 4px;
  transition: all 250ms ease;
}

.bar-container:hover {
  box-shadow: none;
}

.bar-container.move-down.justify-content {
  position: relative;
  overflow: visible;
  width: 100%;
  justify-content: space-between;
}

.bar-container.justify-content {
  justify-content: space-between;
}

.bar-container.justify-content.small {
  position: relative;
  overflow: visible;
}

.bar-container.justify-content.small.move-down {
  overflow: visible;
}

.bar-container.justify-content.small.move-down.stretch {
  overflow: visible;
  flex-direction: column;
  align-items: stretch;
}

.bar-container.has-cover {
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.bar-container.has-cover.move-down {
  overflow: visible;
}

.bar-container.has-cover.move-down.overflow-show {
  overflow: visible;
}

.bar-container.has-cover.nudge-down.static {
  position: relative;
  overflow: visible;
}

.bar-container.has-cover.nudge-down.selected {
  box-shadow: 0 0 0 2px rgba(121, 80, 242, 0.1);
}

.bar-container.vertical {
  min-width: 300px;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: none;
}

.sign-up {
  display: flex;
  min-height: 100vh;
  padding: 64px 16px 140px;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  background-image: none;
  background-position: 0px 0px;
  background-size: auto;
  background-repeat: repeat;
  text-align: center;
}

.logo.margin-bottom-spaced {
  margin-bottom: 32px;
}

.positive {
  color: #364fc7;
}

.bottom-breather {
  margin-bottom: 32px;
}

.bottom-breather.big-breath {
  margin-bottom: 64px;
}

.form-block {
  width: 100%;
  max-width: 400px;
  margin-bottom: 0px;
  text-align: left;
}

.form-block.push-down.full {
  max-width: 100%;
}

.progress-container {
  width: 100%;
  max-width: 960px;
}

.primary {
  color: #320b85;
}

.primary.brighter {
  color: #4517a6;
}

.primary.lighter {
  color: #4517a6;
}

.with-icon {
  display: flex;
  align-items: center;
  line-height: 100%;
  cursor: pointer;
}

.with-icon.throw-up.fill.align-right {
  justify-content: flex-end;
}

.with-icon.muted.active {
  cursor: pointer;
}

.top-breather {
  margin-top: 32px;
}

.important {
  color: #f76707;
}

.push-right {
  margin-left: 16px;
}

.push-freeform-right {
  margin-left: 90px;
}

.push-right.light {
  opacity: 0.6;
}

.main {
  display: block;
  color: #2d3748;
}

.toggle {
  width: 32px;
  height: 16px;
  padding: 2px;
  border-radius: 16px;
  background-color: #cbd5e0;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f00e6fef2d5_x-circle.svg"),
    url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e4960cec9e35624ce18e0_Shape.png");
  background-position: 81% 50%, 5px 50%;
  background-size: 6px, 8px;
  background-repeat: no-repeat, no-repeat;
  cursor: pointer;
}

.toggle.big {
  width: 40px;
  height: 20px;
  background-size: 8px, 8px;
}

.toggle.big.on {
  background-size: 8px, 10px;
}

.toggle.on {
  background-color: #4517a6;
}

.row-2 {
  margin-top: 20px;
}

.toggle-switch {
  width: 12px;
  height: 12px;
  border-radius: 10px;
  background-color: #718096;
}

.toggle-switch.big {
  width: 16px;
  height: 16px;
}

.toggle-switch.big.on {
  transform: translate(20px, 0px);
}

.toggle-switch.on {
  background-color: #fff;
  transform: translate(16px, 0px);
}

.checkbox-field {
  text-align: left;
}

.nav-container {
  position: fixed;
  z-index: 10;
  display: flex;
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f7fafc;
}

.nav-section {
  display: flex;
  align-items: center;
}

.brand {
  width: 100px;
  height: 100%;
  max-height: 52px;
  margin-right: 64px;
  padding-top: 4px;
  padding-bottom: 4px;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da78d3fac4d6deacd4589d5_Group.png");
  background-position: 50% 40%;
  background-size: contain;
  background-repeat: no-repeat;
}

.brand.scouts {
  width: 169px;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b589b37929c5a3a8dce7a0e_Group%2012.png");
}

.move-right {
  margin-left: 8px;
}

.move-right.display-name {
  font-weight: 600;
}

.move-right.display-name.has-object {
  display: flex;
  align-items: center;
}

.move-right.vertical.align-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.move-right.vertical.align-left.sticky {
  position: sticky;
  top: 64px;
}

.move-right.move-left.meta {
  color: #a0aec0;
}

.move-left {
  margin-right: 8px;
}

.move-left.meta {
  color: #a0aec0;
}

.move-left.meta.push-left {
  margin-right: 16px;
}

.move-down {
  margin-top: 8px;
}

.move-up {
  margin-bottom: 8px;
}

.push-up {
  margin-bottom: 16px;
}

.push-up.top-breather {
  margin-top: 64px;
}

.nudge-right {
  margin-left: 4px;
}

.nudge-left {
  margin-right: 4px;
}

.input.nudge-left {
  /* margin-right: 4px; */
  flex-direction: column;
  justify-content: center;
  display: flex;
}

.nudge-left-15 {
  margin-right: 48px;
}

.button.with-object.tag.location {
  height: auto;
  padding: 8px 16px;
  margin-top: 8px;
}

.icon-3 {
  color: #718096;
}

.dropdown-list-input.w--open {
  background-color: #fff;
  max-height: 80vh;
  padding: 15px;
  display: inline;
  top: 100%;
  right: 0;
  overflow: scroll;
  box-shadow: 0 16px 32px #343a401a;
}

.nudge-up {
  margin-bottom: 4px;
}

.nudge-down {
  margin-top: 4px;
}

.section {
  display: flex;
  padding: 54px 16px 64px;
  flex-direction: column;
  align-items: center;
}

.content {
  display: block;
  width: 100%;
  max-width: 1180px;
  margin-top: 32px;
  flex-direction: column;
  align-items: stretch;
}

.content.small {
  max-width: 760px;
  padding-right: 32px;
  padding-left: 32px;
}

.content.medium {
  max-width: 960px;
}

.content.medium {
  max-width: 940px;
}

.content.tiny {
  max-width: 480px;
}

.content.align-center {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.content.half-screen {
  height: 50vh;
}

.content.half-screen.flex-center {
  display: flex;
  height: 50vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.content.full {
  max-width: 100%;
  padding-right: 16px;
  padding-left: 16px;
}

.content.med {
  max-width: 940px;
}

.no-margin {
  margin-top: 0px;
  margin-bottom: 0px;
}

.no-margin.push-left {
  margin-right: 16px;
}

.no-margin.push-left.top-breather {
  margin-top: 64px;
}

.no-margin.push-left.move-up {
  margin-bottom: 8px;
}

.no-margin.push-left.muted.full {
  width: 100%;
  max-width: none;
}

.no-margin.push-down {
  margin-top: 16px;
}

.no-margin.push-down.nudge-up {
  margin-bottom: 4px;
}

.no-margin.fill.top-breather {
  margin-top: 32px;
}

.throw-down {
  margin-top: 32px;
}

.throw-right {
  margin-left: 32px;
}

.throw-left {
  margin-right: 32px;
}

.throw-up {
  margin-bottom: 32px;
}

.donut-chart-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.donut-chart-container.move-down.vertical {
  flex-direction: column;
  align-items: flex-start;
}

.donut-chart-container.align-top {
  align-items: flex-start;
}

.html-embed {
  flex: 0 0 auto;
}

.html-embed.sentiment-chart {
  width: 100%;
}

.legend.horizontal {
  display: flex;
}

.legend-item {
  display: flex;
  margin-top: 4px;
  margin-bottom: 4px;
  align-items: baseline;
}

.legend-item.horinzontal {
  margin-top: 0px;
  margin-right: 16px;
}

.legend-marker {
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 4px;
  background-color: #718096;
}

.legend-marker.brand-1 {
  background-color: #9775fa;
}

.legend-marker.brand-2 {
  width: 8px;
  height: 8px;
  margin-top: 0px;
  margin-left: 0px;
  background-color: #4dabf7;
  background-image: none;
  background-size: auto;
  background-repeat: repeat;
}

.legend-marker.brand-3 {
  background-color: #38d9a9;
}

.legend-marker.positive {
  background-color: #40c057;
}

.legend-marker.neutral {
  background-color: #fcc419;
}

.legend-marker.negative {
  background-color: #fa5252;
}

.chart-bg {
  padding: 8px;
  border-radius: 4px;
  background-color: #f7fafc;
}

.sentiment-map {
  width: 80%;
}

.inline {
  display: inline-block;
}

.muted {
  max-width: 400px;
  color: #718096;
  font-style: normal;
  font-weight: 400;
}

.muted.small {
  font-size: 14px;
}

.muted.small.with-icon.push-right.bold {
  font-weight: 600;
}

.muted.small.with-icon.push-right.bold.active {
  cursor: pointer;
}

.muted.white-text {
  color: hsla(0, 0%, 100%, 0.7);
}

.muted.with-icon.full {
  width: 100%;
  max-width: none;
}

.muted.with-icon.no-shrink {
  flex: 0 0 auto;
}

.grey-card {
  position: relative;
  border-radius: 4px;
  background-color: #f7fafc;
}

.grey-card.push-down {
  transition: transform 250ms ease;
  cursor: pointer;
}

.grey-card.push-down:hover {
  transform: translate(0px, -4px);
}

.with-badge {
  display: inline-block;
}

.column-header-container {
  margin-bottom: 4px;
}

.chart-detail-content {
  overflow: hidden;
  width: 100%;
  padding-top: 8px;
}

.no-top-padding {
  padding-top: 0px;
}

.card-marker {
  width: 100%;
  height: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-color: #718096;
}

.card-marker.positive {
  background-color: #40c057;
}

.card-marker.neutral {
  background-color: #fcc419;
}

.card-marker.negative {
  background-color: #fa5252;
}

.card-marker.active {
  background-color: #4517a6;
}

.card-marker.important {
  background-color: #ff922b;
}

.card-marker.pink {
  background-color: #e64980;
}

.card-marker.blue {
  background-color: #5c7cfa;
}

.marker {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  border-radius: 100%;
  background-color: #718096;
  transform: translate(0px, 2px);
}

.marker.positive {
  background-color: #40c057;
  transform: translate(0px, 3px);
}

.marker.neutral {
  background-color: #fcc419;
}

.marker.negative {
  background-color: #fa5252;
}

.marker.small {
  width: 8px;
  height: 8px;
}

.marker.small.nudge-down.move-left.positive-2 {
  overflow: scroll;
}

.marker.positive-2 {
  background-color: #4c6ef5;
}

.text-align-center {
  text-align: center;
}

.text-align-center.with-icon.justify-center {
  justify-content: center;
}

.push-left {
  margin-right: 16px;
}

.metric {
  /* width: 100%; */
  height: 100%;
  max-height: 24px;
  padding-left: 0px;
  border-radius: 4px;
  background-color: #cbd5e0;
  color: #1a202c;
  font-size: 14px;
  font-weight: 600;
}

.metric.brand-1 {
  padding-right: 0px;
  background-color: #9775fa;
  text-align: right;
}

.metric.brand-1._40 {
  width: 40%;
}

.metric.brand-1._20 {
  width: 20%;
}

.metric.brand-1._3 {
  width: 30%;
}

.metric.brand-1._3._20 {
  width: 20%;
}

.metric.brand-1._3._50 {
  width: 50%;
}

.metric.brand-1._3._2 {
  width: 2%;
}

.metric.brand-1._3._5 {
  width: 5%;
}

.metric.brand-1._3._18 {
  width: 18%;
}

.metric.brand-1._5 {
  width: 80%;
}

.metric.brand-1._5.ke {
  width: 10%;
  background-color: #9779ef;
}

.metric.brand-1._6 {
  width: 70%;
}

.metric.brand-1._6.et {
  width: 10%;
  background-color: #9779ef;
}

.metric.brand-1._7 {
  width: 40%;
}

.metric.brand-1._8 {
  width: 30%;
}

.metric.brand-1._9 {
  width: 6%;
}

.metric.brand-1._10 {
  width: 1%;
}

.metric.brand-1._11 {
  width: 3%;
}

.metric.brand-1._80 {
  width: 80%;
}

.metric.brand-1._50 {
  width: 50%;
}

.metric.brand-2 {
  width: 60%;
  background-color: #9775fa;
}

.metric.brand-2._40 {
  width: 40%;
}

.metric.brand-2._30 {
  width: 30%;
}

.metric.brand-2._20 {
  width: 20%;
}

.metric.brand-2._10 {
  width: 10%;
}

.metric.brand-3 {
  width: 30%;
  background-color: #9775fa;
}

.metric.brand-3._20 {
  width: 20%;
}

.metric.brand-3._10 {
  width: 10%;
}

.metric.stat {
  padding-right: 0px;
  background-color: #9775fa;
  text-align: right;
}

.metric.stat._40 {
  width: 40%;
}

.metric.stat._20 {
  width: 20%;
}

.metric.stat._2 {
  width: 70%;
}

.metric.stat._4 {
  width: 95%;
  background-color: #9775fa;
}

.metric.stat._4.positive {
  background-color: #4c6ef5;
}

.metric.stat._4.negative {
  background-color: #fa5252;
}

.metric.stat._4.so {
  width: 30%;
  background-color: #9779ef;
}

.metric.stat.brand-2 {
  height: auto;
  margin-top: 0px;
  margin-left: 0px;
  background-color: rgba(77, 171, 247, 0.4);
  background-image: none;
  background-size: auto;
  background-repeat: repeat;
}

.metric.stat.brand-2._2 {
  height: auto;
  margin-top: 0px;
  margin-left: 0px;
}

.metric.stat.brand-3 {
  background-color: rgba(56, 217, 169, 0.4);
}

.metric.stat.asjvbnr {
  width: 80%;
}

.metric.stat.aovuber {
  width: 40%;
}

.metric.stat.afjovba {
  width: 32%;
}

.metric.primary {
  background-color: #4517a6;
}

.metric.primary._20 {
  width: 20%;
}

.metric.primary._30 {
  width: 35%;
}

.metric.primary._0 {
  width: 0%;
}

.metric.warning {
  background-color: #ff922b;
}

.metric.warning._20 {
  width: 20%;
}

.metric.warning._0 {
  width: 0%;
}

.metric.grey {
  background-color: #718096;
}

.metric.grey._20 {
  width: 20%;
}

.metric.grey._50 {
  width: 50%;
}

.metric._20 {
  width: 20%;
}

.metric._20.red-bg {
  background-color: rgba(250, 82, 82, 0.2);
}

.metric._20.purple {
  background-color: #f3d9fa;
}

.metric._80 {
  width: 80%;
}

.metric._80.green-bg {
  background-color: rgba(64, 192, 87, 0.2);
}

.metric._80.pink {
  background-color: #eebefa;
}

.metric._80.purple {
  background-color: #f3d9fa;
}

.metric._80.purple._60 {
  width: 60%;
}

.metric._80.purple._22 {
  width: 22%;
}

.metric._40 {
  width: 40%;
}

.metric._40.yellow-bg {
  background-color: rgba(250, 176, 5, 0.2);
}

.metric._40.purple {
  background-color: #f3d9fa;
}

.metric._40.purple._30 {
  width: 30%;
}

.metric._40.purple._20 {
  width: 20%;
}

.metric._40.purple._10 {
  width: 10%;
}

.metric._40.purple._60 {
  width: 60%;
}

.metric._40.purple._8 {
  width: 8%;
}

.metric._40.purple._4 {
  width: 4%;
}

.metric._40.purple._3 {
  width: 3%;
}

.metric.violet {
  padding-right: 0px;
  background-color: #9775fa;
  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
  text-align: right;
}

.metric.violet._40 {
  width: 40%;
}

.metric.violet._20 {
  width: 20%;
}

.metric.violet._3 {
  width: 30%;
}

.metric.violet._3._20 {
  width: 20%;
}

.metric.violet._3._50 {
  width: 50%;
}

.metric.violet._3._2 {
  width: 2%;
}

.metric.violet._3._5 {
  width: 5%;
}

.metric.violet._3._18 {
  width: 18%;
}

.metric.violet._5 {
  width: 80%;
}

.metric.violet._6 {
  width: 70%;
}

.metric.violet._7 {
  width: 40%;
}

.metric.violet._8 {
  width: 30%;
}

.metric.violet._9 {
  width: 6%;
}

.metric.violet._10 {
  width: 1%;
}

.metric.violet._11 {
  width: 3%;
}

.metric.violet._80 {
  width: 80%;
}

.metric.violet._50 {
  width: 50%;
}

.metric.violet.ni {
  width: 50%;
}

.metric.violet._0 {
  width: 0%;
}

.metric.positive {
  background-color: #4c6ef5;
}

.metric.positive.advkn {
  width: 80%;
}

.metric.positive.aksvn {
  width: 40%;
}

.metric.positive.asicn {
  width: 33%;
}

.metric.negative {
  background-color: #fa5252;
}

.metric.negative.safvr {
  width: 30%;
  flex: 0 0 auto;
}

.metric.negative.safvr._2 {
  width: 50%;
}

.metric.comparison {
  position: absolute;
  left: 50%;
  width: 4px;
  max-height: 16px;
  margin-left: -4px;
  background-color: #320b85;
  transform: translate(0px, -4px);
}

.metric.comparison._70 {
  left: 70%;
  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
}

.metric.comparison._40 {
  left: 40%;
}

.metric.comparison._30 {
  left: 30%;
}

.metric.comparison._15 {
  left: 15%;
}

.metric.comparison._12 {
  left: 12%;
}

.metric.comparison._60 {
  left: 60%;
}

.metric.comparison._38 {
  left: 38%;
}

.metric.comparison._8 {
  left: 8%;
}

.metric.comparison._22 {
  left: 22%;
}

.metric.comparison._4 {
  left: 4%;
}

.metric.comparison._19 {
  left: 19%;
}

.metric.comparison._3 {
  left: 3%;
}

.metric.comparison._0 {
  left: 0%;
}

.metric.purple {
  background-color: #f3d9fa;
}

.metric.purple._50 {
  width: 50%;
}

.metric.purple._19 {
  width: 19%;
}

.metric.blue {
  background-color: #5c7cfa;
}

.metric.positive-2 {
  background-color: #4c6ef5;
}

.metric.positive-2.aerv {
  width: 60%;
  flex: 0 0 auto;
}

.metric.positive-2.djac {
  width: 50%;
  flex: 0 0 auto;
}

.metric.positive-2.adcvrv {
  width: 50%;
  flex: 0 0 auto;
}

.metric.positive-2.adv {
  width: 20%;
  flex: 0 0 auto;
}

.metric.neutral-2 {
  background-color: #edf2f7;
}

.metric.neutral-2._135g {
  width: 33%;
  flex: 0 0 auto;
}

.scout-option-label {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  border-left: 1px none #cbd5e0;
  color: #1a202c;
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
}

.scout-option-label:hover {
  background-color: #cbd5e0;
}

.scout-option-label.first {
  border-left-style: none;
}

.scout-option {
  display: flex;
  margin-bottom: 0px;
  padding-top: 4px;
  padding-left: 0px;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  border-left: 1px solid #cbd5e0;
  color: #1a202c;
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
}

.scout-option:hover {
  background-color: #cbd5e0;
}

.scout-option.first {
  border-left-style: none;
}

.form-block-2 {
  margin-bottom: 0px;
}

.scout-number {
  flex: 0 0 auto;
  font-size: 20px;
  line-height: 120%;
  font-weight: 600;
}

.scout-number.huge {
  margin-bottom: 16px;
  font-size: 36px;
}

.scout-number.huge.no-margin {
  margin-bottom: 0px;
}

.scout-number.small {
  max-width: 346px;
  font-size: 16px;
  line-height: 140%;
}

.scout-number.small.white-text {
  color: #fff;
}

.scout-number.small.fill {
  max-width: 100%;
}

.scout-number.large {
  font-size: 28px;
}

.scout-number.tiny {
  font-size: 14px;
}

.scout-number.positive {
  color: #2b8a3e;
}

.scout-number.neutral {
  color: #e67700;
}

.scout-number.negative {
  color: #c92a2a;
}

.scout-number.brand-1 {
  color: #9775fa;
}

.scout-number.brand-2 {
  color: #4dabf7;
}

.scout-number.brand-3 {
  color: #38d9a9;
}

.sidebar {
  position: fixed;
  width: 174px;
  margin-top: 96px;
  padding: 4px;
  border-radius: 4px;
  background-color: #e2e8f0;
}

.sidebar-link {
  display: block;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-bottom: 2px;
  padding-left: 4px;
  border-radius: 4px;
  transition: all 250ms ease;
  color: #2d3748;
}

.sidebar-link:hover {
  background-color: #cbd5e0;
}

.answer-date-header {
  padding-top: 65px;
}

.white-text {
  color: #fff;
}

.fill {
  width: 100%;
  max-width: 100%;
}

.expand {
  flex: 1 1;
}

.step-1 {
  overflow: hidden;
}

.step-1.fill {
  overflow: visible;
}

.step-2 {
  overflow: hidden;
}

.step-2.fill {
  overflow: visible;
}

.step-4 {
  overflow: hidden;
}

.step-4.fill {
  overflow: visible;
}

.respond-step {
  overflow: hidden;
}

.modal-card-content {
  overflow: hidden;
}

.modal-card-location-filter {
  position: relative;
  overflow: scroll;
  width: 100%;
  max-height: 90vh;
  border-radius: 4px;
  background-color: #fff;
  color: #2d3748;
  min-height: 445px;
}

.reports {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.report-preview {
  width: 45%;
  height: 392px;
  flex: 0 1 auto;
}

.pdf-container {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 20;
  display: none;
  overflow: scroll;
  padding-top: 64px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(33, 37, 41, 0.8);
  color: #fff;
}

.pdf-container.darker {
  display: none;
  background-color: rgba(33, 37, 41, 0.95);
  color: #718096;
}

.pdf-container.temp {
  display: flex;
}

.blacklist {
  opacity: 0.2;
  text-decoration: line-through;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.hidden {
  display: none;
}

.no-padding {
  padding: 0px;
}

.absolute {
  position: absolute;
}

.absolute.align-right {
  right: 0px;
}

.absolute.align-right.small-text {
  font-size: 12px;
}

.has-bottom-border {
  border-bottom: 1px solid #cbd5e0;
}

.has-top-border {
  border-top: 1px solid #cbd5e0;
}

.details-container {
  position: relative;
  display: block;
  overflow: visible;
  flex-wrap: wrap;
  border-top: 1px solid #cbd5e0;
}

.details-container.mentions {
  overflow: visible;
}

.fader {
  position: relative;
  z-index: 1;
  height: 40px;
  background-image: linear-gradient(0deg, #fff, hsla(0, 0%, 100%, 0));
  transform: translate(0px, -40px);
  text-align: center;
}

.fader.bottom {
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  height: 40px;
  background-image: linear-gradient(0deg, #fff, hsla(0, 0%, 100%, 0));
}

.close-detail {
  display: flex;
  padding-top: 4px;
  padding-bottom: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.full-screen {
  height: 90vh;
}

.align-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.image {
  margin-bottom: 8px;
  border-radius: 4px;
}

.code-block {
  padding: 8px;
  border-radius: 4px;
  background-color: #edf2f7;
}

.rich-text-block {
  margin-top: 16px;
}

.rich-text-block h2 {
  font-weight: 600;
}

.rich-text-block p {
  margin-bottom: 16px;
}

.image-2 {
  height: 64px;
  border-radius: 4px;
}

.div-block {
  display: none;
  padding-bottom: 32px;
}

.neutral {
  color: #4a5568;
}

.negative {
  color: #c92a2a;
}

.div-block-2 {
  display: none;
}

.div-block-10 {
  display: flex;
}

.div-block-11 {
  position: absolute;
  top: 50%;
  display: flex;
  width: 52px;
  height: 52px;
  margin-top: -26px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: #fff;
  box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.1), 0 1px 4px 0 rgba(0, 0, 0, 0.2);
}

.card-footer {
  display: flex;
  padding: 8px 16px;
  justify-content: flex-start;
  align-items: baseline;
  flex: 0 0 auto;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #edf2f7;
}

.static {
  position: static;
}

.table-action {
  position: absolute;
  top: 50%;
  right: 0px;
  margin-top: -8px;
  cursor: pointer;
}

.input-2 {
  height: 36px;
  margin-bottom: 0px;
  padding-right: 8px;
  padding-left: 8px;
  border: 1px none #adb5bd;
  border-radius: 4px;
  background-color: #f1f3f5;
  transition: all 250ms ease;
  color: #343a40;
  line-height: 100%;
}

.input-2:hover {
  border-color: #868e96;
  background-color: #dee2e6;
}

.input-2:focus {
  border: 2px solid #be4bdb;
  background-color: #fff;
}

.input-2::placeholder {
  color: #868e96;
}

.input-2.select {
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg"),
    linear-gradient(180deg, #f1f3f5, #f1f3f5);
  background-position: 98% 50%, 0px 0px;
  background-size: 16px, auto;
  background-repeat: no-repeat, repeat;
}

.input-2.select.large {
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg"),
    linear-gradient(180deg, null, null);
  background-size: 24px, auto;
}

.input-2.select.large.multi {
  height: 128px;
}

.input-2.textarea {
  height: 100px;
  max-width: 400px;
}

.input-2.textarea.large {
  height: 120px;
}

.input-2.textarea.large.fill {
  max-width: 100%;
}

.input-2.large {
  height: 52px;
  flex: 0 1 auto;
  font-size: 16px;
}

.button-3 {
  position: relative;
  display: inline-block;
  margin-top: 16px;
  margin-bottom: 8px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  border: 2px solid transparent;
  border-radius: 4px;
  background-color: rgba(190, 75, 219, 0.1);
  box-shadow: none;
  transition: all 250ms ease;
  color: #9c36b5;
  font-weight: 600;
}

.button-3:hover {
  box-shadow: none;
  transform: translate(0px, -2px);
}

.button-3:active {
  border-color: #9c36b5;
}

.button-3:focus {
  z-index: 1;
  border-color: rgba(190, 75, 219, 0.2);
}

.button-3.with-icon.wide.no-margin {
  margin-top: 0px;
}

.button-3.primary {
  border-color: #be4bdb;
  background-color: #be4bdb;
  box-shadow: 0 8px 16px -4px rgba(156, 54, 181, 0.3);
  color: #fff;
}

.button-3.primary:hover {
  box-shadow: 0 12px 20px -4px rgba(156, 54, 181, 0.3);
}

.button-3.primary:focus {
  border-color: #e37cff;
}

.img-box {
  width: 128px;
  height: 128px;
}

.img-box.move-left {
  border-radius: 8px;
  background-color: #edf2f7;
}

.scroll {
  overflow: scroll;
}

.max-height-xs {
  max-height: 156px;
}

.padding-bottom-huge {
  padding-bottom: 64px;
}

.tight {
  max-width: 200px;
}

.black-text {
  color: #1a202c;
}

.number {
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
}

.grey-text {
  color: #2d3748;
}

.question-header {
  height: 80px;
}

.full-height {
  height: 100%;
}

.full-height.vertical {
  display: flex;
  flex-direction: column;
}

.full-height.vertical.center {
  justify-content: center;
  align-items: center;
}

.full-height.vertical.center.padded {
  padding: 32px;
}

.full-height.vertical.padded {
  padding: 32px;
}

.padded {
  padding: 16px;
}

.rounded {
  border-radius: 4px;
}

.datepicker-here {
  height: 300px;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5d5c177340c6bea80285c4fb_Screenshot%202019-08-20%20at%204.52.28%20PM.png");
  background-position: -1% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.nav-container-2 {
  position: fixed;
  z-index: 10;
  display: flex;
  overflow: hidden;
  width: 200px;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #f1eef8;
}

.nav-2 {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  flex: 0 0 auto;
}

.brand-2 {
  width: 100px;
  height: 32px;
  max-height: 32px;
  margin-top: 32px;
  margin-left: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da78d3fac4d6deacd4589d5_Group.png");
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.brand-2.scouts {
  width: 169px;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b589b37929c5a3a8dce7a0e_Group%2012.png");
}

.brand-2.small-brand {
  display: none;
  width: 40px;
  height: 32px;
  max-height: 32px;
  background-image: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da7a082e8ed8a5958595bfa_Shape.svg");
}

.section-2 {
  display: flex;
  min-height: 100vh;
  padding: 0px 16px 64px;
  flex-direction: row;
  align-items: stretch;
  background-color: #fff;
}

.section-2.center {
  justify-content: center;
}

.container-sticky {
  z-index: 4;
  background-color: #fff;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  max-width: 1226px;
  height: auto;
  margin-left: -24px;
  padding-top: 32px;
  padding-left: 32px;
  padding-right: 32px;
  display: block;
  /* position: -webkit-sticky;
  position: sticky;
  top: 0; */
}

.tab-menu {
  z-index: 3;
  background-color: #fff;
  padding-top: 0;
  top: 284px;
  height: 84px;
  /* position: sticky; */
  width: inherit;
  margin-left: inherit;
}

.request-tab-menu {
  z-index: 3;
  background-color: #fff;
  padding-top: 0;
  top: 262px;
  height: 84px;
  /* position: sticky; */
  width: inherit;
  margin-left: inherit;
  margin-right: auto;
}

.body-2 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}

.nav-link-2 {
  margin: 2px 16px 0px;
  padding: 12px 0px;
  background-color: transparent;
  transition: color 250ms ease;
  color: #4a5568;
  font-size: 16px;
  line-height: 100%;
  font-weight: 600;
}

.nav-link-2:hover {
  color: #320b85;
}

.nav-link-2.w--current {
  border-bottom: 2px solid #4517a6;
  background-color: transparent;
  color: #2d3748;
}

.nav-link-2.with-badge {
  margin-right: 4px;
}

.nav-link-2.small {
  padding-top: 16px;
  padding-bottom: 8px;
  font-size: 16px;
}

.nav-link-2.tiny {
  display: flex;
  margin-right: 8px;
  margin-left: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 12px;
}

.nav-link-2.with-icon {
  width: 100%;
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
}

.nav-link-2.with-icon:hover {
  background-color: #e4e0f1;
  color: #4517a6;
}

.nav-link-2.with-icon.w--current {
  border-left: 1px none #000;
  border-bottom-style: none;
  background-color: #fcfaff;
  color: #4517a6;
}

.side-bar {
  overflow: hidden;
  width: 220px;
  margin-right: 16px;
  padding-top: 52px;
  padding-bottom: 16px;
  flex: 0 0 auto;
  background-color: #fcfaff;
  box-shadow: inset -20px 0 20px -12px rgba(18, 0, 54, 0.05),
    inset -10px 0 4px -8px rgba(21, 0, 65, 0.05);
}

.side-bar.feed {
  position: fixed;
  left: auto;
  top: 0px;
  right: 0%;
  bottom: 0%;
  z-index: 10;
  overflow: scroll;
  width: 320px;
  margin-right: 0px;
  margin-left: 0px;
  padding: 32px 16px 0px;
  border-top: 1px none #e2e8f0;
  border-left: 1px solid #e4e0f1;
  background-color: #fff;
  box-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.1);
}

.side-bar.feed.padded {
  padding-right: 32px;
  padding-bottom: 32px;
  padding-left: 32px;
}

.side-bar.fixed {
  position: fixed;
  left: 0%;
  top: 0%;
  right: auto;
  bottom: 0%;
  display: flex;
  overflow: scroll;
  width: auto;
  height: 100vh;
  margin-left: 0px;
  padding-top: 82px;
  padding-right: 32px;
  padding-left: 32px;
}

.side-bar.fixed.temp {
  left: 210px;
}

.card-2 {
  margin-bottom: 16px;
  flex: 1 1;
  border-style: none;
  border-width: 1px;
  border-color: #cbd5e0;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 0 4px -2px rgba(0, 0, 0, 0.1),
    3px 3px 8px -4px rgba(0, 0, 0, 0.2), 0 16px 50px -8px rgba(33, 37, 41, 0.1);
  transition: all 250ms ease;
  text-decoration: none;
}

.card-2.horizontal {
  display: flex;
  flex: 0 0 auto;
}

.card-2.horizontal.m-wrap {
  flex: 0 0 auto;
}

.card-2.horizontal.m-wrap.full-height {
  flex: 1 1;
}

.card-2.horizontal.m-wrap.expand {
  flex: 1 1;
}

.card-2.vertical {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
}

.card-2.active {
  cursor: pointer;
}

.card-2.active.selected {
  border-style: solid;
  border-color: #4517a6;
}

.card-2.active:hover {
  transform: translate(0px, -4px);
}

.card-2.dark {
  background-color: #1a202c;
}

.card-2.muted {
  background-color: #cbd5e0;
}

.card-2.muted.active {
  cursor: pointer;
}

.card-2.m-side-scroll {
  box-shadow: 0 16px 64px 0 rgba(33, 37, 41, 0.1);
}

.card-2.m-side-scroll.active {
  flex: 0 1 auto;
  cursor: pointer;
}

.card-2.m-side-scroll.active.flex {
  display: flex;
  height: 100%;
  flex-direction: column;
  flex: 0 0 auto;
}

.card-2.m-side-scroll.active.full {
  height: 100%;
}

.card-2.m-side-scroll.flex {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
}

.card-2.m-side-scroll.flex.full {
  height: 100%;
}

.card-2.m-side-scroll.spaced {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 0 0 auto;
}

.search {
  display: flex;
  margin-right: -8px;
  margin-left: -8px;
  padding: 0px 0px 0px 8px;
  align-items: center;
  border-radius: 8px;
  background-color: #eeebf7;
}

.small-text {
  flex: 0 0 auto;
  font-size: 12px;
}

.small-text.nudge-right.bold {
  color: #2d3748;
}

.small-text.muted {
  line-height: 150%;
}

.small-text.uppercase {
  letter-spacing: 1px;
  text-transform: uppercase;
}

.nav-section-2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 0 0 auto;
}

.nav-section-2.center {
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 0 0 auto;
}

.nav-section-2.right {
  justify-content: flex-end;
  flex: 0 0 auto;
}

.nav-section-2.left {
  flex: 0 0 auto;
}

.side-bar-link {
  display: block;
  margin: 2px -8px;
  padding: 8px;
  border-radius: 8px;
  color: #4a5568;
  font-size: 12px;
  line-height: 150%;
  font-weight: 600;
}

.side-bar-link:hover {
  background-color: #e4e0f1;
}

.side-bar-link.w--current {
  background-color: #eeebf7;
  color: #2d3748;
}

.side-bar-link.active {
  background-color: #f6f3fd;
  color: #2d3748;
}

.card-section-2 {
  padding: 32px;
  flex: 0 1 auto;
}

.card-section-2.w--current {
  background-color: transparent;
}

.card-section-2.horizontal {
  display: inline-block;
  border-right: 1px solid #cbd5e0;
}

.card-section-2.horizontal.end {
  border-right-style: none;
}

.card-section-2.vertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid #cbd5e0;
}

.card-section-2.vertical.has-bottom-border.dark-border {
  border-bottom-color: #cdd3da;
}

.card-section-2.center {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.card-section-2.grey {
  background-color: #f7fafc;
}

.card-section-2.flex-row {
  display: flex;
}

.card-section-2.flex-row.align-center {
  align-items: center;
}

.card-section-2._8-padding {
  min-width: 120px;
  padding: 8px;
}

.card-section-2._8-padding.no-top-padding {
  padding-top: 0px;
}

.card-section-2.fill {
  flex: 1 1;
}

.card-section-2.expand {
  flex: 1 1;
}

.card-section-2.expand.horizontal.detail-trigger {
  background-color: #fff;
}

.card-section-2.expand.horizontal.detail-trigger.w--current {
  border-bottom: 2px solid #4517a6;
}

.card-section-2.expand.detail-trigger.w--current {
  border-bottom: 2px solid #4517a6;
}

.card-section-2.expand.has-top-border {
  flex: 1 1;
}

.card-section-2.detail-trigger {
  transition: background-color 250ms ease;
  cursor: pointer;
}

.card-section-2.detail-trigger:hover {
  background-color: #f7fafc;
}

.card-section-2.detail-trigger.expand {
  background-color: #fff;
}

.card-section-2.empty {
  display: flex;
  height: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card-section-2.has-top-border {
  flex: 0 0 auto;
}

.card-section-2.align-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.card-section-2.no-shrink {
  flex: 0 0 auto;
}

.card-section-2._50 {
  width: 50%;
}

.card-section-2._60 {
  width: 60%;
}

.chart-bg-2 {
  margin-right: -16px;
  margin-left: -16px;
  padding: 16px 0px 0px;
  border-radius: 4px;
}

.side-spacer {
  position: relative;
  width: 320px;
  margin-right: 0px;
  margin-left: 0px;
  padding: 0px 24px 16px;
  flex: 0 0 auto;
}

.side-spacer.feed {
  margin-left: 0px;
}

.side-spacer.thin {
  width: 224px;
}

.side-spacer.thin.left {
  margin-right: 16px;
  padding-right: 0px;
  padding-left: 0px;
}

.medium-text {
  position: relative;
  z-index: 1;
  font-size: 14px;
}

.medium-text.medium-weight {
  font-weight: 500;
}

.medium-text.nudge-right.huh {
  transform: translate(0px, 0px);
}

.keep-size {
  flex: 0 0 auto;
}

.psuedo-card {
  margin-right: -4px;
  margin-bottom: 16px;
  margin-left: -4px;
  padding: 2px 4px;
  border-radius: 8px;
  cursor: pointer;
}

.psuedo-card:hover {
  background-color: #edf2f7;
}

.psuedo-card.important {
  background-color: rgba(230, 119, 0, 0.1);
  color: #2d3748;
}

.psuedo-card.padded {
  padding: 16px;
}

.psuedo-card.padded.negative {
  background-color: #fff5f5;
}

.psuedo-card.padded.purple {
  background-color: #f8f0fc;
  color: #320b85;
}

.psuedo-card.positive {
  background-color: #edf2ff;
  color: #364fc7;
}

.psuedo-card.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.source-container {
  margin-right: -4px;
  margin-left: -4px;
}

.modal-2 {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 20;
  display: none;
  overflow: auto;
  padding-top: 244px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
}

.modal-2.darker {
  display: none;
  background-color: rgba(33, 37, 41, 0.95);
  color: #718096;
}

.modal-2.dev {
  display: flex;
}

.modal-2.temp {
  display: flex;
}

.violet-text {
  color: #5f3dc4;
}

.pink-text {
  color: #a61e4d;
}

.positive-2 {
  color: #364fc7 !important;
}

.sidebar-trigger {
  position: absolute;
  left: auto;
  top: 16px;
  right: 16px;
  bottom: auto;
  z-index: 11;
}

.regular {
  font-weight: 400;
}

.inline-message-content-copy {
  position: absolute;
  left: 0px;
  top: 100%;
  z-index: 10;
  display: none;
  overflow: hidden;
  width: 300px;
  flex-direction: column;
  border-style: solid;
  border-width: 1px;
  border-color: #cbd5e0;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 16px 32px -8px rgba(33, 37, 41, 0.2);
  font-size: 14px;
}

.inline-message-content-copy.sentiment-message {
  left: 50%;
  top: 120%;
  display: flex;
  width: auto;
  margin-left: -70px;
}

.inline-message-content-copy.small {
  width: auto;
}

.inline-message-content-copy.top-right {
  left: 100%;
  top: 0%;
}

.inline-message-content-copy.top-right.small {
  left: 103%;
}

.inline-message-content-copy.anchor-right {
  left: auto;
  right: 0px;
}

.inline-message-content-copy.anchor-right.temp {
  display: block;
}

.inline-message-content-copy.anchor-right.auto {
  position: fixed;
  top: auto;
  right: auto;
  display: flex;
  width: auto;
}

.inline-message-content-copy.temp {
  display: block;
  width: auto;
}

.inline-message-content-copy.align-center.remp {
  display: block;
}

.link-block {
  width: 100%;
  color: #2d3748;
}

.hider {
  position: absolute;
  left: 0%;
  top: auto;
  right: 0%;
  bottom: 0%;
  z-index: 10;
  height: 287px;
  margin-left: -10px;
  background-color: #fff;
}

.hider.h {
  height: 322px;
}

.hider.s {
  height: 54px;
}

.hider.s.h {
  height: 84px;
}

.hider-2 {
  position: absolute;
  left: 0%;
  top: auto;
  right: 0%;
  bottom: 0%;
  z-index: 10;
  height: 194px;
  margin-left: -10px;
  background-color: #fff;
}

.hider-2.h {
  height: 320px;
}

.hider-2.s {
  height: 130px;
}

.hider-2.s.h {
  height: 120px;
}

.heading-2 {
  color: #1a202c;
}

.div-block-3 {
  width: 100%;
  margin-top: 64px;
}

.profile {
  display: flex;
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
  justify-content: space-between;
  align-items: center;
}

.div-block-4 {
  margin-top: 16px;
  margin-left: 16px;
  transition: all 250ms ease;
  cursor: pointer;
}

.div-block-4:hover {
  transform: translate(-4px, 0px);
}

.div-block-4.right:hover {
  transform: translate(4px, 0px);
}

.spacer {
  width: 184px;
  flex: 0 0 auto;
}

.div-block-5 {
  margin-bottom: 32px;
}

.div-block-5.right {
  display: flex;
  margin-top: 4px;
  justify-content: flex-end;
  cursor: pointer;
}

.div-block-6 {
  padding-right: 30px;
  padding-left: 30px;
}

.div-block-7 {
  width: 200px;
  padding-left: 8px;
  flex: 0 0 auto;
}

.vertical {
  display: flex;
  flex-direction: column;
}

.vertical.align-left {
  align-items: flex-start;
}

@media (max-width: 991px) {
  .card.horizontal.m-wrap {
    flex: 0 0 auto;
  }
  .row.has-cards {
    flex-direction: column;
  }
  .row.has-cards.push-down {
    flex-direction: row;
  }
  .column {
    flex: 0 0 auto;
  }
  .column._40 {
    width: 100%;
  }
  .measure-bar.push-right.super-long {
    width: 240px;
  }
  .measure-bar.tall.push-right.med-long {
    width: 64px;
    min-width: auto;
  }
  .sentiment-map {
    width: 90%;
  }
  .grey-card.push-down {
    font-size: 12px;
  }
  .chart-detail-content {
    width: auto;
  }
  .card-2.horizontal.m-wrap {
    flex: 0 0 auto;
  }
}

@media (max-width: 767px) {
  .card {
    border-radius: 0px;
  }
  .row.has-cards {
    padding-right: 0px;
    padding-left: 0px;
  }
  .row.has-cards.push-down {
    flex-direction: column;
  }
  .card-wrap {
    flex: 1 1;
  }
  .tab-menu {
    padding-left: 8px;
  }
  .data.huge {
    font-size: 28px;
  }
  .nav-link {
    margin-right: 8px;
    margin-left: 8px;
    font-size: 16px;
  }
  .column {
    padding-right: 0px;
    padding-left: 0px;
  }
  .column.has-grey-cards {
    padding-right: 16px;
    padding-left: 16px;
  }
  .measure-bar.push-right.super-long {
    width: 100%;
    margin-left: 0px;
  }
  .measure-bar.short {
    min-width: 80px;
  }
  .measure-bar.tall.push-right.med-long {
    margin-left: 0px;
  }
  .measure-bar.tall.push-right.long {
    margin-left: 0px;
  }
  .bar-container.move-down.justify-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .brand {
    width: 70px;
    margin-right: 16px;
  }
  .section {
    overflow: hidden;
  }
  .brand-2 {
    width: 70px;
    margin-right: 16px;
  }
  .section-2 {
    overflow: hidden;
  }
  .nav-link-2 {
    margin-right: 8px;
    margin-left: 8px;
    font-size: 16px;
  }
  .card-2 {
    border-radius: 0px;
  }
}

@media (max-width: 479px) {
  h1 {
    font-size: 20px;
  }
  .card.horizontal {
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .card.horizontal.m-wrap {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .card.m-side-scroll {
    overflow: scroll;
  }
  .row.spaced.in-card {
    flex-direction: row;
  }
  .row.spaced.align-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
  .row.in-card.spaced {
    flex-direction: row;
  }
  .row.center {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .row.has-cards.move-down.align-top {
    align-items: stretch;
  }
  .row.has-cards.m-side-scroll {
    overflow: scroll;
  }
  .row.details {
    width: 100%;
  }
  .row.m-vertical {
    flex-direction: column;
  }
  .tab-menu {
    display: flex;
    padding-right: 8px;
    padding-left: 8px;
  }
  .request-responses-tab-menu {
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    padding-left: 0;
    padding-right: 0;
  }
  .data.small {
    width: 100%;
  }
  .dropdown.user-actions {
    transform: translate(0px, 12px);
  }
  .meta.push-left {
    margin-left: 8px;
  }
  .table-header {
    width: 302px;
    border-bottom-style: none;
  }
  .table-header-cell {
    width: 140px;
    flex: 0 0 auto;
  }
  .table-header-cell._40 {
    width: 260px;
  }
  .table-row.comfy {
    flex-direction: column;
    border-top: 1px solid #cbd5e0;
    border-radius: 0px;
  }
  .table-row.news {
    flex-direction: column;
    align-items: stretch;
    border-bottom: 1px solid #cbd5e0;
    border-radius: 0px;
  }
  .table-body-cell {
    min-width: 140px;
    padding-top: 8px;
    padding-bottom: 8px;
    flex: 0 0 auto;
  }
  .table-body-cell.main {
    width: 100%;
    flex: 0 0 auto;
  }
  .table-body-cell.right-align {
    padding-left: 8px;
    flex-direction: row-reverse;
  }
  .table-body-cell._40 {
    width: 260px;
  }
  .table-body-cell._50 {
    width: 100%;
  }
  .nav {
    padding-top: 8px;
  }
  .nav-link.w--current {
    margin-left: 0px;
  }
  .card-section.horizontal {
    border-bottom: 1px solid #cbd5e0;
    border-right-style: none;
  }
  .card-section.flex-row {
    padding: 8px;
  }
  .card-section.no-top-padding {
    padding-right: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
  }
  .card-section.expand {
    width: 100%;
  }
  .card-section.expand.horizontal {
    width: 100%;
  }
  .card-section.expand.horizontal.has-bottom-border {
    width: 140px;
    flex: 0 0 auto;
    border-right-style: solid;
  }
  .card-section.expand.horizontal.detail-trigger {
    width: 140px;
    flex: 0 0 auto;
    border-right-style: solid;
  }
  .card-section.expand.has-bottom-border {
    width: 140px;
    flex: 0 0 auto;
  }
  .card-section.detail-trigger.expand {
    width: 140px;
    flex: 0 0 auto;
  }
  .measure-bar.short.push-right.medium {
    width: 100%;
    margin-left: 0px;
  }
  .measure-bar.tall.push-right.medium {
    width: 100%;
    margin-left: 0px;
  }
  .bar-container {
    margin-bottom: 8px;
  }
  .bar-container.justify-content.small {
    flex-direction: column;
    align-items: flex-start;
  }
  .nav-container {
    padding-right: 8px;
    padding-left: 8px;
  }
  .nav-section {
    flex-wrap: wrap;
  }
  .brand {
    width: 100%;
    height: 16px;
    margin-bottom: 8px;
    background-position: 0px 50%;
  }
  .move-right.display-name.has-object {
    display: none;
  }
  .section {
    padding-right: 9px;
    padding-left: 8px;
  }
  .donut-chart-container.move-down.vertical {
    flex-direction: row;
  }
  .legend.push-down {
    margin-top: 0px;
    margin-left: 16px;
  }
  .sentiment-map {
    width: 100%;
  }
  .grey-card.push-down {
    margin-top: 8px;
  }
  .marker {
    margin-bottom: 8px;
  }
  .nav-container-2 {
    padding-right: 8px;
    padding-left: 8px;
  }
  .nav-2 {
    padding-top: 8px;
  }
  .brand-2 {
    width: 100%;
    height: 16px;
    margin-bottom: 8px;
    background-position: 0px 50%;
  }
  .section-2 {
    padding-right: 9px;
    padding-left: 8px;
  }
  .nav-link-2.w--current {
    margin-left: 0px;
  }
  .card-2.horizontal {
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .card-2.horizontal.m-wrap {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .card-2.m-side-scroll {
    overflow: scroll;
  }
  .nav-section-2 {
    flex-wrap: wrap;
  }
  .card-section-2.horizontal {
    border-bottom: 1px solid #cbd5e0;
    border-right-style: none;
  }
  .card-section-2.flex-row {
    padding: 8px;
  }
  .card-section-2.no-top-padding {
    padding-right: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
  }
  .card-section-2.expand {
    width: 100%;
  }
  .card-section-2.expand.horizontal {
    width: 100%;
  }
  .card-section-2.expand.horizontal.has-bottom-border {
    width: 140px;
    flex: 0 0 auto;
    border-right-style: solid;
  }
  .card-section-2.expand.horizontal.detail-trigger {
    width: 140px;
    flex: 0 0 auto;
    border-right-style: solid;
  }
  .card-section-2.expand.has-bottom-border {
    width: 140px;
    flex: 0 0 auto;
  }
  .card-section-2.detail-trigger.expand {
    width: 140px;
    flex: 0 0 auto;
  }
}
@font-face {
  font-family: "Proxima Nova";
  src: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f83c7fef2d1_ProximaNova-Semibold.otf")
    format("opentype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Proxima Nova";
  src: url("https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f3a38fef2cd_ProximaNova-Regular.otf")
    format("opentype");
  font-weight: 400;
  font-style: normal;
}

.h100 {
  height: 100%;
}
.hidden-link-text {
  line-height: 0;
  font-size: 0;
  color: transparent;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}

.rotate {
  animation: rotation 2s infinite linear;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.loader-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.75);
  -webkit-backdrop-filter: blur(16px);
  -moz-backdrop-filter: blur(16px);
  -o-backdrop-filter: blur(16px);
  backdrop-filter: blur(16px);
}

.loader {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.loader div {
  animation: loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.loader div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #c04fe1;
  margin: -4px 0 0 -4px;
}
.loader div:nth-child(1) {
  animation-delay: -0.036s;
}
.loader div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.loader div:nth-child(2) {
  animation-delay: -0.072s;
}
.loader div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.loader div:nth-child(3) {
  animation-delay: -0.108s;
}
.loader div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.loader div:nth-child(4) {
  animation-delay: -0.144s;
}
.loader div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.loader div:nth-child(5) {
  animation-delay: -0.18s;
}
.loader div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.loader div:nth-child(6) {
  animation-delay: -0.216s;
}
.loader div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.loader div:nth-child(7) {
  animation-delay: -0.252s;
}
.loader div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.loader div:nth-child(8) {
  animation-delay: -0.288s;
}
.loader div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

[data-tooltip],
.tooltip {
  position: relative;
  cursor: pointer;
}
/* Base styles for the entire tooltip */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after {
  position: absolute;
  visibility: hidden;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
  opacity: 0;
  transition-delay: 0.8s;
  -webkit-transition-delay: 0.8s;
  -moz-transition-delay: 0.8s;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out,
    transform 0.2s ease-in-out;
  transform: translate3d(0, 0, 0);
  pointer-events: none;
}
/* Show the entire tooltip on hover and focus */
[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after {
  visibility: visible;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
  opacity: 1;
}
/* Base styles for the tooltip's content area */
.tooltip:after,
[data-tooltip]:after {
  z-index: 1000;
  padding: 2px;
  width: 160px;
  border-radius: 4px;
  text-align: center;
  background-color: #212529;
  color: #fff;
  content: attr(data-tooltip);
  font-size: 14px;
  line-height: 1.4;
}
/* Directions */
/* Top (default) */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after,
.tooltip-top:before,
.tooltip-top:after {
  bottom: 100%;
  left: 50%;
}
[data-tooltip]:before,
.tooltip:before,
.tooltip-top:before {
  margin-left: -6px;
  margin-bottom: -12px;
  border-top-color: #000;
  border-top-color: hsla(0, 0%, 20%, 0.9);
}
/* Horizontally align top/bottom tooltips */
[data-tooltip]:after,
.tooltip:after,
.tooltip-top:after {
  margin-left: -80px;
}
[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after,
.tooltip-top:hover:before,
.tooltip-top:hover:after,
.tooltip-top:focus:before,
.tooltip-top:focus:after {
  transform: translateY(-12px);
}
/* Left */
.tooltip-left:before,
.tooltip-left:after {
  right: 100%;
  bottom: 50%;
  left: auto;
}
.tooltip-left:before {
  margin-left: 0;
  margin-right: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-left-color: #000;
  border-left-color: hsla(0, 0%, 20%, 0.9);
}
.tooltip-left:hover:before,
.tooltip-left:hover:after,
.tooltip-left:focus:before,
.tooltip-left:focus:after {
  transform: translateX(-12px);
}
/* Bottom */
.tooltip-bottom:before,
.tooltip-bottom:after {
  top: 100%;
  bottom: auto;
  left: 50%;
}
.tooltip-bottom:before {
  margin-top: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-bottom-color: #000;
  border-bottom-color: hsla(0, 0%, 20%, 0.9);
}
.tooltip-bottom:hover:before,
.tooltip-bottom:hover:after,
.tooltip-bottom:focus:before,
.tooltip-bottom:focus:after {
  transform: translateY(12px);
}
/* Right */
.tooltip-right:before,
.tooltip-right:after {
  bottom: 50%;
  left: 100%;
}
.tooltip-right:before {
  margin-bottom: 0;
  margin-left: -12px;
  border-top-color: transparent;
  border-right-color: #000;
  border-right-color: hsla(0, 0%, 20%, 0.9);
}
.tooltip-right:hover:before,
.tooltip-right:hover:after,
.tooltip-right:focus:before,
.tooltip-right:focus:after {
  transform: translateX(12px);
}
/* Move directional arrows down a bit for left/right tooltips */
.tooltip-left:before,
.tooltip-right:before {
  top: 3px;
}
/* Vertically center tooltip content for left/right tooltips */
.tooltip-left:after,
.tooltip-right:after {
  margin-left: 0;
  margin-bottom: -16px;
}

.option {
  display: flex;
  margin-right: 4px;
  padding: 12px 32px;
  align-items: center;
  border: 2px solid #f1f3f5;
  border-radius: 8px;
  background-color: #f1f3f5;
  transition: all 250ms ease;
  cursor: default;
}

.option.active {
  border-color: #5f3dc4;
}

.has-icon {
  display: flex;
  align-items: center;
}

.modal-body.pad-top {
  padding-top: 32px;
}
.q-container {
  position: relative;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  max-width: 100%;
}

.q-options {
  position: absolute;
  padding: 10px;
}

.q-more {
  border: solid 2px transparent;
  width: 40px;
  cursor: pointer;
  text-align: center;
  border-radius: 5px;
  padding: 4px 3px 1px 3px;
  background-color: white;
}

.q-more:hover {
  border-color: #d7ccec;
}
.q-more:focus {
  border-color: #d7ccec;
}
.q-actions {
  position: absolute;
  background-color: white;
  width: 150px;
  border-radius: 5px;
  box-shadow: 0px 0px 3px;
  z-index: 22;
  top: 50px;
  right: -100px;
}
.q-options {
  right: 9px;
  top: 5px;
}
.q-actions ul {
  list-style-type: none;
  color: #320b85;
  padding: 0;
  padding-top: 10px;
}
.q-options ul li {
  padding: 5px 20px;
  cursor: pointer;
}
.q-options ul li:hover {
  font-weight: bold;
}
.q-options ul li span {
  margin-right: 10px;
}
.q-options ul li svg {
  margin-right: 2px;
}
.q-options.arrows button {
  border: solid 2px transparent;
  border-radius: 5px;
  display: block;
  background-color: white;
  padding: 4px 3px;
}
/* .q-options.arrows button:hover {
    border-color: #d7ccec;
  } */
.q-actions ul li:nth-child(3) {
  color: #e64980;
}

.main-color {
  color: #1c0142;
}

.main-color_1 {
  color: #4517a6;
}

.button-link {
  text-decoration: underline;
  border: 0;
  background-color: white;
}
#card-fixed:before {
  position: "fixed";
  z-index: 9999;
  background-color: "#4517A6";
  color: "white";
  top: 20px;
  left: -20px;
}
.inline-tooltip-content-settings.left-up:before {
  background-color: #17a62f;
  margin-top: 120px;
  top: 120px;
  left: -120px;
  color: white;
}

.inline-tooltip-content {
  z-index: 9999;
  position: absolute;
  margin-top: 20px;
  /* Purple */
  background: #4517a6;
  color: white;
}
.inline-tooltip-content.top-right:before {
  content: "";
  position: absolute;
  top: -10px;
  right: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-content.top-left:before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-content-new-survey {
  z-index: 9999;
  position: absolute;
  margin-top: 20px;
  right: 0;
  /* Purple */
  background: #4517a6;
  color: white;
}
.inline-tooltip-content-new-survey.left-up:before {
  content: "";
  position: absolute;
  top: 20px;
  left: -20px;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.inline-tooltip-content-new-survey.top-right:before {
  content: "";
  position: absolute;
  top: -10px;
  right: 100px;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.inline-tooltip-content-new-survey.bottom-right:before {
  content: "";
  position: absolute;
  bottom: -10px;
  right: 100px;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-content-new-survey.left-middle:before {
  content: "";
  position: absolute;
  top: 20px;
  left: -20px;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.inline-tooltip-content-survey-launch {
  z-index: 9999;
  position: fixed;
  margin-top: 20px;
  right: 310px;
  top: 240px;
  /* Purple */
  background: #4517a6;
  color: white;
}
.inline-tooltip-content-survey-launch.right-top:before {
  content: "";
  position: absolute;
  top: -10px;
  right: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-content-survey-summary {
  z-index: 9999;
  position: fixed;
  margin-top: 20px;
  right: 310px;
  /* Purple */
  background: #4517a6;
  color: white;
}

.inline-tooltip-content-survey-summary.right-top:before {
  content: "";
  position: absolute;
  top: -10px;
  right: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-content-multiple-options {
  z-index: 9999;
  position: absolute;

  margin-top: 20px;
  left: 300px;
  /* Purple */
  background: #4517a6;
  color: white;
}

.inline-tooltip-content-multiple-options.top-right:before {
  content: "";
  position: absolute;
  top: -10px;
  right: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-content-3 {
  z-index: 99999;
  position: absolute;
  margin-top: 20px;
  /* Purple */
  background: #4517a6;
  color: white;
}
.inline-tooltip-content-4 {
  z-index: 99999;
  position: fixed;
  margin-top: 20px;
  /* Purple */
  background: #4517a6;
  color: white;
  bottom: 50px;
  left: 120px;
}
.inline-tooltip-content-5 {
  z-index: 99999;
  position: absolute;
  margin-top: 20px;
  /* Purple */
  background: #4517a6;
  color: white;
  top: 50px;
  right: 50px;
}

.inline-tooltip-content-5.top-right:before {
  content: "";
  position: absolute;
  top: -10px;
  right: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-content-3.left-up:before {
  content: "";
  position: absolute;
  top: 20px;
  left: -20px;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.inline-tooltip-content-4.left-up:before {
  content: "";
  position: absolute;
  top: 30px;
  left: -20px;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-content-3.left-down:before {
  content: "";
  position: absolute;
  bottom: 20px;
  left: -20px;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.inline-tooltip-content-3.top-right:before {
  content: "";
  position: absolute;
  top: -10px;
  right: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.inline-tooltip-content-3.top-left:before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.inline-tooltip-content-3.bottom-right:before {
  content: "";
  position: absolute;
  bottom: -10px;
  right: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.inline-tooltip-button {
  color: #1c0142;
}
.inline-tooltip-content-new-survey.top:before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.inline-tooltip-content.top:before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-content.left:before {
  content: "";
  position: absolute;
  top: 0;
  left: -20px;
  border-left: 10px solid transparent;
  border-right: 10px solid #4517a6;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.inline-tooltip-frame {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 109px;
  color: white;

  width: 259px;
  height: 37px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}
.askFiltersTabs {
  display: flex;
  align-items: stretch;
  width: 100%;
  margin-left: 15px;
}

.askFiltersTabs input {
  display: none;
}

.askFiltersTabs button {
  background: white;
  color: #2d3748;
  transition: 0.25s ease;
  margin-right: 32px;
  font-weight: 300;
  font-size: 14px;
  width: -moz-fit-content;
  width: fit-content;
}

.grey-border-bottom {
  border-bottom: 1px solid #e2e8f0;
}

.active-border-bottom {
  border-bottom: 2px solid #4517a6;
}

@keyframes fab-anim {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fab-reverse-anim {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fab {
  position: fixed;
  /* top: 77%;
  left: 93%;
  right: auto; */
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  box-shadow: 0 1px 8px 0 rgb(0 0 0 / 30%);
  background-color: #4517a6;
  animation-name: fab-anim;
  animation-duration: 4s;
  bottom: 30px;
  right: 30px;
}

.fab svg {
  color: #fff;
  opacity: 1;
}
.searchContainer {
  display: flex;
  background-color: #edf2f7;
  width: 250px;
  padding: 0px 0px 0px 0px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-top: 1rem;
  justify-content: flex-start;
  align-items: center;
  border-radius: 8px;
  gap: 0.5rem;
  box-sizing: border-box;
}

.searchContainer input {
  display: block;
  width: 100%;
  height: 36px;
  margin-bottom: 0px;
  padding-right: 8px;
  padding-left: 8px;
  outline: none;
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: transparent;
  font-size: 12px;
  border-style: none;
  border-radius: 4px;
  transition: all 250ms ease;
  color: #1a202c;
  line-height: 100%;
}

.searchContainer input::-webkit-search-cancel-button {
  background-color: red;
}

.searchContainer button {
  background-color: transparent;
  border-radius: 50%;
  font-weight: 500;
}

.active-state {
  display: flex;
  flex-direction: row;
}

.search-border {
  width: 185px;
}

.close-btn {
  opacity: 1;
  transition: color 200ms ease;
  color: #cbd5e0;
  padding-left: 10px;
  cursor: pointer;
  padding-top: 10px;
}

.states-search-dropdown {
  position: absolute;
  background-color: white;
  margin-left: -8px;
  border-radius: 3px 3px 4px 4px;
  border: solid 1px #ddd;
  max-height: 150px;
  width: 208px;
  padding: 2px 5px;
  overflow-x: hidden;
  overflow-y: scroll;
  z-index: 100;
}

.grid-15 {
  grid-template-rows: auto auto auto auto auto;
  grid-template-columns: 1fr 1fr 0.5fr;
  align-items: end;
  margin-top: 10px;
  /* margin-bottom: 10px; */
}

.grid-17 {
  grid-template-rows: auto auto auto auto;
  grid-template-columns: 0.3fr 1fr;
  align-items: end;
  margin-top: 10px;
  /* margin-bottom: 10px; */
}

.grid-16 {
  grid-template-rows: auto auto auto auto;
  grid-template-columns: 0.5fr 1fr;
  align-items: end;
  margin-top: 10px;
  /* margin-bottom: 10px; */
}

.w-layout-grid {
  /* grid-row-gap: 16px; */
  grid-column-gap: 16px;
  /* grid-template-rows: auto auto; */
  /* grid-template-columns: 1fr 1fr; */
  grid-auto-columns: 1fr;
  display: grid;
}

.dropdown-toggle-2 {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  align-items: stretch;
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
  display: flex;
}

.dropdown-list-input {
  z-index: 900;
  width: 160px;
  max-height: 90vh;
  background-color: #fff;
  border-radius: 4px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px;
  /* display: none; */
  position: absolute;
  top: 110%;
  left: 0;
  overflow: hidden;
  box-shadow: 0 16px 32px rgba(33, 37, 41, 0.2);
}

.table-row-other {
  border-radius: 4px;
  flex: 0 1 auto;
  align-items: baseline;
  padding-top: 8px;
  padding-bottom: 8px;
  transition: all 0.25s;
  display: flex;
  position: relative;
}

.table-row-other.small {
  flex: 0 1 auto;
  align-self: auto;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
  font-size: 14px;
  line-height: 140%;
}

.table-row-other.small.left-align {
  /* justify-content: space-between; */
  padding-top: 10px;
  padding-bottom: 10px;
}

.table-body-cell.tiny {
  width: 64px;
  flex: 1 1;
  padding-right: 0;
  flex: none !important;
}

.action-btns {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.image-upload {
  width: 100%;
  height: 400px;
  border: 3.5px dashed var(--grey-faint);
  color: var(--grey);
  border-radius: 8px;
  overflow: hidden;
}

.image-upload.push-up {
  border-color: var(--grey-faint);
  background-color: var(--grey-background);
  border-radius: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
}

.image-preview {
  max-width: 100%;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.helper {
  color: var(--grey-lighter);
  text-align: left;
  margin-top: 4px;
  margin-bottom: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 120%;
  display: block;
}

.response-media {
  width: 60px;
  height: 55px;
  border: solid 2px var(--grey-lighter);
  border-radius: 5px;
  margin: 10px 15px 5px 0px;
  overflow: hidden;
  text-align: center;
}

.response-media-no-border {
  width: 60px;
  height: 60px;
  margin: 10px 15px 5px 0px;
  overflow: hidden;
}

.embedly-embed {
  max-width: 100%;
  height: 300px;
}

.pagination {
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.page-controls {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  align-items: stretch;
  display: flex;
}

.page-counter {
}

.left-content {
  align-items: center;
  display: flex;
}

.button-7 {
  box-shadow: none;
  color: #320b85;
  background-color: #4517a61a;
  border: 2px solid #0000;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 8px;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.25s;
  display: inline-block;
  position: relative;
}

.button-7.subtle {
  color: #320b85;
  background-color: #0000;
  border-style: solid;
  border-color: #0000;
  padding-left: 8px;
  padding-right: 8px;
}

.button-7.subtle.small {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0 4px;
}

.button-7.with-icon.subtle.small {
  flex: none;
  justify-content: flex-start;
}

.button-7:hover {
  background-color: rgba(121, 80, 242, 0.1);
  color: #5f3dc4;
}

.button-7:disabled {
  background-color: inherit;
  pointer-events: none;
}

.center-content {
  grid-column-gap: 6px;
  grid-row-gap: 6px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.bold-text-10 {
  font-size: 16px;
  font-weight: bold;
}

.icon-5 {
  opacity: 0.6;
  flex: none;
  width: 24px;
  height: 24px;
  font-size: 16px;
  transform: none;
}

.right-content {
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  align-items: center;
  display: flex;
}

.row-grid {
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  grid-template-rows: auto;
  grid-template-columns: 0.8fr 1fr 0.5fr;
  grid-auto-columns: 1fr;
  justify-content: center;
  align-items: end;
  display: grid;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;;+EAE+E;AAC/E,2EAA2E;;AAE3E;EACE,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,SAAS;AACX;AACA;;;;;;;;;;;;;EAaE,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;;EAEE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,iCAAiC;EACjC,cAAc;AAChB;AACA;;;;;EAKE,cAAc;EACd,aAAa;EACb,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;AACtB;AACA;;;EAGE,0BAA0B;EAC1B,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;AACA;;EAEE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;;EAEE,UAAU;AACZ;;AAEA;;+EAE+E;AAC/E;EACE,4BAA4B;EAC5B;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,uCAAuC;EACvC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EAGE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,mCAAmC;EACnC,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,gCAAgC;EAChC,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,sEAAsE;EACtE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,qBAAqB;EACrB,iCAAiC;AACnC;AACA;;;;;;EAME,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,SAAS;EACT,SAAS;AACX;AACA;;;EAGE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;AACA;;;;;;EAME,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;;;EAGE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,cAAc;IACd,eAAe;EACjB;EACA;IACE,WAAW;IACX,UAAU;IACV,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,yBAAyB;EAGzB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,QAAQ;EACR,OAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,6CAA6C;EAC7C,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,WAAW;AACb;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,qCAAqC;EACrC,yBAAyB;EAGzB,iBAAiB;AACnB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;;EAEE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EAGzB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX;cACY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,wCAAwC;EACxC,kCAAkC;AACpC;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;;;EAGE,YAAY;AACd;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;EAEf,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,SAAS;EACT,OAAO;EACP,yDAA2U;AAC7U;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;EACT,yDAA+U;AACjV;AACA;EACE,QAAQ;EACR,aAAa;EACb,yDAA2W;EAC3W,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,QAAQ;EACR,WAAW;EAGX,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,YAAY;EAGZ,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAElB,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;EACA;;IAEE,YAAY;EACd;EACA;;;IAGE,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;;IAEE,cAAc;IACd,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,SAAS;AACX;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;AACb;AACA;EACE,MAAM;AACR;AACA;EACE,WAAW;AACb;AACA;;EAEE,WAAW;EACX,UAAU;EACV,MAAM;AACR;AACA;EACE,WAAW;AACb;AACA;;EAEE,UAAU;EACV,UAAU;EACV,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,6CAA6C;EAC7C,qCAAqC;EACrC,yBAAyB;EAGzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAElB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EAEf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAElB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EAEf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,4GAA4G;EAC5G,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB;;cAEY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;EAIb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EAIjB,uBAAuB;EAIvB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAEhB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAGhB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,YAAY;EAIZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EAGE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,wCAAwC;EAGxC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EAEzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EAGE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,iBAAiB;AACnB;;AAEA;EAIE,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EAIE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EAGE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EAGZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAIE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EAIjB,2BAA2B;EAI3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;EACb,UAAU;EACV,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EAIf,aAAa;EACb,WAAW;EACX,YAAY;EAIZ,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAIhB,uBAAuB;AACzB;;AAEA;EAIE,aAAa;EACb,YAAY;EACZ,WAAW;EAIX,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;EACb,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,2HAA2H;EAC3H,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EASE;;;;;6GAK2G;EAC3G,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EASE;;;;;6GAK2G;EAC3G,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EAEzB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAcA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qHAAqH;EACrH,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EAGE;6CAC2C;EAC3C,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EAGE;uCACqC;EACrC,2BAA2B;AAC7B;;AAEA;EAIE;;6CAE2C;EAC3C,8CAA8C;EAC9C,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EAIZ,cAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,wHAAwH;EACxH,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EAIE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,aAAa;EAIb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EAInB,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,+CAA+C;EAE/C,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EAIE,aAAa;EAIb,cAAc;AAChB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EAIE,SAAO;AACT;;AAEA;EAIE,SAAO;AACT;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAGE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EAIE,cAAY;EACZ,eAAe;AACjB;;AAEA;EAIE,aAAa;EACb,YAAY;EAKZ,sBAAsB;EAItB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,8BAA8B;EAI9B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAIE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EAKjB,mBAAmB;EAGnB,iBAAiB;EAIjB,uBAAuB;EAIvB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EAIE,yBAAyB;AAC3B;;AAEA;EAIE,8BAA8B;AAChC;;AAEA;EAIE,qBAAqB;AACvB;;AAEA;EAIE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAIE,mBAAmB;AACrB;;AAEA;EAIE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAIlB,oBAAoB;AACtB;;AAEA;EAIE,uBAAuB;AACzB;;AAEA;EAIE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAGE,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EAIE,oBAAoB;AACtB;;AAEA;EAIE,oBAAoB;AACtB;;AAEA;EAIE,qBAAqB;AACvB;;AAEA;EAIE,SAAO;AACT;;AAEA;EAIE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EAIE,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EAInB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EAIE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EAIV,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAIhB,uBAAuB;EAIvB,mBAAmB;EAInB,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8JAA8J;EAC9J,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2HAA2H;AAC7H;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EASzB;;;;;yGAKuG;EACvG,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EASzB;;;;;2GAKyG;EACzG,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EASzB;;;;;uGAKqG;EACrG,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EASzB;;;;;gHAK8G;EAC9G,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EASzB;;;;;2GAKyG;EACzG,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sHAAsH;EACtH,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,kBAAkB;EAIlB,uBAAuB;EACvB,yBAAyB;EACzB,2DAA2D;EAC3D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EAIpB,uBAAuB;EAIvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EAIZ,cAAc;EACd,YAAY;EAGZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EAEnB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EAGpB,+BAA+B;EAE/B,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EAGE,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EAGE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EAEf,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EAKZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,UAAU;EACV,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EAIE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAElB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EAIE,aAAa;EAIb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAIhB,uBAAuB;EAIvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAIlB,aAAa;EAIb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAIlB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EAIb,uBAAuB;EAIvB,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB;oCACkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB;oCACkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB;oCACkC;EAClC,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EAInB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EAIZ,cAAc;EACd,mBAAmB;EAEnB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,oBAAoB;EAKpB,sBAAsB;EAItB,yBAAyB;EAIzB,oBAAoB;AACtB;;AAEA;EAIE,aAAa;EACb,aAAa;EAIb,uBAAuB;EAIvB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAIlB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAIhB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B;oCACkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EAKZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,SAAS;EAIT,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAIE,aAAa;EAIb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAIhB,uBAAuB;EAIvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,aAAa;EACb,cAAc;EACd,iBAAiB;EAKjB,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EAIE,aAAa;AACf;;AAEA;EAIE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EAIE,aAAa;EACb,sBAAsB;EAItB,qBAAqB;AACvB;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,gBAAgB;EAIhB,8BAA8B;EAG9B,eAAe;EAIf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAIE,aAAa;EACb,sBAAsB;EAItB,2BAA2B;EAI3B,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EAIE,mBAAmB;AACrB;;AAEA;EAIE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EAIE,aAAa;EAIb,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EAIjB,SAAO;EACP,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAIlB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EAInB,qBAAqB;EACrB,kBAAkB;EAElB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAIE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EAIjB,mBAAmB;EAInB,SAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,cAAc;EAId,yBAAyB;EAIzB,qBAAqB;AACvB;;AAEA;EAIE,aAAa;EAIb,yBAAyB;EAIzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EAKE,sBAAsB;AACxB;;AAEA;EAIE,cAAY;AACd;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAY;AACd;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAIhB,uBAAuB;EAIvB,mBAAmB;EAInB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EAIE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EAIjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,iBAAiB;EAIjB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAE7B,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EAIE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAIhB,uBAAuB;EAIvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wHAAwH;EACxH,4BAA4B;EAC5B,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,yJAAyJ;EACzJ,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAIlB,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EACnB,mHAAmH;AACrH;;AAEA;EACE,kBAAkB;EAIlB,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EACnB,yJAAyJ;AAC3J;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,0EAA0E;EAC1E,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EAKjB,sBAAsB;EAItB,SAAO;AACT;;AAEA;EACE,UAAU;EAIV,cAAY;AACd;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EAIE,cAAY;AACd;;AAEA;EACE,UAAU;EAIV,cAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EAInB,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAI1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EAIE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAIE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EAKjB,sBAAsB;EAGtB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EAIb,cAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,MAAM;AACR;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,2BAA2B;EAI3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;AACf;;AAEA;EAIE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAIE,SAAO;AACT;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EAIE,SAAO;AACT;;AAEA;EAEE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAIE,aAAa;EACb,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,gBAAgB;EAIhB,8BAA8B;AAChC;;AAEA;EAIE,aAAa;EACb,gBAAgB;EAIhB,mBAAmB;EAInB,cAAY;EACZ,kBAAkB;EAElB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EAIX,8BAA8B;AAChC;;AAEA;EAIE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EAKjB,sBAAsB;EAItB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAIlB,aAAa;EAIb,8BAA8B;EAG9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAKhB,sBAAsB;EAItB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EAIE,aAAa;EACb,iBAAiB;EACjB,wBAAwB;EAKxB,sBAAsB;EAItB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAIE,aAAa;EAIb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EAIE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB;uGACqG;EACrG,qCAAqC;EACrC,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EAGE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EAGtB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EAIX,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAKlB,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;EAIb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qHAAqH;EACrH,4BAA4B;EAC5B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,0HAA0H;AAC5H;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAIE,aAAa;EAIb,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;AACzB;;AAEA;EAEE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAIE,aAAa;EACb,uBAAuB;EAKvB,sBAAsB;EAItB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAKhB,sBAAsB;EAItB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAIE,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,aAAa;EACb,YAAY;EAKZ,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EAGb,eAAe;EAIf,mBAAmB;AACrB;;AAEA;EAKE,sBAAsB;EAItB,uBAAuB;AACzB;;AAEA;EAIE,uBAAuB;AACzB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EAIE,aAAa;AACf;;AAEA;EAIE,aAAa;EACb,eAAe;EACf,kBAAkB;EAIlB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EAGE,gCAAgC;EAEhC,eAAe;AACjB;;AAEA;EAGE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EAIZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EAGzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EAGzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAIE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EAEzB,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EAGzB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EAET,oDAAoD;AACtD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EAIV,cAAc;AAChB;;AAEA;EAIE,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EAInB,SAAO;EACP,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EAIE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EAIjB,uBAAuB;EAIvB,mBAAmB;EAInB,SAAO;EACP,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAIE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAElB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EAIE,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EAIE,aAAa;EACb,WAAW;EAIX,8BAA8B;EAG9B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EAIb,cAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EAKjB,sBAAsB;EAItB,2BAA2B;EAI3B,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EAIE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EAIE,aAAa;EAIb,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EAGjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EAQZ,mEAAmE;EAGnE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EAQZ,mEAAmE;AACrE;;AAEA;EAIE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EAInB,uBAAuB;EAIvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EAIE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EAIR,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EAIjB,uBAAuB;EAIvB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,8EAA8E;AAChF;;AAEA;EAIE,aAAa;EACb,iBAAiB;EAIjB,2BAA2B;EAI3B,qBAAqB;EAIrB,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EAEzB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAcA;EACE,cAAc;AAChB;;AAEA;EAGE;6CAC2C;EAC3C,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EAGE;uCACqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EAIZ,cAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EAIjB,uBAAuB;EAIvB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAEhB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAGhB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,YAAY;EAIZ,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,aAAa;EAKb,sBAAsB;AACxB;;AAEA;EAIE,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2JAA2J;EAC3J,4BAA4B;EAC5B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;EAIX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EAKZ,sBAAsB;EAItB,2BAA2B;EAI3B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,YAAY;EAKZ,sBAAsB;EAItB,8BAA8B;EAI9B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qHAAqH;EACrH,4BAA4B;EAC5B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,0HAA0H;AAC5H;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qHAAqH;AACvH;;AAEA;EAIE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EAKtB,mBAAmB;EAInB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EAIE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd;;WAES;AACX;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;;cAEY;AACd;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAE7B,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EAIE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EAIpB,cAAc;EACd,yBAAyB;EACzB;gDAC8C;AAChD;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,WAAW;EACX,UAAU;EAIV,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EAInB,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB;+EAC6E;EAE7E,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EAIE,aAAa;EAIb,cAAc;AAChB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EAIE,SAAO;AACT;;AAEA;EAIE,SAAO;AACT;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EAGE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EAIE,cAAY;EACZ,eAAe;AACjB;;AAEA;EAIE,aAAa;EACb,YAAY;EAKZ,sBAAsB;EAItB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,8BAA8B;EAI9B,cAAc;AAChB;;AAEA;EAIE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EAIxB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EAIE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;EAIvB,cAAc;AAChB;;AAEA;EAKE,sBAAsB;EAItB,uBAAuB;EAIvB,uBAAuB;EAIvB,cAAc;AAChB;;AAEA;EAIE,yBAAyB;EAIzB,cAAc;AAChB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EAIb,cAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,2BAA2B;EAI3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;AACf;;AAEA;EAIE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAIE,SAAO;AACT;;AAEA;EAIE,SAAO;AACT;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EAIE,SAAO;AACT;;AAEA;EAEE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAIE,aAAa;EACb,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;AACzB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EAItB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,8BAA8B;AAChC;;AAEA;EAIE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAKlB,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EAIE,aAAa;AACf;;AAEA;EAIE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EAKZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,SAAS;EAIT,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EAIX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAIlB,8BAA8B;EAI9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EAEjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EAGE,+BAA+B;AACjC;;AAEA;EAGE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EAIZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EACb,eAAe;EAIf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EAIjB,cAAc;AAChB;;AAEA;EAIE,aAAa;EAKb,sBAAsB;AACxB;;AAEA;EAIE,uBAAuB;AACzB;;AAEA;EACE;IAIE,cAAc;EAChB;EACA;IAKE,sBAAsB;EACxB;EACA;IAKE,mBAAmB;EACrB;EACA;IAIE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IAIE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IAKE,sBAAsB;EACxB;EACA;IAIE,SAAO;EACT;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IAKE,sBAAsB;IAItB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IAKE,sBAAsB;IAGtB,iBAAiB;EACnB;EACA;IAKE,mBAAmB;IAGnB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IAKE,mBAAmB;EACrB;EACA;IAKE,sBAAsB;IAItB,uBAAuB;EACzB;EACA;IAKE,mBAAmB;EACrB;EACA;IAKE,mBAAmB;IAGnB,eAAe;IAIf,uBAAuB;EACzB;EACA;IAIE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IAKE,sBAAsB;EACxB;EACA;IAIE,aAAa;IACb,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,gCAAgC;IAChC,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IAGE,+BAA+B;EACjC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,YAAY;IAIZ,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IAKE,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;EACpB;EACA;IAKE,sBAAsB;IAItB,oBAAoB;IACpB,gCAAgC;IAChC,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IAInB,cAAc;EAChB;EACA;IACE,WAAW;IAIX,cAAc;EAChB;EACA;IACE,iBAAiB;IAKjB,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IAIZ,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,YAAY;IAIZ,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,YAAY;IAIZ,cAAc;EAChB;EACA;IACE,YAAY;IAIZ,cAAc;EAChB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IAKE,sBAAsB;IAItB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IAGE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IAKE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;EAC9B;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IAKE,sBAAsB;IAGtB,iBAAiB;EACnB;EACA;IAKE,mBAAmB;IAGnB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IAGE,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IAIZ,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,YAAY;IAIZ,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,YAAY;IAIZ,cAAc;EAChB;EACA;IACE,YAAY;IAIZ,cAAc;EAChB;AACF;AACA;EACE,2BAA2B;EAC3B;sBACoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B;sBACoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,4DAA4D;EAC5D,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAoBA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;AACA,uCAAuC;AACvC;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,gEAAgE;EAChE,0DAA0D;EAC1D,UAAU;EACV,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAK3B;8BAC4B;EAG5B,+BAA+B;EAC/B,oBAAoB;AACtB;AACA,+CAA+C;AAC/C;;;;;;;;EAQE,mBAAmB;EACnB,kEAAkE;EAClE,4DAA4D;EAC5D,UAAU;AACZ;AACA,+CAA+C;AAC/C;;EAEE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA,eAAe;AACf,kBAAkB;AAClB;;;;;;EAME,YAAY;EACZ,SAAS;AACX;AACA;;;EAGE,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,uCAAuC;AACzC;AACA,2CAA2C;AAC3C;;;EAGE,kBAAkB;AACpB;AACA;;;;;;;;;;;;EAcE,4BAA4B;AAC9B;AACA,SAAS;AACT;;EAEE,WAAW;EACX,WAAW;EACX,UAAU;AACZ;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;;;;EAME,4BAA4B;AAC9B;AACA,WAAW;AACX;;EAEE,SAAS;EACT,YAAY;EACZ,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;;;;EAME,2BAA2B;AAC7B;AACA,UAAU;AACV;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,yCAAyC;AAC3C;AACA;;;;EAME,2BAA2B;AAC7B;AACA,+DAA+D;AAC/D;;EAEE,QAAQ;AACV;AACA,8DAA8D;AAC9D;;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAIlB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EAEzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB;;cAEY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,aAAa;AACf;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;KAEK;AACL;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,cAAc;EACd,SAAS;EACT,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;;EAElB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,YAAY;;EAEZ,YAAY;EACZ,YAAY;;EAEZ,uBAAuB;;EAEvB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf;;gBAEc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,wCAAwC;EACxC,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAEhB,2BAA2B;EAE3B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAElB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EAEV,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,mCAAmC;EACnC,oCAAoC;EACpC,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;;AAEA;AACA;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,sCAAsC;EACtC,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf","sourcesContent":["/* Generated on: Thu Jan 30 2020 12:02:03 GMT+0000 (Coordinated Universal Time) */\n/* ==========================================================================\n   normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css\n   ========================================================================== */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\n\n:root {\n  --grey-faint: #cbd5e0;\n  --grey-lighter: #cbd5e0;\n  --grey-background: #f7fafc;\n  --grey: #718096;\n}\n\nhtml {\n  font-family: sans-serif;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\nbody {\n  margin: 0;\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n[hidden],\ntemplate {\n  display: none;\n}\na {\n  background-color: transparent;\n}\na:active,\na:hover {\n  outline: 0;\n}\nabbr[title] {\n  border-bottom: 1px dotted;\n}\nb,\nstrong {\n  font-weight: bold;\n}\ndfn {\n  font-style: italic;\n}\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\nmark {\n  background: #ff0;\n  color: #000;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsup {\n  top: -0.5em;\n}\nsub {\n  bottom: -0.25em;\n}\nimg {\n  border: 0;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\nfigure {\n  margin: 1em 40px;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n}\npre {\n  overflow: auto;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbutton {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\ninput {\n  line-height: normal;\n}\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\ninput[type=\"search\"] {\n  -webkit-appearance: none;\n}\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\nlegend {\n  border: 0;\n  padding: 0;\n}\ntextarea {\n  overflow: auto;\n}\noptgroup {\n  font-weight: bold;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\ntd,\nth {\n  padding: 0;\n}\n\n/* ==========================================================================\n   Start of base Webflow CSS - If you're looking for some ultra-clean CSS, skip the boilerplate and see the unminified code below.\n   ========================================================================== */\n@font-face {\n  font-family: \"webflow-icons\";\n  src: url(\"data:application/x-font-ttf;charset=utf-8;base64,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\")\n    format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=\"w-icon-\"],\n[class*=\" w-icon-\"] {\n  font-family: \"webflow-icons\" !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.w-icon-slider-right:before {\n  content: \"\\e600\";\n}\n.w-icon-slider-left:before {\n  content: \"\\e601\";\n}\n.w-icon-nav-menu:before {\n  content: \"\\e602\";\n}\n.w-icon-arrow-down:before,\n.w-icon-dropdown-toggle:before {\n  content: \"\\e603\";\n}\n.w-icon-file-upload-remove:before {\n  content: \"\\e900\";\n}\n.w-icon-file-upload-icon:before {\n  content: \"\\e903\";\n}\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\nhtml {\n  height: 100%;\n}\nbody {\n  margin: 0;\n  min-height: 100%;\n  background-color: #fff;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: #333;\n}\nimg {\n  max-width: 100%;\n  vertical-align: middle;\n  display: inline-block;\n}\nhtml.w-mod-touch * {\n  background-attachment: scroll !important;\n}\n.w-block {\n  display: block;\n}\n.w-inline-block {\n  max-width: 100%;\n  display: inline-block;\n}\n.w-clearfix:before,\n.w-clearfix:after {\n  content: \" \";\n  display: table;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-column-end: 2;\n  grid-row-end: 2;\n}\n.w-clearfix:after {\n  clear: both;\n}\n.w-hidden {\n  display: none;\n}\n.w-button {\n  display: inline-block;\n  padding: 9px 15px;\n  background-color: #3898ec;\n  color: white;\n  border: 0;\n  line-height: inherit;\n  text-decoration: none;\n  cursor: pointer;\n  border-radius: 0;\n}\ninput.w-button {\n  -webkit-appearance: button;\n}\nhtml[data-w-dynpage] [data-w-cloak] {\n  color: transparent !important;\n}\n.w-webflow-badge,\n.w-webflow-badge * {\n  position: static;\n  left: auto;\n  top: auto;\n  right: auto;\n  bottom: auto;\n  z-index: auto;\n  display: block;\n  visibility: visible;\n  overflow: visible;\n  overflow-x: visible;\n  overflow-y: visible;\n  box-sizing: border-box;\n  width: auto;\n  height: auto;\n  max-height: none;\n  max-width: none;\n  min-height: 0;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  float: none;\n  clear: none;\n  border: 0 none transparent;\n  border-radius: 0;\n  background: none;\n  background-image: none;\n  background-position: 0 0;\n  background-size: auto auto;\n  background-repeat: repeat;\n  background-origin: padding-box;\n  background-clip: border-box;\n  background-attachment: scroll;\n  background-color: transparent;\n  box-shadow: none;\n  opacity: 1;\n  transform: none;\n  transition: none;\n  direction: ltr;\n  font-family: inherit;\n  font-weight: inherit;\n  color: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  font-style: inherit;\n  font-variant: inherit;\n  text-align: inherit;\n  letter-spacing: inherit;\n  text-decoration: inherit;\n  text-indent: 0;\n  text-transform: inherit;\n  list-style-type: disc;\n  text-shadow: none;\n  font-smoothing: auto;\n  vertical-align: baseline;\n  cursor: inherit;\n  white-space: inherit;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n}\n.w-webflow-badge {\n  position: fixed !important;\n  display: inline-block !important;\n  visibility: visible !important;\n  z-index: 2147483647 !important;\n  top: auto !important;\n  right: 12px !important;\n  bottom: 12px !important;\n  left: auto !important;\n  color: #aaadb0 !important;\n  background-color: #fff !important;\n  border-radius: 3px !important;\n  padding: 6px 8px 6px 6px !important;\n  font-size: 12px !important;\n  opacity: 1 !important;\n  line-height: 14px !important;\n  text-decoration: none !important;\n  transform: none !important;\n  margin: 0 !important;\n  width: auto !important;\n  height: auto !important;\n  overflow: visible !important;\n  white-space: nowrap;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n.w-webflow-badge > img {\n  display: inline-block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  vertical-align: middle !important;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: bold;\n  margin-bottom: 10px;\n}\nh1 {\n  font-size: 38px;\n  line-height: 44px;\n  margin-top: 20px;\n}\nh2 {\n  font-size: 32px;\n  line-height: 36px;\n  margin-top: 20px;\n}\nh3 {\n  font-size: 24px;\n  line-height: 30px;\n  margin-top: 20px;\n}\nh4 {\n  font-size: 18px;\n  line-height: 24px;\n  margin-top: 10px;\n}\nh5 {\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 10px;\n}\nh6 {\n  font-size: 12px;\n  line-height: 18px;\n  margin-top: 10px;\n}\np {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\nblockquote {\n  margin: 0 0 10px 0;\n  padding: 10px 20px;\n  border-left: 5px solid #e2e2e2;\n  font-size: 18px;\n  line-height: 22px;\n}\nfigure {\n  margin: 0;\n  margin-bottom: 10px;\n}\nfigcaption {\n  margin-top: 5px;\n  text-align: center;\n}\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px;\n  padding-left: 40px;\n}\n.w-list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n.w-embed:before,\n.w-embed:after {\n  content: \" \";\n  display: table;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-column-end: 2;\n  grid-row-end: 2;\n}\n.w-embed:after {\n  clear: both;\n}\n.w-video {\n  width: 100%;\n  position: relative;\n  padding: 0;\n}\n.w-video iframe,\n.w-video object,\n.w-video embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\nfieldset {\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"] {\n  border: 0;\n  cursor: pointer;\n  -webkit-appearance: button;\n}\n.w-form {\n  margin: 0 0 15px;\n}\n.w-form-done {\n  display: none;\n  padding: 20px;\n  text-align: center;\n  background-color: #dddddd;\n}\n.w-form-fail {\n  display: none;\n  margin-top: 10px;\n  padding: 10px;\n  background-color: #ffdede;\n}\nlabel {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.field-label-height {\n  margin-top: 67px;\n}\n.w-input,\n.w-select {\n  display: block;\n  width: 100%;\n  height: 38px;\n  padding: 8px 12px;\n  margin-bottom: 10px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #333333;\n  vertical-align: middle;\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n}\n.w-input:-moz-placeholder,\n.w-select:-moz-placeholder {\n  color: #999;\n}\n.w-input::-moz-placeholder,\n.w-select::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.w-input:-ms-input-placeholder,\n.w-select:-ms-input-placeholder {\n  color: #999;\n}\n.w-input::-webkit-input-placeholder,\n.w-select::-webkit-input-placeholder {\n  color: #999;\n}\n.w-input:focus,\n.w-select:focus {\n  border-color: #3898ec;\n  outline: 0;\n}\n.w-input[disabled],\n.w-select[disabled],\n.w-input[readonly],\n.w-select[readonly],\nfieldset[disabled] .w-input,\nfieldset[disabled] .w-select {\n  cursor: not-allowed;\n  background-color: #eeeeee;\n}\ntextarea.w-input,\ntextarea.w-select {\n  height: auto;\n}\n.w-select {\n  background-color: #f3f3f3;\n}\n.w-select[multiple] {\n  height: auto;\n}\n.w-form-label {\n  display: inline-block;\n  cursor: pointer;\n  font-weight: normal;\n  margin-bottom: 0;\n}\n.w-radio {\n  display: block;\n  margin-bottom: 5px;\n  padding-left: 20px;\n}\n.w-radio:before,\n.w-radio:after {\n  content: \" \";\n  display: table;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-column-end: 2;\n  grid-row-end: 2;\n}\n.w-radio:after {\n  clear: both;\n}\n.w-radio-input {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal;\n  float: left;\n  margin-left: -20px;\n}\n.w-radio-input {\n  margin-top: 3px;\n}\n.w-file-upload {\n  display: block;\n  margin-bottom: 10px;\n}\n.w-file-upload-input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -100;\n}\n.w-file-upload-default,\n.w-file-upload-uploading,\n.w-file-upload-success {\n  display: inline-block;\n  color: #333333;\n}\n.w-file-upload-error {\n  display: block;\n  margin-top: 10px;\n}\n.w-file-upload-default.w-hidden,\n.w-file-upload-uploading.w-hidden,\n.w-file-upload-error.w-hidden,\n.w-file-upload-success.w-hidden {\n  display: none;\n}\n.w-file-upload-uploading-btn {\n  display: flex;\n  font-size: 14px;\n  font-weight: normal;\n  cursor: pointer;\n  margin: 0;\n  padding: 8px 12px;\n  border: 1px solid #cccccc;\n  background-color: #fafafa;\n}\n.w-file-upload-file {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  margin: 0;\n  padding: 8px 9px 8px 11px;\n  border: 1px solid #cccccc;\n  background-color: #fafafa;\n}\n.w-file-upload-file-name {\n  font-size: 14px;\n  font-weight: normal;\n  display: block;\n}\n.w-file-remove-link {\n  margin-top: 3px;\n  margin-left: 10px;\n  width: auto;\n  height: auto;\n  padding: 3px;\n  display: block;\n  cursor: pointer;\n}\n.w-icon-file-upload-remove {\n  margin: auto;\n  font-size: 10px;\n}\n.w-file-upload-error-msg {\n  display: inline-block;\n  color: #ea384c;\n  padding: 2px 0;\n}\n.w-file-upload-info {\n  display: inline-block;\n  line-height: 38px;\n  padding: 0 12px;\n}\n.w-file-upload-label {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: normal;\n  cursor: pointer;\n  margin: 0;\n  padding: 8px 12px;\n  border: 1px solid #cccccc;\n  background-color: #fafafa;\n}\n.w-icon-file-upload-icon,\n.w-icon-file-upload-uploading {\n  display: inline-block;\n  margin-right: 8px;\n  width: 20px;\n}\n.w-icon-file-upload-uploading {\n  height: 20px;\n}\n.w-container {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 940px;\n}\n.w-container:before,\n.w-container:after {\n  content: \" \";\n  display: table;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-column-end: 2;\n  grid-row-end: 2;\n}\n.w-container:after {\n  clear: both;\n}\n.w-container .w-row {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n.w-row:before,\n.w-row:after {\n  content: \" \";\n  display: table;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-column-end: 2;\n  grid-row-end: 2;\n}\n.w-row:after {\n  clear: both;\n}\n.w-row .w-row {\n  margin-left: 0;\n  margin-right: 0;\n}\n.w-col {\n  position: relative;\n  float: left;\n  width: 100%;\n  min-height: 1px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.w-col .w-col {\n  padding-left: 0;\n  padding-right: 0;\n}\n.w-col-1 {\n  width: 8.33333333%;\n}\n.w-col-2 {\n  width: 16.66666667%;\n}\n.w-col-3 {\n  width: 25%;\n}\n.w-col-4 {\n  width: 33.33333333%;\n}\n.w-col-5 {\n  width: 41.66666667%;\n}\n.w-col-6 {\n  width: 50%;\n}\n.w-col-7 {\n  width: 58.33333333%;\n}\n.w-col-8 {\n  width: 66.66666667%;\n}\n.w-col-9 {\n  width: 75%;\n}\n.w-col-10 {\n  width: 83.33333333%;\n}\n.w-col-11 {\n  width: 91.66666667%;\n}\n.w-col-12 {\n  width: 100%;\n}\n.w-hidden-main {\n  display: none !important;\n}\n@media screen and (max-width: 991px) {\n  .w-container {\n    max-width: 728px;\n  }\n  .w-hidden-main {\n    display: inherit !important;\n  }\n  .w-hidden-medium {\n    display: none !important;\n  }\n  .w-col-medium-1 {\n    width: 8.33333333%;\n  }\n  .w-col-medium-2 {\n    width: 16.66666667%;\n  }\n  .w-col-medium-3 {\n    width: 25%;\n  }\n  .w-col-medium-4 {\n    width: 33.33333333%;\n  }\n  .w-col-medium-5 {\n    width: 41.66666667%;\n  }\n  .w-col-medium-6 {\n    width: 50%;\n  }\n  .w-col-medium-7 {\n    width: 58.33333333%;\n  }\n  .w-col-medium-8 {\n    width: 66.66666667%;\n  }\n  .w-col-medium-9 {\n    width: 75%;\n  }\n  .w-col-medium-10 {\n    width: 83.33333333%;\n  }\n  .w-col-medium-11 {\n    width: 91.66666667%;\n  }\n  .w-col-medium-12 {\n    width: 100%;\n  }\n  .w-col-stack {\n    width: 100%;\n    left: auto;\n    right: auto;\n  }\n}\n@media screen and (max-width: 767px) {\n  .w-hidden-main {\n    display: inherit !important;\n  }\n  .w-hidden-medium {\n    display: inherit !important;\n  }\n  .w-hidden-small {\n    display: none !important;\n  }\n  .w-row,\n  .w-container .w-row {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .w-col {\n    width: 100%;\n    left: auto;\n    right: auto;\n  }\n  .w-col-small-1 {\n    width: 8.33333333%;\n  }\n  .w-col-small-2 {\n    width: 16.66666667%;\n  }\n  .w-col-small-3 {\n    width: 25%;\n  }\n  .w-col-small-4 {\n    width: 33.33333333%;\n  }\n  .w-col-small-5 {\n    width: 41.66666667%;\n  }\n  .w-col-small-6 {\n    width: 50%;\n  }\n  .w-col-small-7 {\n    width: 58.33333333%;\n  }\n  .w-col-small-8 {\n    width: 66.66666667%;\n  }\n  .w-col-small-9 {\n    width: 75%;\n  }\n  .w-col-small-10 {\n    width: 83.33333333%;\n  }\n  .w-col-small-11 {\n    width: 91.66666667%;\n  }\n  .w-col-small-12 {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 479px) {\n  .w-container {\n    max-width: none;\n  }\n  .w-hidden-main {\n    display: inherit !important;\n  }\n  .w-hidden-medium {\n    display: inherit !important;\n  }\n  .w-hidden-small {\n    display: inherit !important;\n  }\n  .w-hidden-tiny {\n    display: none !important;\n  }\n  .w-col {\n    width: 100%;\n  }\n  .w-col-tiny-1 {\n    width: 8.33333333%;\n  }\n  .w-col-tiny-2 {\n    width: 16.66666667%;\n  }\n  .w-col-tiny-3 {\n    width: 25%;\n  }\n  .w-col-tiny-4 {\n    width: 33.33333333%;\n  }\n  .w-col-tiny-5 {\n    width: 41.66666667%;\n  }\n  .w-col-tiny-6 {\n    width: 50%;\n  }\n  .w-col-tiny-7 {\n    width: 58.33333333%;\n  }\n  .w-col-tiny-8 {\n    width: 66.66666667%;\n  }\n  .w-col-tiny-9 {\n    width: 75%;\n  }\n  .w-col-tiny-10 {\n    width: 83.33333333%;\n  }\n  .w-col-tiny-11 {\n    width: 91.66666667%;\n  }\n  .w-col-tiny-12 {\n    width: 100%;\n  }\n}\n.w-widget {\n  position: relative;\n}\n.w-widget-map {\n  width: 100%;\n  height: 400px;\n}\n.w-widget-map label {\n  width: auto;\n  display: inline;\n}\n.w-widget-map img {\n  max-width: inherit;\n}\n.w-widget-map .gm-style-iw {\n  text-align: center;\n}\n.w-widget-map .gm-style-iw > button {\n  display: none !important;\n}\n.w-widget-twitter {\n  overflow: hidden;\n}\n.w-widget-twitter-count-shim {\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  width: 28px;\n  height: 20px;\n  text-align: center;\n  background: white;\n  border: #758696 solid 1px;\n  border-radius: 3px;\n}\n.w-widget-twitter-count-shim * {\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.w-widget-twitter-count-shim .w-widget-twitter-count-inner {\n  position: relative;\n  font-size: 15px;\n  line-height: 12px;\n  text-align: center;\n  color: #999;\n  font-family: serif;\n}\n.w-widget-twitter-count-shim .w-widget-twitter-count-clear {\n  position: relative;\n  display: block;\n}\n.w-widget-twitter-count-shim.w--large {\n  width: 36px;\n  height: 28px;\n  margin-left: 7px;\n}\n.w-widget-twitter-count-shim.w--large .w-widget-twitter-count-inner {\n  font-size: 18px;\n  line-height: 18px;\n}\n.w-widget-twitter-count-shim:not(.w--vertical) {\n  margin-left: 5px;\n  margin-right: 8px;\n}\n.w-widget-twitter-count-shim:not(.w--vertical).w--large {\n  margin-left: 6px;\n}\n.w-widget-twitter-count-shim:not(.w--vertical):before,\n.w-widget-twitter-count-shim:not(.w--vertical):after {\n  top: 50%;\n  left: 0;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.w-widget-twitter-count-shim:not(.w--vertical):before {\n  border-color: rgba(117, 134, 150, 0);\n  border-right-color: #5d6c7b;\n  border-width: 4px;\n  margin-left: -9px;\n  margin-top: -4px;\n}\n.w-widget-twitter-count-shim:not(.w--vertical).w--large:before {\n  border-width: 5px;\n  margin-left: -10px;\n  margin-top: -5px;\n}\n.w-widget-twitter-count-shim:not(.w--vertical):after {\n  border-color: rgba(255, 255, 255, 0);\n  border-right-color: white;\n  border-width: 4px;\n  margin-left: -8px;\n  margin-top: -4px;\n}\n.w-widget-twitter-count-shim:not(.w--vertical).w--large:after {\n  border-width: 5px;\n  margin-left: -9px;\n  margin-top: -5px;\n}\n.w-widget-twitter-count-shim.w--vertical {\n  width: 61px;\n  height: 33px;\n  margin-bottom: 8px;\n}\n.w-widget-twitter-count-shim.w--vertical:before,\n.w-widget-twitter-count-shim.w--vertical:after {\n  top: 100%;\n  left: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.w-widget-twitter-count-shim.w--vertical:before {\n  border-color: rgba(117, 134, 150, 0);\n  border-top-color: #5d6c7b;\n  border-width: 5px;\n  margin-left: -5px;\n}\n.w-widget-twitter-count-shim.w--vertical:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-top-color: white;\n  border-width: 4px;\n  margin-left: -4px;\n}\n.w-widget-twitter-count-shim.w--vertical .w-widget-twitter-count-inner {\n  font-size: 18px;\n  line-height: 22px;\n}\n.w-widget-twitter-count-shim.w--vertical.w--large {\n  width: 76px;\n}\n.w-widget-gplus {\n  overflow: hidden;\n}\n.w-background-video {\n  position: relative;\n  overflow: hidden;\n  height: 500px;\n  color: white;\n}\n.w-background-video > video {\n  background-size: cover;\n  background-position: 50% 50%;\n  position: absolute;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  right: -100%;\n  bottom: -100%;\n  top: -100%;\n  left: -100%;\n  object-fit: cover;\n  z-index: -100;\n}\n.w-background-video > video::-webkit-media-controls-start-playback-button {\n  display: none !important;\n  -webkit-appearance: none;\n}\n.w-slider {\n  position: relative;\n  height: 300px;\n  text-align: center;\n  background: #dddddd;\n  clear: both;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.w-slider-mask {\n  position: relative;\n  display: block;\n  overflow: hidden;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  height: 100%;\n  white-space: nowrap;\n}\n.w-slide {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 100%;\n  height: 100%;\n  white-space: normal;\n  text-align: left;\n}\n.w-slider-nav {\n  position: absolute;\n  z-index: 2;\n  top: auto;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  padding-top: 10px;\n  height: 40px;\n  text-align: center;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.w-slider-nav.w-round > div {\n  border-radius: 100%;\n}\n.w-slider-nav.w-num > div {\n  width: auto;\n  height: auto;\n  padding: 0.2em 0.5em;\n  font-size: inherit;\n  line-height: inherit;\n}\n.w-slider-nav.w-shadow > div {\n  box-shadow: 0 0 3px rgba(51, 51, 51, 0.4);\n}\n.w-slider-nav-invert {\n  color: #fff;\n}\n.w-slider-nav-invert > div {\n  background-color: rgba(34, 34, 34, 0.4);\n}\n.w-slider-nav-invert > div.w-active {\n  background-color: #222;\n}\n.w-slider-dot {\n  position: relative;\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  background-color: rgba(255, 255, 255, 0.4);\n  cursor: pointer;\n  margin: 0 3px 0.5em;\n  transition: background-color 100ms, color 100ms;\n}\n.w-slider-dot.w-active {\n  background-color: #fff;\n}\n.w-slider-arrow-left,\n.w-slider-arrow-right {\n  position: absolute;\n  width: 80px;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  cursor: pointer;\n  overflow: hidden;\n  color: white;\n  font-size: 40px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.w-slider-arrow-left [class^=\"w-icon-\"],\n.w-slider-arrow-right [class^=\"w-icon-\"],\n.w-slider-arrow-left [class*=\" w-icon-\"],\n.w-slider-arrow-right [class*=\" w-icon-\"] {\n  position: absolute;\n}\n.w-slider-arrow-left {\n  z-index: 3;\n  right: auto;\n}\n.w-slider-arrow-right {\n  z-index: 4;\n  left: auto;\n}\n.w-icon-slider-left,\n.w-icon-slider-right {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  width: 1em;\n  height: 1em;\n}\n.w-dropdown {\n  display: inline-block;\n  position: relative;\n  text-align: left;\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 900;\n}\n.w-dropdown-btn,\n.w-dropdown-toggle,\n.w-dropdown-link {\n  position: relative;\n  vertical-align: top;\n  text-decoration: none;\n  color: #222222;\n  padding: 20px;\n  text-align: left;\n  margin-left: auto;\n  margin-right: auto;\n  white-space: nowrap;\n}\n.w-dropdown-toggle {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: inline-block;\n  cursor: pointer;\n  padding-right: 40px;\n}\n.w-icon-dropdown-toggle {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  margin-right: 20px;\n  width: 1em;\n  height: 1em;\n}\n.w-dropdown-list {\n  position: absolute;\n  background: #dddddd;\n  display: none;\n  min-width: 100%;\n}\n.w-dropdown-list.w--open {\n  display: block;\n}\n.w-dropdown-link {\n  padding: 10px 20px;\n  display: block;\n  color: #222222;\n}\n.w-dropdown-link.w--current {\n  color: #0082f3;\n}\n.question-skip-logic {\n  width: 510px;\n  word-wrap: break-word;\n}\n@media screen and (max-width: 767px) {\n  .w-nav-brand {\n    padding-left: 10px;\n  }\n}\n.w-lightbox-backdrop {\n  color: #000;\n  cursor: auto;\n  font-family: serif;\n  font-size: medium;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  letter-spacing: normal;\n  line-height: normal;\n  list-style: disc;\n  text-align: start;\n  text-indent: 0;\n  text-shadow: none;\n  text-transform: none;\n  visibility: visible;\n  white-space: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  color: #fff;\n  font-family: \"Helvetica Neue\", Helvetica, Ubuntu, \"Segoe UI\", Verdana,\n    sans-serif;\n  font-size: 17px;\n  line-height: 1.2;\n  font-weight: 300;\n  text-align: center;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: 2000;\n  outline: 0;\n  opacity: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-transform: translate(0, 0);\n}\n.w-lightbox-backdrop,\n.w-lightbox-container {\n  height: 100%;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.w-lightbox-content {\n  position: relative;\n  height: 100vh;\n  overflow: hidden;\n}\n.w-lightbox-view {\n  position: absolute;\n  width: 100vw;\n  height: 100vh;\n  opacity: 0;\n}\n.w-lightbox-view:before {\n  content: \"\";\n  height: 100vh;\n}\n.w-lightbox-group,\n.w-lightbox-group .w-lightbox-view,\n.w-lightbox-group .w-lightbox-view:before {\n  height: 86vh;\n}\n.w-lightbox-frame,\n.w-lightbox-view:before {\n  display: inline-block;\n  vertical-align: middle;\n}\n.w-lightbox-figure {\n  position: relative;\n  margin: 0;\n}\n.w-lightbox-group .w-lightbox-figure {\n  cursor: pointer;\n}\n.w-lightbox-img {\n  width: auto;\n  height: auto;\n  max-width: none;\n}\n.w-lightbox-image {\n  display: block;\n  float: none;\n  max-width: 100vw;\n  max-height: 100vh;\n}\n.w-lightbox-group .w-lightbox-image {\n  max-height: 86vh;\n}\n.w-lightbox-caption {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 0.5em 1em;\n  background: rgba(0, 0, 0, 0.4);\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.w-lightbox-embed {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.w-lightbox-control {\n  position: absolute;\n  top: 0;\n  width: 4em;\n  background-size: 24px;\n  background-repeat: no-repeat;\n  background-position: center;\n  cursor: pointer;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.w-lightbox-left {\n  display: none;\n  bottom: 0;\n  left: 0;\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0yMCAwIDI0IDQwIiB3aWR0aD0iMjQiIGhlaWdodD0iNDAiPjxnIHRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHBhdGggZD0ibTAgMGg1djIzaDIzdjVoLTI4eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDN2MjNoMjN2M2gtMjZ6IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==\");\n}\n.w-lightbox-right {\n  display: none;\n  right: 0;\n  bottom: 0;\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMjQgNDAiIHdpZHRoPSIyNCIgaGVpZ2h0PSI0MCI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMC0waDI4djI4aC01di0yM2gtMjN6IiBvcGFjaXR5PSIuNCIvPjxwYXRoIGQ9Im0xIDFoMjZ2MjZoLTN2LTIzaC0yM3oiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+\");\n}\n.w-lightbox-close {\n  right: 0;\n  height: 2.6em;\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMTggMTciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMCAwaDd2LTdoNXY3aDd2NWgtN3Y3aC01di03aC03eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDd2LTdoM3Y3aDd2M2gtN3Y3aC0zdi03aC03eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4=\");\n  background-size: 18px;\n}\n.w-lightbox-strip {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 0 1vh;\n  line-height: 0;\n  white-space: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.w-lightbox-item {\n  display: inline-block;\n  width: 10vh;\n  padding: 2vh 1vh;\n  box-sizing: content-box;\n  cursor: pointer;\n  -webkit-transform: translate3d(0, 0, 0);\n}\n.w-lightbox-active {\n  opacity: 0.3;\n}\n.w-lightbox-thumbnail {\n  position: relative;\n  height: 10vh;\n  background: #222;\n  overflow: hidden;\n}\n.w-lightbox-thumbnail-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.w-lightbox-thumbnail .w-lightbox-tall {\n  top: 50%;\n  width: 100%;\n  -webkit-transform: translate(0, -50%);\n  -ms-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n}\n.w-lightbox-thumbnail .w-lightbox-wide {\n  left: 50%;\n  height: 100%;\n  -webkit-transform: translate(-50%, 0);\n  -ms-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n}\n.w-lightbox-spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  box-sizing: border-box;\n  width: 40px;\n  height: 40px;\n  margin-top: -20px;\n  margin-left: -20px;\n  border: 5px solid rgba(0, 0, 0, 0.4);\n  border-radius: 50%;\n  -webkit-animation: spin 0.8s infinite linear;\n  animation: spin 0.8s infinite linear;\n}\n.w-lightbox-spinner:after {\n  content: \"\";\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  bottom: -4px;\n  left: -4px;\n  border: 3px solid transparent;\n  border-bottom-color: #fff;\n  border-radius: 50%;\n}\n.w-lightbox-hide {\n  display: none;\n}\n.w-lightbox-noscroll {\n  overflow: hidden;\n}\n@media (min-width: 768px) {\n  .w-lightbox-content {\n    height: 96vh;\n    margin-top: 2vh;\n  }\n  .w-lightbox-view,\n  .w-lightbox-view:before {\n    height: 96vh;\n  }\n  .w-lightbox-group,\n  .w-lightbox-group .w-lightbox-view,\n  .w-lightbox-group .w-lightbox-view:before {\n    height: 84vh;\n  }\n  .w-lightbox-image {\n    max-width: 96vw;\n    max-height: 96vh;\n  }\n  .w-lightbox-group .w-lightbox-image {\n    max-width: 82.3vw;\n    max-height: 84vh;\n  }\n  .w-lightbox-left,\n  .w-lightbox-right {\n    display: block;\n    opacity: 0.5;\n  }\n  .w-lightbox-close {\n    opacity: 0.8;\n  }\n  .w-lightbox-control:hover {\n    opacity: 1;\n  }\n}\n.w-lightbox-inactive,\n.w-lightbox-inactive:hover {\n  opacity: 0;\n}\n.w-richtext:before,\n.w-richtext:after {\n  content: \" \";\n  display: table;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-column-end: 2;\n  grid-row-end: 2;\n}\n.w-richtext:after {\n  clear: both;\n}\n.w-richtext[contenteditable=\"true\"]:before,\n.w-richtext[contenteditable=\"true\"]:after {\n  white-space: initial;\n}\n.w-richtext ol,\n.w-richtext ul {\n  overflow: hidden;\n}\n.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-video div:after,\n.w-richtext .w-richtext-figure-selected[data-rt-type=\"video\"] div:after {\n  outline: 2px solid #2895f7;\n}\n.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-image div,\n.w-richtext .w-richtext-figure-selected[data-rt-type=\"image\"] div {\n  outline: 2px solid #2895f7;\n}\n.w-richtext figure.w-richtext-figure-type-video > div:after,\n.w-richtext figure[data-rt-type=\"video\"] > div:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n.w-richtext figure {\n  position: relative;\n  max-width: 60%;\n}\n.w-richtext figure > div:before {\n  cursor: default !important;\n}\n.w-richtext figure img {\n  width: 100%;\n}\n.w-richtext figure figcaption.w-richtext-figcaption-placeholder {\n  opacity: 0.6;\n}\n.w-richtext figure div {\n  font-size: 0;\n  color: transparent;\n}\n.w-richtext figure.w-richtext-figure-type-image,\n.w-richtext figure[data-rt-type=\"image\"] {\n  display: table;\n}\n.w-richtext figure.w-richtext-figure-type-image > div,\n.w-richtext figure[data-rt-type=\"image\"] > div {\n  display: inline-block;\n}\n.w-richtext figure.w-richtext-figure-type-image > figcaption,\n.w-richtext figure[data-rt-type=\"image\"] > figcaption {\n  display: table-caption;\n  caption-side: bottom;\n}\n.w-richtext figure.w-richtext-figure-type-video,\n.w-richtext figure[data-rt-type=\"video\"] {\n  width: 60%;\n  height: 0;\n}\n.w-richtext figure.w-richtext-figure-type-video iframe,\n.w-richtext figure[data-rt-type=\"video\"] iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.w-richtext figure.w-richtext-figure-type-video > div,\n.w-richtext figure[data-rt-type=\"video\"] > div {\n  width: 100%;\n}\n.w-richtext figure.w-richtext-align-center {\n  margin-right: auto;\n  margin-left: auto;\n  clear: both;\n}\n.w-richtext figure.w-richtext-align-center.w-richtext-figure-type-image > div,\n.w-richtext figure.w-richtext-align-center[data-rt-type=\"image\"] > div {\n  max-width: 100%;\n}\n.w-richtext figure.w-richtext-align-normal {\n  clear: both;\n}\n.w-richtext figure.w-richtext-align-fullwidth {\n  width: 100%;\n  max-width: 100%;\n  text-align: center;\n  clear: both;\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n.w-richtext figure.w-richtext-align-fullwidth > div {\n  display: inline-block;\n  padding-bottom: inherit;\n}\n.w-richtext figure.w-richtext-align-fullwidth > figcaption {\n  display: block;\n}\n.w-richtext figure.w-richtext-align-floatleft {\n  float: left;\n  margin-right: 15px;\n  clear: none;\n}\n.w-richtext figure.w-richtext-align-floatright {\n  float: right;\n  margin-left: 15px;\n  clear: none;\n}\n.w-nav {\n  position: relative;\n  background: #dddddd;\n  z-index: 1000;\n}\n.w-nav:before,\n.w-nav:after {\n  content: \" \";\n  display: table;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-column-end: 2;\n  grid-row-end: 2;\n}\n.w-nav:after {\n  clear: both;\n}\n.w-nav-brand {\n  position: relative;\n  float: left;\n  text-decoration: none;\n  color: #333333;\n}\n.w-nav-link {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  text-decoration: none;\n  color: #222222;\n  padding: 20px;\n  text-align: left;\n  margin-left: auto;\n  margin-right: auto;\n}\n.w-nav-link.w--current {\n  color: #0082f3;\n}\n.w-nav-menu {\n  position: relative;\n  float: right;\n}\n.w--nav-menu-open {\n  display: block !important;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: #c8c8c8;\n  text-align: center;\n  overflow: visible;\n  min-width: 200px;\n}\n.w--nav-link-open {\n  display: block;\n  position: relative;\n}\n.w-nav-overlay {\n  position: absolute;\n  overflow: hidden;\n  display: none;\n  top: 100%;\n  left: 0;\n  right: 0;\n  width: 100%;\n}\n.w-nav-overlay .w--nav-menu-open {\n  top: 0;\n}\n.w-nav[data-animation=\"over-left\"] .w-nav-overlay {\n  width: auto;\n}\n.w-nav[data-animation=\"over-left\"] .w-nav-overlay,\n.w-nav[data-animation=\"over-left\"] .w--nav-menu-open {\n  right: auto;\n  z-index: 1;\n  top: 0;\n}\n.w-nav[data-animation=\"over-right\"] .w-nav-overlay {\n  width: auto;\n}\n.w-nav[data-animation=\"over-right\"] .w-nav-overlay,\n.w-nav[data-animation=\"over-right\"] .w--nav-menu-open {\n  left: auto;\n  z-index: 1;\n  top: 0;\n}\n.w-nav-button {\n  position: relative;\n  float: right;\n  padding: 18px;\n  font-size: 24px;\n  display: none;\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.w-nav-button.w--open {\n  background-color: #c8c8c8;\n  color: white;\n}\n.w-nav[data-collapse=\"all\"] .w-nav-menu {\n  display: none;\n}\n.w-nav[data-collapse=\"all\"] .w-nav-button {\n  display: block;\n}\n.w--nav-dropdown-open {\n  display: block;\n}\n.w--nav-dropdown-toggle-open {\n  display: block;\n}\n.w--nav-dropdown-list-open {\n  position: static;\n}\n@media screen and (max-width: 991px) {\n  .w-nav[data-collapse=\"medium\"] .w-nav-menu {\n    display: none;\n  }\n  .w-nav[data-collapse=\"medium\"] .w-nav-button {\n    display: block;\n  }\n}\n@media screen and (max-width: 767px) {\n  .w-nav[data-collapse=\"small\"] .w-nav-menu {\n    display: none;\n  }\n  .w-nav[data-collapse=\"small\"] .w-nav-button {\n    display: block;\n  }\n  .w-nav-brand {\n    padding-left: 10px;\n  }\n}\n@media screen and (max-width: 479px) {\n  .w-nav[data-collapse=\"tiny\"] .w-nav-menu {\n    display: none;\n  }\n  .w-nav[data-collapse=\"tiny\"] .w-nav-button {\n    display: block;\n  }\n}\n.w-tabs {\n  position: relative;\n}\n.w-tabs:before,\n.w-tabs:after {\n  content: \" \";\n  display: table;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-column-end: 2;\n  grid-row-end: 2;\n}\n.w-tabs:after {\n  clear: both;\n}\n.w-tab-menu {\n  position: relative;\n}\n.w-tab-link {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  text-decoration: none;\n  padding: 9px 30px;\n  text-align: left;\n  cursor: pointer;\n  color: #222222;\n  background-color: #dddddd;\n}\n.w-tab-link.w--current {\n  background-color: #c8c8c8;\n}\n.w-tab-content {\n  position: relative;\n  display: block;\n  overflow: hidden;\n}\n.w-tab-pane {\n  position: relative;\n  display: none;\n}\n.w--tab-active {\n  display: block;\n}\n@media screen and (max-width: 479px) {\n  .w-tab-link {\n    display: block;\n  }\n}\n.w-ix-emptyfix:after {\n  content: \"\";\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.w-dyn-empty {\n  padding: 10px;\n  background-color: #dddddd;\n}\n.w-dyn-hide {\n  display: none !important;\n}\n.w-dyn-bind-empty {\n  display: none !important;\n}\n.w-condition-invisible {\n  display: none !important;\n}\n\n/* ==========================================================================\n   Start of custom Webflow CSS\n   ========================================================================== */\n.w-checkbox {\n  display: block;\n  margin-bottom: 5px;\n  padding-left: 20px;\n}\n\n.w-checkbox::before {\n  content: \" \";\n  display: table;\n  -ms-grid-column-span: 1;\n  grid-column-end: 2;\n  -ms-grid-column: 1;\n  grid-column-start: 1;\n  -ms-grid-row-span: 1;\n  grid-row-end: 2;\n  -ms-grid-row: 1;\n  grid-row-start: 1;\n}\n\n.w-checkbox::after {\n  content: \" \";\n  display: table;\n  -ms-grid-column-span: 1;\n  grid-column-end: 2;\n  -ms-grid-column: 1;\n  grid-column-start: 1;\n  -ms-grid-row-span: 1;\n  grid-row-end: 2;\n  -ms-grid-row: 1;\n  grid-row-start: 1;\n  clear: both;\n}\n\n.w-checkbox-input {\n  float: left;\n  margin-bottom: 0px;\n  margin-left: -20px;\n  margin-right: 0px;\n  margin-top: 4px;\n  line-height: normal;\n}\n\n.w-checkbox-input--inputType-custom {\n  border-top-width: 1px;\n  border-bottom-width: 1px;\n  border-left-width: 1px;\n  border-right-width: 1px;\n  border-top-color: #ccc;\n  border-bottom-color: #ccc;\n  border-left-color: #ccc;\n  border-right-color: #ccc;\n  border-top-style: solid;\n  border-bottom-style: solid;\n  border-left-style: solid;\n  border-right-style: solid;\n  width: 12px;\n  height: 12px;\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n}\n\n.w-checkbox-input--inputType-custom.w--redirected-checked {\n  background-color: #3898ec;\n  border-top-color: #3898ec;\n  border-bottom-color: #3898ec;\n  border-left-color: #3898ec;\n  border-right-color: #3898ec;\n  background-image: url(https://d3e54v103j8qbb.cloudfront.net/static/custom-checkbox-checkmark.589d534424.svg);\n  background-position: 50% 50%;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.w-checkbox-input--inputType-custom.w--redirected-focus {\n  box-shadow: 0px 0px 3px 1px #3898ec;\n}\n\n.w-form-formradioinput--inputType-custom {\n  border-top-width: 1px;\n  border-bottom-width: 1px;\n  border-left-width: 1px;\n  border-right-width: 1px;\n  border-top-color: #ccc;\n  border-bottom-color: #ccc;\n  border-left-color: #ccc;\n  border-right-color: #ccc;\n  border-top-style: solid;\n  border-bottom-style: solid;\n  border-left-style: solid;\n  border-right-style: solid;\n  width: 12px;\n  height: 12px;\n  border-bottom-left-radius: 50%;\n  border-bottom-right-radius: 50%;\n  border-top-left-radius: 50%;\n  border-top-right-radius: 50%;\n}\n\n.w-form-formradioinput--inputType-custom.w--redirected-focus {\n  box-shadow: 0px 0px 3px 1px #3898ec;\n}\n\n.w-form-formradioinput--inputType-custom.w--redirected-checked {\n  border-top-width: 4px;\n  border-bottom-width: 4px;\n  border-left-width: 4px;\n  border-right-width: 4px;\n  border-top-color: #3898ec;\n  border-bottom-color: #3898ec;\n  border-left-color: #3898ec;\n  border-right-color: #3898ec;\n}\n\nbody {\n  background-color: #f7fafc;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  color: #2d3748;\n  font-size: 16px;\n  line-height: 160%;\n  cursor: default;\n}\n\nh1 {\n  margin-top: 16px;\n  margin-bottom: 8px;\n  font-size: 28px;\n  line-height: 120%;\n  font-weight: 400;\n}\n\nh2 {\n  max-width: 400px;\n  margin-top: 0px;\n  margin-bottom: 8px;\n  font-size: 20px;\n  line-height: 120%;\n  font-weight: 400;\n}\n\nh3 {\n  margin-top: 0px;\n  margin-bottom: 4px;\n  color: #718096;\n  font-size: 16px;\n  line-height: 120%;\n  font-weight: 400;\n}\n\nh4 {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  font-size: 16px;\n  line-height: 1.2em;\n  font-weight: 600;\n}\n\nh5 {\n  margin-top: 0px;\n  margin-bottom: 4px;\n  color: #718096;\n  font-size: 14px;\n  line-height: 1.2em;\n  font-weight: 400;\n}\n\nh6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 15px;\n  line-height: 1.2em;\n  font-weight: 400;\n}\n\np {\n  max-width: 600px;\n  margin-bottom: 0px;\n  line-height: 160%;\n}\n\na {\n  color: #320b85;\n  text-decoration: none;\n  cursor: pointer;\n}\n\nul {\n  margin-top: 0px;\n  margin-bottom: 10px;\n  padding-left: 40px;\n}\n\nimg {\n  display: inline-block;\n  max-width: 100%;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 4px;\n  color: #4a5568;\n  font-size: 14px;\n  line-height: 100%;\n  font-weight: 600;\n  text-align: left;\n}\n\nstrong {\n  font-weight: 600;\n}\n\nblockquote {\n  margin-bottom: 10px;\n  padding: 10px 20px;\n  border-left: 3px solid #ebebeb;\n  font-size: 19px;\n  line-height: 1.6em;\n}\n\nfigure {\n  margin-bottom: 10px;\n}\n\nfigcaption {\n  margin-top: 5px;\n  margin-bottom: 80px;\n  text-align: center;\n}\n\n.plan {\n  margin-bottom: 8px;\n  padding: 8px;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.plan.active {\n  border-color: #5f3dc4;\n}\n\n.project-hero-copy {\n  width: 50%;\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n\n.hero-headline {\n  font-size: 60px;\n  line-height: 1.1em;\n  font-weight: 400;\n}\n\n.style-guide-content {\n  padding-top: 40px;\n}\n\n.style-guide-label {\n  margin-top: 8px;\n  margin-bottom: 32px;\n  color: #1a202c;\n  font-size: 11px;\n  line-height: 11px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.style-guide-label.cc-box {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.style-guide-section {\n  position: relative;\n  margin: 16px;\n  padding: 64px 32px;\n  border-radius: 4px;\n  background-color: #fff;\n  box-shadow: 0 16px 64px 0 rgba(33, 37, 41, 0.2);\n}\n\n.body {\n  font-size: 15px;\n  line-height: 1.6em;\n}\n\n.button {\n  position: relative;\n  display: inline-block;\n  margin-top: 16px;\n  margin-bottom: 8px;\n  padding: 8px 16px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border: 2px solid transparent;\n  border-radius: 4px;\n  background-color: rgba(69, 23, 166, 0.1);\n  box-shadow: none;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  color: #320b85;\n  font-weight: 600;\n}\n\n.button:hover {\n  box-shadow: none;\n  -webkit-transform: translate(0px, -2px);\n  -ms-transform: translate(0px, -2px);\n  transform: translate(0px, -2px);\n}\n\n.button:active {\n  border-color: #320b85;\n}\n\n.button:focus {\n  z-index: 1;\n  border-color: rgba(69, 23, 166, 0.22);\n}\n\n.button.small {\n  margin-top: 8px;\n  padding: 4px 8px;\n  font-size: 14px;\n}\n\n.button.small.grouped.group-end.no-margin {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.button.small.subtle.with-icon {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.button.small.no-margin.move-left.subtle.is-icon {\n  width: auto;\n  height: auto;\n  padding: 2px;\n}\n\n.button.small.no-margin.move-left.positive.is-icon {\n  width: auto;\n  height: auto;\n  padding: 2px;\n}\n\n.button.small.no-margin.move-left.negative.is-icon {\n  width: auto;\n  height: auto;\n  padding: 2px;\n}\n\n.button.small.no-margin.subtle.is-icon {\n  width: auto;\n  height: auto;\n  padding: 2px;\n}\n\n.button.small.nudge-down.with-icon.disabled {\n  background-color: #f7fafc;\n  color: #718096;\n}\n\n.button.large {\n  padding: 16px 32px;\n  background-color: rgba(69, 23, 166, 0.1);\n  font-size: 20px;\n}\n\n.button.large.grouped.group-end.no-margin.white {\n  height: 52px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.button.default {\n  border-style: solid;\n  border-width: 2px;\n  border-color: #4517a6;\n  background-color: #fff;\n  box-shadow: none;\n  color: #320b85;\n  font-weight: 600;\n}\n\n.button.primary {\n  border-color: #4517a6;\n  background-color: #4517a6;\n  box-shadow: 0 8px 16px -4px rgba(69, 23, 166, 0.3);\n  color: #fff;\n}\n\n.button.primary:hover {\n  box-shadow: 0 12px 20px -4px rgba(156, 54, 181, 0.3);\n}\n\n.button.primary:focus {\n  border-color: #e37cff;\n}\n\n.button.primary.is-grouped {\n  position: relative;\n  box-shadow: none;\n}\n\n.button.primary.is-grouped.group-end.is-icon {\n  -webkit-transform: none;\n  -ms-transform: none;\n  transform: none;\n}\n\n.button.primary.black {\n  border-style: solid;\n  border-color: #1a202c;\n  background-color: #1a202c;\n  box-shadow: 0 8px 16px -4px rgba(33, 37, 41, 0.3);\n  color: #fff;\n}\n\n.button.primary.large {\n  margin-bottom: 16px;\n  box-shadow: 0 16px 32px -4px rgba(69, 23, 166, 0.3);\n}\n\n.button.primary.medium {\n  width: 164px;\n  text-align: center;\n}\n\n.button.subtle {\n  padding-right: 8px;\n  padding-left: 8px;\n  border-style: solid;\n  border-color: transparent;\n  background-color: transparent;\n  color: #320b85;\n}\n\n.button.subtle:hover {\n  background-color: rgba(69, 23, 166, 0.1);\n  -webkit-transform: none;\n  -ms-transform: none;\n  transform: none;\n}\n\n.button.subtle:focus {\n  border-style: solid;\n  border-color: rgba(69, 23, 166, 0.22);\n}\n\n.button.subtle.is-small {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  padding: 2px 2px 0px;\n  line-height: 140%;\n}\n\n.button.subtle.is-small.danger {\n  color: #c92a2a;\n}\n\n.button.subtle.is-small.danger:hover {\n  background-color: rgba(250, 82, 82, 0.2);\n}\n\n.button.subtle.is-small.push-left {\n  margin-right: 8px;\n}\n\n.button.subtle.is-small.warning {\n  color: #f76707;\n}\n\n.button.subtle.is-small.warning:hover {\n  background-color: rgba(255, 146, 43, 0.2);\n}\n\n.button.subtle.is-icon {\n  height: auto;\n}\n\n.button.subtle.is-icon.is-table-action {\n  position: absolute;\n  top: -3px;\n  right: 0px;\n}\n\n.button.subtle.small {\n  padding: 0px 4px;\n}\n\n.button.subtle.small.push-left {\n  margin-right: 8px;\n}\n\n.button.subtle.small.danger {\n  color: #c92a2a;\n}\n\n.button.subtle.small.danger:hover {\n  background-color: rgba(250, 82, 82, 0.2);\n}\n\n.button.subtle.small.warning {\n  color: #f76707;\n}\n\n.button.subtle.small.with-icon.black {\n  background-color: rgba(33, 37, 41, 0);\n  color: #2d3748;\n}\n\n.button.subtle.small.with-icon.black:hover {\n  background-color: #cbd5e0;\n}\n\n.button.subtle.small.with-icon.disabled {\n  color: #718096;\n}\n\n.button.subtle.with-icon.small {\n  padding-top: 2px;\n}\n\n.button.is-disabled {\n  border-color: #edf2f7;\n  background-color: #edf2f7;\n  -webkit-transition: none 0ms ease;\n  transition: none 0ms ease;\n  color: #718096;\n}\n\n.button.is-disabled:hover {\n  -webkit-transform: none;\n  -ms-transform: none;\n  transform: none;\n}\n\n.button.is-warning {\n  border-color: #ff922b;\n  background-color: #ff922b;\n  color: #1a202c;\n}\n\n.button.is-warning:active {\n  border-color: rgba(69, 23, 166, 0.22);\n}\n\n.button.is-warning:focus {\n  border-color: rgba(69, 23, 166, 0.22);\n}\n\n.button.danger {\n  border-color: #fa5252;\n  background-color: #fa5252;\n  color: #fff;\n}\n\n.button.danger:focus {\n  border-color: rgba(69, 23, 166, 0.22);\n}\n\n.button.danger.subtle {\n  border-color: transparent;\n  background-color: transparent;\n  color: #c92a2a;\n}\n\n.button.danger.subtle:hover {\n  background-color: rgba(250, 82, 82, 0.2);\n}\n.button.danger.subtle.padded.horizontal {\n  padding: 6px 16px;\n}\n\n.button.dropdown {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.button.with-object {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.button.with-object.is-subtle {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  background-color: transparent;\n}\n\n.button.with-object.is-subtle:hover {\n  -webkit-transform: none;\n  -ms-transform: none;\n  transform: none;\n}\n\n.button.with-object.is-subtle.no-spacing {\n  padding-right: 0px;\n  padding-left: 0px;\n}\n\n.button.with-object.is-subtle.muted {\n  color: #4a5568;\n}\n\n.button.with-object.subtle.is-icon.is-table-action {\n  position: static;\n  margin-top: -3px;\n  margin-bottom: 0px;\n}\n\n.button.wide {\n  width: 100%;\n  text-align: center;\n}\n\n.button.menu {\n  text-align: center;\n}\n\n.button.wide.with-icon.no-margin.small.subtle {\n  width: auto;\n}\n\n.button.grouped {\n  margin-right: 2px;\n  border-radius: 2px;\n}\n\n.button.grouped:hover {\n  opacity: 0.7;\n  -webkit-transform: none;\n  -ms-transform: none;\n  transform: none;\n}\n\n.button.grouped.group-lead {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.button.grouped.group-end {\n  margin-right: 0px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.button.grouped.primary {\n  box-shadow: none;\n}\n\n.button.grouped.expand {\n  text-align: center;\n}\n\n.button.is-icon {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 45px;\n  height: 45px;\n  padding: 0px;\n}\n\n.button.push-right {\n  margin-left: 16px;\n}\n\n.button.black {\n  border-style: none;\n  background-color: rgba(33, 37, 41, 0.1);\n  color: #2d3748;\n}\n\n.button.black.wide.no-margin {\n  background-color: #eeebf7;\n  color: #4517a6;\n}\n\n.button.black.wide.no-margin.throw-down {\n  margin-top: 32px;\n}\n\n.button.white {\n  border-style: none;\n  background-color: hsla(0, 0%, 100%, 0.1);\n  color: #fff;\n}\n\n.button.float-right {\n  float: right;\n}\n\n.button.float-left {\n  float: left;\n}\n\n.button.no-margin {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.button.no-margin.subtle.no-padding {\n  padding: 0px;\n}\n\n.button.no-margin.subtle.is-icon {\n  height: 45px;\n}\n\n.button.no-margin.subtle.is-icon.table-action {\n  position: absolute;\n  top: 50%;\n  right: 0px;\n  margin-top: -22.5px;\n}\n\n.button.no-margin.subtle.is-icon.table-action-icon {\n  width: 32px;\n  height: 16px;\n}\n\n.button.no-margin.subtle.is-icon.table-action-icon.anchor-top {\n  top: 0px;\n}\n\n.button.no-margin.subtle.is-icon.table-action-icon.auto-height {\n  height: auto;\n}\n\n.button.no-margin.move-right.align-center.no-shrink {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.button.no-margin.with-icon.disabled {\n  background-color: #f7fafc;\n  color: #718096;\n}\n\n.button.no-margin.move-down {\n  margin-top: 8px;\n}\n\n.button.tall {\n  height: 100%;\n}\n\n.button.no-padding {\n  padding: 0px;\n}\n\n.button.no-padding.subtle.with-icon.no-margin.black {\n  padding: 2px 4px;\n  background-color: transparent;\n}\n\n.button.no-padding.subtle.with-icon.small.black.no-margin.push-up {\n  margin-bottom: 16px;\n  padding: 0px;\n}\n\n.button.med-width {\n  padding-right: 64px;\n  padding-left: 64px;\n}\n\n.button.fill-height {\n  width: auto;\n}\n\n.button.pink {\n  background-color: rgba(230, 73, 128, 0.1);\n  color: #e64980;\n}\n\n.button.green {\n  background-color: rgba(130, 201, 30, 0.1);\n  color: #82c91e;\n}\n\n.button.blue {\n  background-color: rgba(77, 171, 247, 0.1);\n  color: #4dabf7;\n}\n\n.project-content {\n  display: block;\n}\n\n.project-content figure {\n  margin-top: 10px;\n  margin-bottom: 50px;\n}\n\n.project-content img {\n  display: block;\n}\n\n.project-hero-section {\n  padding-top: 60px;\n}\n\n.project-hero-container {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 90%;\n  max-width: 1000px;\n  margin-right: auto;\n  margin-left: auto;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.project-details-container {\n  display: block;\n  width: 90%;\n  max-width: 1000px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.project-services {\n  padding-left: 0px;\n}\n\n.project-services ul {\n  padding-left: 20px;\n  font-size: 14px;\n  line-height: 30px;\n  font-weight: 500;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.project-hero-logo {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50%;\n  padding: 60px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.navbar {\n  position: fixed;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 60px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  background-color: #f5f5f5;\n}\n\n.container-2 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 80%;\n  height: 100%;\n  max-width: 1000px;\n  margin-right: 0px;\n  margin-left: 0px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.back-button {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  float: left;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.body {\n  font-family: \"Proxima Nova\", sans-serif;\n  color: #2d3748;\n}\n\n.type-column-2 {\n  padding-top: 30px;\n  padding-left: 20px;\n}\n\n.type-column-1 {\n  padding-right: 20px;\n}\n\n.style-guide-title {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  display: inline-block;\n  margin-top: 0px;\n  padding-top: 16px;\n  padding-left: 28px;\n  color: #1a202c;\n  font-size: 22px;\n  line-height: 44px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.color-block {\n  height: 70px;\n  margin-top: 30px;\n  border-radius: 4px;\n  background-color: #ebebeb;\n}\n\n.color-block.cc-black {\n  background-color: #1a202c;\n}\n\n.color-block.cc-grey-dark {\n  background-color: #1a202c;\n}\n\n.color-block.cc-purple {\n  background-color: #4517a6;\n}\n\n.color-block.cc-purple.with-object-inside {\n  padding: 16px;\n}\n\n.color-block.cc-purple-dark {\n  background-color: #320b85;\n}\n\n.color-block.cc-purple-light {\n  background-color: rgba(69, 23, 166, 0.22);\n}\n\n.color-block.cc-brand-color-4 {\n  background-color: #f7fafc;\n}\n\n.color-block.cc-negative {\n  background-color: #fa5252;\n}\n\n.color-block.cc-neutral {\n  background-color: #fcc419;\n}\n\n.color-block.cc-dark-grey-1 {\n  background-color: #4a5568;\n}\n\n.color-block.cc-dark-grey-2 {\n  background-color: #2d3748;\n}\n\n.color-block.cc-grey {\n  background-color: #2d3748;\n}\n\n.color-block.cc-grey-light {\n  background-color: #4a5568;\n}\n\n.color-block.cc-grey-lighter {\n  background-color: #718096;\n}\n\n.color-block.cc-grey-faint {\n  background-color: #cbd5e0;\n}\n\n.color-block.cc-grey-background {\n  background-color: #f7fafc;\n}\n\n.color-block.cc-positive {\n  background-color: #40c057;\n}\n\n.color-block.cc-brand-color-1 {\n  background-color: #9775fa;\n}\n\n.color-block.cc-brand-color-2 {\n  background-color: #4dabf7;\n}\n\n.color-block.cc-brand-color-3 {\n  background-color: #38d9a9;\n}\n\n.color-block.cc-brand-color-4 {\n  background-color: #82c91e;\n}\n\n.color-block.cc-brand-color-5 {\n  background-color: #e64980;\n}\n\n.color-block.cc-purple-lighter {\n  background-color: rgba(69, 23, 166, 0.1);\n}\n\n.color-block.cc-important {\n  background-color: #ff922b;\n}\n\n.color-block.cc-violet {\n  background-color: #7950f2;\n}\n\n.color-block.cc-violet.with-object-inside {\n  padding: 16px;\n}\n\n.color-block.cc-grey-background-2 {\n  background-color: #edf2f7;\n}\n\n.color-block.cc-important-light {\n  background-color: rgba(255, 146, 43, 0.2);\n}\n\n.color-block.cc-important-dark {\n  background-color: #f76707;\n}\n\n.color-block.cc-positive-light {\n  background-color: rgba(64, 192, 87, 0.2);\n}\n\n.color-block.cc-positive-dark {\n  background-color: #2b8a3e;\n}\n\n.color-block.cc-neutral-light {\n  background-color: rgba(250, 176, 5, 0.2);\n}\n\n.color-block.cc-neutral-dark {\n  background-color: #e67700;\n}\n\n.color-block.cc-negative-light {\n  background-color: rgba(250, 82, 82, 0.2);\n}\n\n.color-block.cc-negative-dark {\n  background-color: #c92a2a;\n}\n\n.color-block.cc-grey-fade {\n  background-color: #e2e8f0;\n}\n\n.style-guide-title-section {\n  margin-bottom: 10px;\n}\n\n.subhead {\n  margin-top: 20px;\n  margin-bottom: 40px;\n  padding: 20px;\n  border-radius: 4px;\n  background-color: #edf2f7;\n  color: #2d3748;\n}\n\n.subhead.inverse {\n  background-color: #1a202c;\n  color: #718096;\n}\n\n.subhead.inverse.no-margin.move-down {\n  margin-top: 8px;\n}\n\n.subhead.inverse.no-margin.with-icon.nudge-down {\n  margin-top: 4px;\n}\n\n.subhead.no-margin.move-down {\n  margin-top: 8px;\n}\n\n.style-guide-label-column {\n  min-height: 44px;\n}\n\n.style-guide-wrap {\n  background-color: #f7fafc;\n}\n\n.style-guide-logo-box {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 40px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #cbd5e0;\n  border-radius: 4px;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f1e3dfef2d0_transparent.gif\");\n  background-position: 0px 0px;\n  background-size: 16px;\n}\n\n.style-guide-logo-box.cc-dark {\n  background-image: -webkit-gradient(\n      linear,\n      left top,\n      left bottom,\n      from(rgba(0, 0, 0, 0.5)),\n      to(rgba(0, 0, 0, 0.5))\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f1e3dfef2d0_transparent.gif\");\n  background-image: linear-gradient(\n      180deg,\n      rgba(0, 0, 0, 0.5),\n      rgba(0, 0, 0, 0.5)\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f1e3dfef2d0_transparent.gif\");\n  background-position: 0px 0px, 0px 0px;\n  background-size: auto, 16px;\n}\n\n.style-guide-logo-box.cc-light {\n  background-image: -webkit-gradient(\n      linear,\n      left top,\n      left bottom,\n      from(hsla(0, 0%, 100%, 0.5)),\n      to(hsla(0, 0%, 100%, 0.5))\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f1e3dfef2d0_transparent.gif\");\n  background-image: linear-gradient(\n      180deg,\n      hsla(0, 0%, 100%, 0.5),\n      hsla(0, 0%, 100%, 0.5)\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f1e3dfef2d0_transparent.gif\");\n  background-position: 0px 0px, 0px 0px;\n  background-size: auto, 16px;\n}\n\n.style-guide-logo-box.cc-white {\n  background-color: #fff;\n  background-image: none;\n  background-position: 0px 0px;\n  background-size: auto;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  margin-top: 16px;\n  margin-bottom: 8px;\n  background-color: #cbd5e0;\n}\n\n.divider.spacer {\n  width: 100%;\n  margin-top: 32px;\n  margin-bottom: 32px;\n}\n\n.divider.no-top-margin {\n  margin-top: 0px;\n}\n\n.divider.darker {\n  background-color: #2d3748;\n}\n\n.divider.no-margin.push-up {\n  margin-bottom: 16px;\n}\n\n.divider.no-margin.move-up {\n  margin-bottom: 8px;\n}\n\n.divider.push-up {\n  background-color: #e2e8f0;\n}\n\n.divider.push-up.in-sidebar {\n  margin-bottom: 16px;\n  background-color: #e8ddff;\n}\n\n.divider.in-sidebar {\n  margin-top: 32px;\n  margin-bottom: 32px;\n}\n\n.link {\n  display: block;\n  color: #320b85;\n}\n\n.link.inline.small {\n  font-size: 14px;\n}\n\n.style-guide-label-link {\n  display: inline-block;\n  font-size: 11px;\n  line-height: 11px;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.style-guide-label-link:hover {\n  text-decoration: underline;\n}\n\n.input {\n  height: 36px;\n  margin-bottom: 0px;\n  padding-right: 8px;\n  padding-left: 8px;\n  border-style: none;\n  border-width: 1px;\n  border-color: #718096;\n  border-radius: 4px;\n  background-color: #e2e8f0;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  color: #1a202c;\n  line-height: 100%;\n}\n\n.input.filter {\n  width: 19px;\n  height: 20px;\n  margin-left: 0px;\n  padding: 0px 2px;\n  background-color: #e4e0f1;\n  font-size: 12px;\n}\n\n.input.survey-search {\n  background-color: rgba(0, 0, 0, 0);\n  width: 240px;\n  height: auto;\n  padding-top: 8px;\n  font-size: 16px;\n}\n\n.input:hover {\n  border-color: #4a5568;\n  background-color: #cbd5e0;\n}\n\n.input:focus {\n  border-style: solid;\n  border-width: 2px;\n  border-color: #4517a6;\n  background-color: #fff;\n}\n\n.input::-webkit-input-placeholder {\n  color: #4a5568;\n}\n\n.input:-ms-input-placeholder {\n  color: #4a5568;\n}\n\n.input::-ms-input-placeholder {\n  color: #4a5568;\n}\n\n.input::placeholder {\n  color: #4a5568;\n}\n\n.input.cc-long {\n  height: auto;\n  min-height: 150px;\n  line-height: 24px;\n}\n\n.input.med {\n  max-width: 250px;\n}\n\n.input.small {\n  max-width: 120px;\n}\n\n.input.error {\n  border: 2px solid #ff922b;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f4f22fef2d3_Group.svg\");\n  background-position: 98% 4px;\n  background-size: 24px;\n  background-repeat: no-repeat;\n}\n\n.input.error:focus {\n  border-color: #4517a6;\n}\n\n.input.long {\n  max-width: 500px;\n}\n\n.input.textarea {\n  height: 100px;\n  max-width: 400px;\n}\n\n.input.textarea.tall {\n  height: 200px;\n}\n\n.input.textarea.large {\n  height: 120px;\n}\n\n.input.textarea.fill {\n  max-width: 100%;\n}\n\n.input.select {\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    -webkit-gradient(linear, left top, left bottom, from(#e2e8f0), to(#e2e8f0));\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    linear-gradient(180deg, #e2e8f0, #e2e8f0);\n  background-position: 98% 50%, 0px 0px;\n  background-size: 16px, auto;\n  background-repeat: no-repeat, repeat;\n}\n\n.input.select.large {\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    -webkit-gradient(linear, left top, left bottom, from(null), to(null));\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    linear-gradient(180deg, null, null);\n  background-size: 24px, auto;\n}\n\n.input.select.large.dark-bg {\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5d5564b2f5538359c0dad965_5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    -webkit-gradient(linear, left top, left bottom, from(transparent), to(transparent)),\n    -webkit-gradient(linear, left top, left bottom, from(#2d3748), to(#2d3748));\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5d5564b2f5538359c0dad965_5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    linear-gradient(180deg, transparent, transparent),\n    linear-gradient(180deg, #2d3748, #2d3748);\n  background-position: 98% 50%, 0px 0px, 0px 0px;\n  background-size: 24px, auto, auto;\n  background-repeat: no-repeat, repeat, repeat;\n}\n\n.input.large {\n  height: 52px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n  font-size: 16px;\n}\n\n.input.large.date-picker {\n  background-position: 98% 50%;\n  background-size: 24px;\n}\n\n.input.large.dark-bg {\n  background-color: #2d3748;\n  color: #fff;\n}\n\n.input.grouped {\n  margin-right: 4px;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n\n.input.date-picker {\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b617afc6d61a0044b9da687_calendar.svg\");\n  background-position: 99% 50%;\n  background-size: 16px;\n  background-repeat: no-repeat;\n}\n\n.input.disabled {\n  opacity: 0.4;\n}\n\n.input.disabled.large {\n  cursor: not-allowed;\n}\n\n.input.in-search {\n  height: auto;\n  padding-top: 12px;\n  background-color: transparent;\n  font-size: 12px;\n}\n\n.input.in-search:focus {\n  border-style: none;\n}\n\n.survey {\n  background-color: #fff !important;\n  border: solid 1px #cbd5e0;\n}\n\n.survey-search:hover {\n  border-color: #fff;\n  background-color: #fff;\n  border-radius: 7px;\n}\n\n.survey-search:focus {\n  border-color: #fff;\n  background-color: #fff;\n  border-radius: 7px;\n}\n\n.form-success {\n  background-color: #1cec88;\n  color: #1cec88;\n}\n\n.success-message {\n  border-radius: 4px;\n  background-color: rgba(32, 206, 123, 0.1);\n  color: #20ce7b;\n}\n\n.error-message {\n  border-radius: 4px;\n  background-color: rgba(236, 56, 114, 0.1);\n  color: #ec3872;\n  text-align: center;\n}\n\n.call-out {\n  padding: 8px;\n  border-radius: 8px;\n  background-color: #eeebf7;\n}\n\n.callout.move-down {\n  margin-top: 8px;\n}\n.callout {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  padding: 16px;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 4px;\n  background-color: rgba(76, 110, 245, 0.2);\n}\n\n.card {\n  margin-bottom: 16px;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  border-style: none;\n  border-width: 1px;\n  border-color: #cbd5e0;\n  border-radius: 4px;\n  background-color: #fff;\n  box-shadow: 0 16px 64px 0 rgba(33, 37, 41, 0.1);\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  text-decoration: none;\n}\n\n.card.horizontal {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card.horizontal.m-wrap {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card.horizontal.m-wrap.full-height {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.card.horizontal.m-wrap.expand {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.card.vertical {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card.active {\n  cursor: pointer;\n}\n\n.card.active:hover {\n  -webkit-transform: translate(0px, -4px);\n  -ms-transform: translate(0px, -4px);\n  transform: translate(0px, -4px);\n}\n\n.card.dark {\n  background-color: #1a202c;\n}\n\n.card.muted {\n  background-color: #cbd5e0;\n}\n\n.card.muted.active {\n  cursor: pointer;\n}\n\n.card.m-side-scroll.active {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n  cursor: pointer;\n}\n\n.card.m-side-scroll.active.flex {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card.m-side-scroll.active.full {\n  height: 100%;\n}\n\n.card.m-side-scroll.flex {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card.m-side-scroll.flex.full {\n  height: 100%;\n}\n\n.card.m-side-scroll.spaced {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card-title {\n  margin-top: 0px;\n}\n\n.card-paragraph {\n  margin-bottom: 0px;\n}\n\n.row {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: -8px;\n  margin-left: -8px;\n  padding-right: 8px;\n  padding-left: 8px;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  border-radius: 4px;\n  background-color: transparent;\n}\n\n.row.right {\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.row.spaced {\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.row.spaced.align-bottom {\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n\n.row.spaced.baseline {\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n}\n\n.row.in-card {\n  margin-bottom: 0px;\n}\n\n.row.center {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.row.center.spaced.push-up {\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.row.center.no-padding.push-up.spaced.bottom {\n  padding-right: 16px;\n  padding-left: 16px;\n}\n\n.row.center.no-padding.push-up.spaced.bottom-fill {\n  width: 100%;\n  padding-right: 16px;\n  padding-left: 16px;\n}\n\n.row.center.no-padding.push-up.spaced.bottom-fill.no-margin.push-up {\n  margin-bottom: 16px;\n}\n\n.row.has-cards {\n  margin-right: -16px;\n  margin-left: -16px;\n  -webkit-box-align: stretch;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.row.has-cards.move-down.align-top {\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.row.has-cards.align-top {\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.row.has-cards._80 {\n  width: 80%;\n}\n\n.row.has-cards._80.push-right {\n  margin-left: -8px;\n}\n\n.row.has-cards.wrap {\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.row.has-cards.wrap.sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 32px;\n}\n\n.row.has-cards.wrap.stretch {\n  -webkit-box-align: stretch;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.row.stretch {\n  -webkit-box-align: stretch;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.row.baseline {\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n}\n\n.row.expand {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.row.expand.align-end {\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.row.no-margin {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n\n.row.details {\n  padding-bottom: 32px;\n}\n\n.row.push-down.full {\n  width: 100%;\n}\n\n.row.align-right {\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.card-wrap {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 50%;\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n}\n\n.tab-pane {\n  padding: 30px 40px 40px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.tab-link {\n  margin-right: 10px;\n  margin-left: 10px;\n  padding-right: 5px;\n  padding-left: 5px;\n  background-color: transparent;\n  color: #1a202c;\n}\n\n.tab-link:hover {\n  color: #1a202c;\n}\n\n.tab-link.w--current {\n  border-bottom: 2px solid #4517a6;\n  background-color: transparent;\n  box-shadow: inset 0 -1px 0 0 #2d3748;\n  color: #320b85;\n}\n\n.tab-menu {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding-right: 0px;\n  padding-left: 0px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.tabs {\n  border-radius: 4px;\n}\n\n.data {\n  position: relative;\n  z-index: 1;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  color: #1a202c;\n  font-size: 20px;\n  line-height: 120%;\n  font-weight: 600;\n}\n\n.data.huge {\n  font-size: 36px;\n}\n\n.data.huge.no-margin {\n  margin-bottom: 0px;\n}\n\n.data.huge.violet {\n  color: #5f3dc4;\n}\n\n.data.small {\n  font-size: 16px;\n  line-height: 140%;\n}\n\n.data.small.white-text {\n  color: #fff;\n}\n\n.data.small.fill {\n  max-width: 100%;\n}\n\n.data.large {\n  font-size: 28px;\n}\n\n.data.tiny {\n  font-size: 14px;\n}\n\n.data.positive {\n  color: #2b8a3e;\n}\n\n.data.neutral {\n  color: #e67700;\n}\n\n.data.negative {\n  color: #c92a2a;\n}\n\n.data.brand-1 {\n  color: #9775fa;\n}\n\n.data.brand-2 {\n  height: auto;\n  margin-top: 0px;\n  margin-left: 0px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  background-image: none;\n  background-size: auto;\n  background-repeat: repeat;\n  color: #4dabf7;\n}\n\n.data.brand-3 {\n  color: #38d9a9;\n}\n\n.data.white-text.large.primary {\n  color: #4517a6;\n}\n\n.data.option-1 {\n  color: #9775fa;\n}\n\n.data.micro {\n  font-size: 12px;\n}\n\n.data.positive-2 {\n  color: #364fc7;\n}\n\n.data.violet-text.muted {\n  opacity: 0.6;\n}\n\n.bold-text {\n  color: #1a202c;\n}\n\n.avatar {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 40px;\n  height: 40px;\n  padding-top: 2px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  border-radius: 100%;\n  background-color: rgba(69, 23, 166, 0.1);\n  color: #320b85;\n  font-size: 20px;\n  line-height: 100%;\n}\n\n.avatar.large {\n  width: 60px;\n  height: 60px;\n  font-size: 24px;\n}\n\n.avatar.huge {\n  width: 100px;\n  height: 100px;\n  padding-top: 4px;\n  font-size: 32px;\n}\n\n.avatar.with-picture {\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1fd400fef2dc_Screen%20Shot%202018-06-24%20at%208.24.20%20PM.png\");\n  background-position: 50% 50%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  color: transparent;\n}\n\n.avatar.with-picture.visa {\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b9cf129e60a716bbf6c755c_instantlogosearch-visa.png\");\n}\n\n.avatar.with-picture.move-left.positive {\n  box-shadow: 0 0 0 2px #4c6ef5;\n}\n\n.avatar.with-picture.move-left.negative {\n  box-shadow: 0 0 0 2px #fa5252;\n}\n\n.avatar.with-picture.kemdi {\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da7abf73e54880be5d6cd81_download-21.png\");\n}\n\n.avatar.small {\n  width: 24px;\n  height: 24px;\n}\n\n.avatar.small.twitter-logo {\n  background-color: #cbd5e0;\n  background-image: -webkit-gradient(\n      linear,\n      left top,\n      left bottom,\n      from(rgba(222, 226, 230, 0.4)),\n      to(rgba(222, 226, 230, 0.4))\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b605f007803b544df4340b1_twitter.svg\");\n  background-image: linear-gradient(\n      180deg,\n      rgba(222, 226, 230, 0.4),\n      rgba(222, 226, 230, 0.4)\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b605f007803b544df4340b1_twitter.svg\");\n  background-position: 0px 0px, 50% 58%;\n  background-size: auto, 16px;\n  background-repeat: repeat, no-repeat;\n  color: transparent;\n}\n\n.avatar.small.news-icon {\n  background-color: #cbd5e0;\n  background-image: -webkit-gradient(\n      linear,\n      left top,\n      left bottom,\n      from(rgba(222, 226, 230, 0.4)),\n      to(rgba(222, 226, 230, 0.4))\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b6058e8d9b73f4d48b557b1_file-text.svg\");\n  background-image: linear-gradient(\n      180deg,\n      rgba(222, 226, 230, 0.4),\n      rgba(222, 226, 230, 0.4)\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b6058e8d9b73f4d48b557b1_file-text.svg\");\n  background-position: 0px 0px, 50% 50%;\n  background-size: auto, 16px;\n  background-repeat: repeat, no-repeat;\n  color: transparent;\n}\n\n.avatar.small.other-icon {\n  background-color: #cbd5e0;\n  background-image: -webkit-gradient(\n      linear,\n      left top,\n      left bottom,\n      from(rgba(222, 226, 230, 0.4)),\n      to(rgba(222, 226, 230, 0.4))\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b6059a6bb5a83e0672518c4_globe.svg\");\n  background-image: linear-gradient(\n      180deg,\n      rgba(222, 226, 230, 0.4),\n      rgba(222, 226, 230, 0.4)\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b6059a6bb5a83e0672518c4_globe.svg\");\n  background-position: 0px 0px, 50% 50%;\n  background-size: auto, 18px;\n  background-repeat: repeat, no-repeat;\n  color: transparent;\n}\n\n.avatar.small.facebook-logo {\n  background-color: #cbd5e0;\n  background-image: -webkit-gradient(\n      linear,\n      left top,\n      left bottom,\n      from(rgba(222, 226, 230, 0.4)),\n      to(rgba(222, 226, 230, 0.4))\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b605efe8b62147bc7f8294a_facebook%20(1).svg\");\n  background-image: linear-gradient(\n      180deg,\n      rgba(222, 226, 230, 0.4),\n      rgba(222, 226, 230, 0.4)\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b605efe8b62147bc7f8294a_facebook%20(1).svg\");\n  background-position: 0px 0px, 50% 50%;\n  background-size: auto, 16px;\n  background-repeat: repeat, no-repeat;\n  color: transparent;\n}\n\n.avatar.small.instagram-logo {\n  background-color: #cbd5e0;\n  background-image: -webkit-gradient(\n      linear,\n      left top,\n      left bottom,\n      from(rgba(222, 226, 230, 0.4)),\n      to(rgba(222, 226, 230, 0.4))\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b605efe71d5d24664553498_instagram.svg\");\n  background-image: linear-gradient(\n      180deg,\n      rgba(222, 226, 230, 0.4),\n      rgba(222, 226, 230, 0.4)\n    ),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b605efe71d5d24664553498_instagram.svg\");\n  background-position: 0px 0px, 50% 50%;\n  background-size: auto, 16px;\n  background-repeat: repeat, no-repeat;\n  color: transparent;\n}\n\n.avatar.alpha {\n  background-color: #4c6ef5;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da7a2b8c8514314bfbb8aae_%CE%B1.svg\");\n  background-position: 0px 0px;\n  background-size: contain;\n}\n\n.avatar img {\n  border-radius: 50%;\n}\n\n.avatar img.positive {\n  box-shadow: 0 0 0 2px #4c6ef5;\n}\n\n.avatar img.negative {\n  box-shadow: 0 0 0 2px #fa5252;\n}\n\n.banner {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  padding: 16px 32px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  background-color: #4517a6;\n  background-image: linear-gradient(135deg, #4517a6, #7950f2);\n  color: #fff;\n  text-align: center;\n}\n\n.banner.error {\n  background-color: #fa5252;\n  background-image: none;\n  color: #fff;\n}\n\n.banner.warning {\n  background-color: #ff922b;\n  background-image: none;\n  color: #1a202c;\n}\n\n.banner.important {\n  background-color: rgba(255, 146, 43, 0.2);\n  background-image: none;\n}\n\n.badge {\n  display: inline-block;\n  padding: 3px 8px 2px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 20px;\n  background-color: #cbd5e0;\n  color: #1a202c;\n  font-size: 14px;\n  line-height: 100%;\n  font-weight: 600;\n}\n\n.badge.bold {\n  background-color: #4517a6;\n  color: #fff;\n}\n\n.badge.white {\n  background-color: #fff;\n  color: #320b85;\n}\n\n.badge.important {\n  background-color: #ff922b;\n  color: #fff;\n}\n\n.badge.push-right {\n  margin-left: 8px;\n}\n\n.badge.in-nav {\n  margin-right: 16px;\n}\n\n.in-banner {\n  margin-left: 16px;\n  color: #fff;\n}\n\n.banner-action {\n  margin-left: 16px;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  opacity: 0.6;\n  -webkit-transform: none;\n  -ms-transform: none;\n  transform: none;\n}\n\n.icon.push-left {\n  margin-right: 8px;\n}\n\n.icon.move-left.orange {\n  opacity: 1;\n  color: #e67700;\n}\n\n.icon.push-right {\n  margin-left: 8px;\n}\n\n.icon.green {\n  opacity: 1;\n  color: #40c057;\n}\n\n.icon.black {\n  color: #1a202c;\n}\n\n.icon.white {\n  color: #fff;\n}\n\n.icon.important {\n  opacity: 1;\n  color: #ff922b;\n}\n\n.icon.is-dropdown {\n  border-radius: 24px;\n  -webkit-transition: background-color 250ms ease;\n  transition: background-color 250ms ease;\n  cursor: pointer;\n}\n\n.icon.is-dropdown:hover {\n  background-color: rgba(33, 37, 41, 0.2);\n}\n\n.icon.loading {\n  display: inline-block;\n}\n\n.icon.close {\n  display: block;\n  width: 32px;\n  height: 32px;\n  padding: 4px;\n  border-radius: 100px;\n  -webkit-transform: translate(0px, -4px);\n  -ms-transform: translate(0px, -4px);\n  transform: translate(0px, -4px);\n  -webkit-transition: background-color 250ms ease;\n  transition: background-color 250ms ease;\n  cursor: pointer;\n}\n\n.icon.close:hover {\n  background-color: hsla(0, 0%, 100%, 0.2);\n}\n\n.icon.small {\n  width: 16px;\n  height: 16px;\n}\n\n.icon.small.source-icon {\n  width: 20px;\n  height: 20px;\n  padding: 2px;\n  border-radius: 20px;\n  background-color: #cbd5e0;\n}\n\n.icon.small.nudge-right.active {\n  cursor: pointer;\n}\n\n.icon.nudge-right.purple {\n  color: #4517a6;\n}\n\n.icon.source-icon {\n  padding: 4px;\n  border-radius: 4px;\n  background-color: #cbd5e0;\n  color: #1a202c;\n}\n\n.icon.source-icon.in-baseline-row {\n  -webkit-transform: translate(0px, 4px);\n  -ms-transform: translate(0px, 4px);\n  transform: translate(0px, 4px);\n}\n\n.icon.source-icon.in-baseline-row.move-left.negative {\n  background-color: rgba(250, 82, 82, 0.2);\n  color: #c92a2a;\n}\n\n.icon.source-icon.in-baseline-row.move-left.positive {\n  background-color: rgba(76, 110, 245, 0.2);\n  color: #364fc7;\n}\n\n.icon.primary.move-left.move-up {\n  -webkit-transform: translate(0px, -1px);\n  -ms-transform: translate(0px, -1px);\n  transform: translate(0px, -1px);\n}\n\n.icon.in-input {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  margin-top: 34px;\n  margin-right: 8px;\n}\n\n.icon.danger {\n  color: #c92a2a;\n}\n\n.icon.danger:hover {\n  background-color: rgba(250, 82, 82, 0.2);\n}\n\n.icon.large {\n  width: 52px;\n  height: 52px;\n  padding: 12px;\n  border-radius: 50%;\n  background-color: rgba(69, 23, 166, 0.22);\n  color: #320b85;\n}\n\n.icon.large.move-down.green {\n  background-color: rgba(64, 192, 87, 0.2);\n  color: #2b8a3e;\n}\n\n.icon.large.green {\n  background-color: rgba(64, 192, 87, 0.2);\n  color: #2b8a3e;\n}\n\n.icon.large.positive {\n  background-color: rgba(76, 110, 245, 0.2);\n  color: #4c6ef5;\n}\n\n.icon.large.positive.move-left {\n  opacity: 1;\n}\n\n.icon.large.neutral {\n  background-color: #cbd5e0;\n  color: #4a5568;\n}\n\n.icon.large.neutral.move-left {\n  opacity: 1;\n}\n\n.icon.large.negative {\n  background-color: rgba(250, 82, 82, 0.2);\n  color: #fa5252;\n}\n\n.icon.large.negative.move-left {\n  opacity: 1;\n}\n\n.icon.positive-2 {\n  color: #364fc7;\n}\n\n.icon.purple {\n  color: #4517a6;\n}\n\n.icon.purple.med {\n  display: block;\n  width: 20px;\n  height: 20px;\n}\n\n.checkbox {\n  margin-top: 0px;\n  -webkit-filter: hue-rotate(20deg);\n  filter: hue-rotate(20deg);\n}\n\n.radio {\n  -webkit-filter: hue-rotate(66deg);\n  filter: hue-rotate(66deg);\n}\n\n.dropdown-list {\n  position: absolute;\n  left: 0px;\n  top: 110%;\n  z-index: 900;\n  display: none;\n  overflow: scroll;\n  width: 160px;\n  max-height: 90vh;\n  padding: 8px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-radius: 4px;\n  background-color: #fff;\n  box-shadow: 0 16px 32px 0 rgba(33, 37, 41, 0.2);\n}\n\n.dropdown-list.w--open {\n  top: 100%;\n  right: 0px;\n  display: block;\n  overflow: scroll;\n  max-height: 80vh;\n  padding: 8px;\n  background-color: #fff;\n  box-shadow: 0 16px 32px 0 rgba(52, 58, 64, 0.1);\n}\n\n.dropdown-list.align-top {\n  top: auto;\n  bottom: 110%;\n}\n\n.dropdown-list.align-right {\n  left: auto;\n  right: 0px;\n  display: none;\n}\n\n.dropdown-list.align-right.w--open {\n  top: 100%;\n  right: 0px;\n}\n\n.dropdown-list.dropdown-right {\n  left: auto;\n  right: 0px;\n}\n\n.dropdown-list.dropdown-right.small {\n  display: none;\n  width: 120px;\n}\n\n.dropdown-list.dropdown-right.small.anchor-left {\n  left: 0%;\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  width: auto;\n  white-space: nowrap;\n  overflow: visible;\n}\n\n.dropdown-list.small {\n  width: 80px;\n}\n\n.dropdown-list.medium {\n  display: none;\n  width: 260px;\n}\n\n.dropdown-list.temp {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.dropdown-link {\n  margin-bottom: 0px;\n  padding: 8px;\n  border-radius: 4px;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  color: #320b85;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.dropdown-link:hover {\n  background-color: rgba(69, 23, 166, 0.1);\n}\n\n.dropdown-link.w--current {\n  background-color: rgba(69, 23, 166, 0.1);\n  color: #320b85;\n}\n\n.dropdown-link.active {\n  background-color: rgba(69, 23, 166, 0.1);\n}\n\n.has-group {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n  margin-right: 0px;\n  margin-left: 0px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.dropdown.more-action {\n  position: absolute;\n  top: 50%;\n  right: 0px;\n  z-index: 0;\n  margin-top: -12px;\n}\n\n.dropdown.push-left {\n  margin-right: 8px;\n}\n\n.dropdown.user-actions {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.dropdown.move-left.table-action {\n  position: absolute;\n  top: 50%;\n  right: 0px;\n  height: 32px;\n  margin-top: -16px;\n  margin-right: 0px;\n}\n\n.dropdown.table-action {\n  position: absolute;\n  top: 50%;\n  right: 0px;\n  margin-top: -8px;\n}\n\n.dropdown.table-action.anchor-top {\n  top: 20px;\n}\n\n.toast {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  max-width: 360px;\n  margin-bottom: 8px;\n  padding: 16px;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  border-style: none;\n  border-width: 1px;\n  border-color: #cbd5e0;\n  border-radius: 4px;\n  background-color: #1a202c;\n  box-shadow: 0 32px 32px -8px rgba(52, 58, 64, 0.1),\n    0 0 64px 0 rgba(33, 37, 41, 0.1);\n  color: #f7fafc;\n}\n\n.toast.warning {\n  border-color: #ff922b;\n  background-color: #ff922b;\n  box-shadow: 0 32px 32px -8px rgba(52, 58, 64, 0.1),\n    0 0 64px 0 rgba(33, 37, 41, 0.1);\n  color: #1a202c;\n}\n\n.toast.warning.dropdown {\n  max-width: 100%;\n}\n\n.toast.danger {\n  border-color: #fa5252;\n  background-color: #fa5252;\n  box-shadow: 0 32px 32px -8px rgba(52, 58, 64, 0.1),\n    0 0 64px 0 rgba(33, 37, 41, 0.1);\n  color: #fff;\n}\n\n.toast.with-dropdown-content {\n  max-width: 100%;\n}\n\n.message-content {\n  overflow: hidden;\n  margin-left: 16px;\n  padding-top: 4px;\n  padding-right: 16px;\n}\n\n.bold {\n  color: #1a202c;\n  font-weight: 600;\n}\n\n.push-down {\n  margin-top: 16px;\n}\n\n.push-down.button.primary.facebook {\n  border-color: #4f69a8;\n  background-color: #4f69a8;\n  box-shadow: none;\n}\n\n.push-down.button.primary.large.facebook {\n  border-color: #3b5998;\n  background-color: #3b5998;\n}\n\n.push-down._50-width {\n  width: 50%;\n  max-width: 50%;\n}\n\n.push-down._50-width.pad {\n  padding-left: 8px;\n}\n\n.dropdown-content {\n  overflow: hidden;\n  margin-left: 16px;\n  padding-top: 4px;\n  padding-right: 16px;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.floating-header {\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  padding-top: 0px;\n  padding-right: 16px;\n}\n\n.dropdown-header {\n  margin-top: 16px;\n  padding-left: 8px;\n  color: #4a5568;\n  font-size: 14px;\n}\n\n.dropdown-trigger {\n  height: 24px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  border-radius: 24px;\n  -webkit-transition: background-color 250ms ease;\n  transition: background-color 250ms ease;\n  cursor: pointer;\n}\n\n.dropdown-trigger:hover {\n  background-color: hsla(0, 0%, 100%, 0.2);\n}\n\n.toast-container {\n  position: fixed;\n  left: 80px;\n  bottom: 0px;\n  z-index: 900;\n  display: none;\n  width: 420px;\n  padding-bottom: 16px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  -webkit-box-align: stretch;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.toasty {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 16px;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.toast-wrapper {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n  max-width: 360px;\n  margin-right: 8px;\n  margin-bottom: 0px;\n  margin-left: 8px;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  border-style: none;\n  border-width: 1px;\n  border-color: #cbd5e0;\n  border-radius: 4px;\n  background-color: transparent;\n  box-shadow: 0 32px 32px -8px rgba(52, 58, 64, 0.1),\n    0 0 64px 0 rgba(33, 37, 41, 0.1);\n}\n\n.toast-wrapper.warning {\n  border-color: #ff922b;\n  background-color: #ff922b;\n  box-shadow: 0 32px 32px -8px rgba(255, 146, 43, 0.2);\n  color: #1a202c;\n}\n\n.toast-wrapper.warning.dropdown {\n  max-width: 100%;\n}\n\n.toast-wrapper.danger {\n  border-color: #fa5252;\n  background-color: #fa5252;\n  box-shadow: 0 32px 32px -8px rgba(250, 82, 82, 0.2);\n  color: #fff;\n}\n\n.toast-wrapper.with-dropdown-content {\n  max-width: 100%;\n}\n\n.toast-wrapper.dropdown-wrapper {\n  max-width: 100%;\n}\n\n.inline-message {\n  position: relative;\n  display: inline-block;\n}\n\n.inline-message-content {\n  position: absolute;\n  left: 0px;\n  top: 100%;\n  z-index: 10;\n  display: none;\n  overflow: hidden;\n  width: 300px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #cbd5e0;\n  border-radius: 4px;\n  background-color: #fff;\n  box-shadow: 0 16px 32px -8px rgba(33, 37, 41, 0.2);\n  font-size: 14px;\n}\n\n.inline-message-content.sentiment-message {\n  left: 50%;\n  top: 120%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: auto;\n  margin-left: -70px;\n}\n\n.inline-message-content.small {\n  width: auto;\n}\n\n.inline-message-content.top-right {\n  left: 100%;\n  top: 0%;\n}\n\n.inline-message-content.top-right.small {\n  left: 103%;\n}\n\n.inline-message-content.anchor-right {\n  left: auto;\n  right: 0px;\n}\n\n.inline-message-content.anchor-right.temp {\n  display: block;\n}\n\n.inline-message-content.temp {\n  display: block;\n}\n\n.inline-message-trigger {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.inline-message-trigger.small-text {\n  font-size: 14px;\n}\n\n.chip {\n  display: inline-block;\n  padding: 4px 8px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 4px;\n  background-color: #edf2f7;\n  color: #4a5568;\n  font-size: 10px;\n  line-height: 100%;\n  font-weight: 400;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.chip.bold {\n  background-color: #4517a6;\n  color: #fff;\n}\n\n.chip.bold.push-up.grey {\n  background-color: #4a5568;\n}\n\n.chip.bold.push-up.blue {\n  background-color: #4c6ef5;\n  color: #fff;\n}\n\n.chip.bold.push-up.pink {\n  background-color: #e64980;\n  color: #fff;\n}\n\n.chip.white {\n  background-color: #fff;\n  color: #320b85;\n}\n\n.chip.important {\n  background-color: rgba(255, 146, 43, 0.2);\n  color: #f76707;\n}\n\n.chip.push-right {\n  margin-left: 8px;\n}\n\n.chip.primary {\n  margin-bottom: 4px;\n  background-color: rgba(69, 23, 166, 0.1);\n  color: #320b85;\n}\n\n.chip.warning {\n  background-color: rgba(255, 146, 43, 0.2);\n  color: #f76707;\n}\n\n.chip.pink {\n  background-color: #fff0f6;\n  color: #a61e4d;\n}\n\n.chip.blue {\n  background-color: #edf2ff;\n  color: #364fc7;\n}\n\n.chip.red {\n  background-color: rgba(250, 82, 82, 0.2);\n  color: #c92a2a;\n}\n\n.modal {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  z-index: 20;\n  display: none;\n  overflow: auto;\n  padding-top: 64px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: rgba(33, 37, 41, 0.8);\n  color: #fff;\n}\n\n.modal.darker {\n  display: none;\n  background-color: rgba(33, 37, 41, 0.95);\n  color: #718096;\n}\n\n.modal.dev {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.modal.temp {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.modal-card {\n  position: relative;\n  overflow: scroll;\n  width: 100%;\n  max-height: 90vh;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #2d3748;\n}\n\n.modal-header {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 16px 32px 8px;\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n}\n\n.modal-container {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  max-width: 600px;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.modal-container.is-large {\n  max-width: 800px;\n}\n\n.modal-container.is-huge {\n  max-width: 940px;\n}\n\n.modal-container.is-small {\n  max-width: 400px;\n}\n\n.modal-container.padded-bottom {\n  overflow: auto;\n}\n\n.meta {\n  display: inline-block;\n  color: #718096;\n  font-size: 14px;\n  line-height: 120%;\n}\n\n.meta.push-right {\n  margin-left: 8px;\n}\n\n.meta.push-left {\n  margin-right: 8px;\n}\n\n.s-border {\n  height: 4px;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  /* background-color: #40c057; */\n}\n\n.s-border.positive {\n  background-color: #364fc7;\n}\n\n.s-border.negative {\n  background-color: #c92a2a;\n}\n\n.s-border.neutral {\n  background-color: #718096;\n}\n\n.modal-body {\n  padding: 8px 32px 32px;\n}\n\n.paragraph {\n  margin-top: 8px;\n}\n\n.modal-footer {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 8px 32px 16px;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: #edf2f7;\n}\n\n.modal-footer.center {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.modal-footer.spaced {\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.progress-tracker {\n  overflow: hidden;\n  width: 100%;\n  height: 8px;\n  max-width: 960px;\n  border-radius: 4px;\n  background-color: #cbd5e0;\n}\n\n.progress-tracker.black {\n  background-color: #1a202c;\n}\n\n.progress-bar {\n  width: 1%;\n  height: 100%;\n  border-radius: 4px;\n  background-color: #4517a6;\n}\n\n.table.full {\n  width: 100%;\n}\n\n.table-header {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n  border-bottom: 1px solid #cbd5e0;\n}\n\n.table-header-cell {\n  padding-right: 16px;\n  padding-bottom: 8px;\n  padding-left: 8px;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  border-bottom: 1px none #cbd5e0;\n  color: #4a5568;\n  line-height: 100%;\n}\n\n.table-header-cell._60 {\n  width: 60%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-header-cell._40 {\n  width: 40%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-header-cell._30 {\n  width: 30%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-header-cell._20 {\n  width: 20%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-header-cell._10 {\n  width: 10%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-header-cell.small {\n  padding-bottom: 4px;\n  font-size: 12px;\n}\n\n.table-body {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.table-body.full {\n  width: 100%;\n}\n\n.table-row {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n  border-radius: 4px;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n}\n\n.table-row:hover {\n  background-color: #e2e8f0;\n}\n\n.table-row.disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.table-row.comfy {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n.table-row.news {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-row.news:hover {\n  background-color: #e2e8f0;\n}\n\n.table-row.news.dark-row {\n  background-color: #f7fafc;\n}\n\n.table-row.news.dark-row:hover {\n  background-color: #e2e8f0;\n}\n\n.table-row.ad {\n  cursor: pointer;\n}\n\n.table-row.dark-row {\n  background-color: #f7fafc;\n}\n\n.table-row.active {\n  cursor: pointer;\n}\n\n.table-row.audience {\n  cursor: pointer;\n}\n\n.table-body-cell {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding-right: 16px;\n  padding-left: 8px;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  color: #4a5568;\n  text-align: left;\n}\n\n.table-body-cell.main {\n  color: #2d3748;\n}\n\n.table-body-cell.main._20 {\n  width: 20%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-body-cell.action {\n  display: block;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n}\n\n.table-body-cell.right-align {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.table-body-cell._40 {\n  width: 40%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-body-cell.vertical {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.table-body-cell.shrink {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n}\n\n.table-body-cell._50 {\n  width: 50%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-body-cell._30 {\n  width: 30%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n}\n\n.table-body-cell._20 {\n  width: 20%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.table-body-cell._10 {\n  width: 10%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.num {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 32px;\n  height: 32px;\n  margin-right: 4px;\n  padding-top: 4px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  border-radius: 100px;\n  background-color: #edf2f7;\n  font-size: 20px;\n  text-align: center;\n}\n\n.num.positive {\n  background-color: rgba(64, 192, 87, 0.2);\n  color: #2b8a3e;\n}\n\n.num.neutral {\n  background-color: rgba(250, 176, 5, 0.2);\n  color: #e67700;\n}\n\n.num.negative {\n  background-color: rgba(250, 82, 82, 0.2);\n  color: #c92a2a;\n}\n\n.filters {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 16px;\n  padding-right: 8px;\n  padding-left: 8px;\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n}\n\n.filters.no-bottom-margin {\n  margin-bottom: 0px;\n}\n\n.filter {\n  margin-left: 8px;\n}\n\n.nav {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  max-width: 1180px;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  border-bottom: 1px solid #cbd5e0;\n}\n\n.nav-link {\n  margin-right: 16px;\n  margin-bottom: -1px;\n  margin-left: 16px;\n  padding: 16px 0px;\n  background-color: transparent;\n  -webkit-transition: color 250ms ease;\n  transition: color 250ms ease;\n  color: #4a5568;\n  font-size: 20px;\n  line-height: 100%;\n}\n\n.nav-link:hover {\n  color: #320b85;\n}\n\n.nav-link.w--current {\n  border-bottom: 2px solid #4517a6;\n  background-color: transparent;\n  color: #320b85;\n}\n\n.nav-link.with-badge {\n  margin-right: 4px;\n}\n\n.nav-link.small {\n  padding-top: 16px;\n  padding-bottom: 8px;\n  font-size: 14px;\n}\n\n.nav-link.small.w--current {\n  color: #2d3748;\n  font-size: 14px;\n}\n\n.nav-link.tiny {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 8px;\n  margin-left: 8px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  font-size: 12px;\n}\n\n.tabs-content-2 {\n  overflow: visible;\n  padding: 16px;\n}\n\n.tabs-content-2.small-padding {\n  padding: 8px;\n}\n\n.tag {\n  display: inline-block;\n  padding: 4px 8px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 4px;\n  background-color: #edf2f7;\n  color: #2d3748;\n  font-size: 12px;\n  line-height: 100%;\n  font-weight: 400;\n}\n\n.tag.bold {\n  background-color: #4517a6;\n  color: #fff;\n}\n\n.tag.white {\n  background-color: #fff;\n  color: #320b85;\n}\n\n.tag.important {\n  background-color: #ff922b;\n  color: #fff;\n}\n\n.tag.push-right {\n  margin-left: 8px;\n}\n\n.tag.removable {\n  padding-right: 20px;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f00e6fef2d5_x-circle.svg\");\n  background-position: 96% 50%;\n  background-size: 8px;\n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n\n.tag.primary {\n  background-color: rgba(69, 23, 166, 0.22);\n  color: #320b85;\n}\n\n.tag.big {\n  padding-top: 6px;\n  padding-bottom: 4px;\n  font-size: 16px;\n}\n\n.tag.big.positive {\n  background-color: rgba(64, 192, 87, 0.2);\n}\n\n.tag.big.option {\n  background-color: rgba(230, 73, 128, 0.1);\n  color: #e64980;\n}\n\n.tag.big.option._2 {\n  background-color: rgba(130, 201, 30, 0.1);\n  color: #82c91e;\n}\n\n.tag.big.option._3 {\n  background-color: rgba(77, 171, 247, 0.1);\n  color: #4dabf7;\n}\n\n.tag.big.option._4 {\n  background-color: rgba(151, 117, 250, 0.1);\n  color: #9775fa;\n}\n\n.tag.big.negative {\n  background-color: rgba(250, 82, 82, 0.2);\n}\n\n.tag.short {\n  padding-top: 6px;\n  padding-bottom: 4px;\n  font-size: 16px;\n}\n\n.tag.short.positive {\n  background-color: rgba(64, 192, 87, 0.2);\n}\n\n.tag.short.option {\n  padding-top: 3px;\n  padding-bottom: 2px;\n  background-color: rgba(230, 73, 128, 0.1);\n  color: #e64980;\n  font-size: 12px;\n}\n\n.tag.short.option._2 {\n  background-color: rgba(130, 201, 30, 0.1);\n  color: #82c91e;\n}\n\n.tag.short.option._3 {\n  background-color: rgba(77, 171, 247, 0.1);\n  color: #4dabf7;\n}\n\n.tag.short.option._4 {\n  background-color: rgba(151, 117, 250, 0.1);\n  color: #9775fa;\n}\n\n.tag.short.negative {\n  background-color: rgba(250, 82, 82, 0.2);\n}\n\n.tag.positive {\n  background-color: rgba(76, 110, 245, 0.2);\n  color: #364fc7;\n}\n\n.tag.negative {\n  background-color: rgba(250, 82, 82, 0.2);\n}\n\n.tag.purple {\n  background-color: rgba(69, 23, 166, 0.1);\n  color: #320b85;\n}\n\n.tag.violet {\n  background-color: rgba(121, 80, 242, 0.1);\n  color: #5f3dc4;\n}\n\n.tag.small {\n  padding: 2px 4px;\n  font-size: 12px;\n}\n\n.tag.small.purple {\n  background-color: rgba(192, 79, 225, 0.1);\n  color: #8d0db3;\n}\n\n.tag.nudge-right.small.blue {\n  background-color: rgba(77, 171, 247, 0.1);\n  color: #1864ab;\n}\n\n.tag.nudge-right.small.teal {\n  background-color: rgba(56, 217, 169, 0.1);\n  color: #087f5b;\n}\n\n.tag.nudge-right.small.yellow {\n  background-color: rgba(252, 196, 25, 0.1);\n  color: #e67700;\n}\n\n.thumb {\n  position: relative;\n  width: 100%;\n  padding-bottom: 80%;\n  border-radius: 8px;\n  background-image: url(https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5f99d01d7eaf1e75233f23f9_Screenshot%202020-10-28%20at%208.57.52%20PM.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  cursor: pointer;\n}\n\n.thumb.audio {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-image: url(https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5f99db7827b2c580277d20dc_audio.png);\n}\n\n.thumb.vid {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-image: url(https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5f99d6a85b2bb119dd7642fb_Screenshot%202020-10-28%20at%209.37.14%20PM.png);\n}\n\n.text-block {\n  position: absolute;\n  right: 4px;\n  bottom: 4px;\n  padding-right: 8px;\n  padding-left: 8px;\n  border-radius: 4px;\n  background-color: #fff;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1), 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n  font-size: 12px;\n}\n\n.heading {\n  font-weight: 600;\n}\n\n.helper {\n  display: block;\n  margin-top: 4px;\n  margin-bottom: 16px;\n  color: #4a5568;\n  font-size: 14px;\n  line-height: 120%;\n  font-weight: 400;\n  text-align: left;\n}\n\n.helper.error {\n  color: #f76707;\n}\n\n.field-label {\n  margin-top: 16px;\n}\n\n.field-label.white-text.large {\n  font-size: 24px;\n}\n\n.field-label.large {\n  color: #2d3748;\n  font-size: 24px;\n}\n\n.control {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.column {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding-right: 8px;\n  padding-left: 8px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.column._50 {\n  width: 50%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n}\n\n.column._40 {\n  width: 40%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.column.shrink {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n}\n\n.column._30 {\n  width: 30%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n}\n\n.column._33 {\n  width: 33.333333333333336%;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.column._20 {\n  width: 20%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n}\n\n.column.relative {\n  position: relative;\n}\n\n.column.third-width {\n  width: 33.333333333333336%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.column.third-width.question {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.column.padded-right {\n  padding-right: 32px;\n}\n\n.column.padded-right.no-padding-left {\n  position: relative;\n  padding-left: 0px;\n}\n\n.column.padded-left {\n  padding-left: 32px;\n}\n\n.column.padded-left.rel {\n  position: relative;\n}\n\n.column._25 {\n  width: 25%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.column.align-right {\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n\n.column.rel {\n  position: relative;\n}\n\n.example-bg {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 32px;\n  margin-right: -8px;\n  margin-left: -8px;\n  padding: 32px 0px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  border-radius: 4px;\n  background-color: #f7fafc;\n}\n\n.card-section {\n  padding: 16px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n}\n\n.card-section.left-up:before {\n  padding: 16px;\n  left: -40px;\n  top: 0;\n}\n\n.card-section.w--current {\n  background-color: transparent;\n}\n\n.card-section.horizontal {\n  display: inline-block;\n  border-right: 1px solid #e2e8f0;\n}\n\n.card-section.horizontal.end {\n  border-right-style: none;\n}\n\n.card-section.vertical {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  border-bottom: 1px solid #cbd5e0;\n}\n\n.card-section.vertical.has-bottom-border.dark-border {\n  border-bottom-color: #cdd3da;\n}\n\n.card-section.center {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.card-section.grey {\n  background-color: #f7fafc;\n}\n\n.card-section.flex-row {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.card-section.flex-row.align-center {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.card-section._8-padding {\n  min-width: 120px;\n  padding: 8px;\n}\n\n.card-section._8-padding.no-top-padding {\n  padding-top: 0px;\n}\n\n.card-section.fill {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.card-section.expand.horizontal.detail-trigger {\n  background-color: #fff;\n}\n\n.card-section.expand.horizontal.detail-trigger.w--current {\n  border-bottom: 2px solid #4517a6;\n}\n\n.card-section.expand.detail-trigger.w--current {\n  border-bottom: 2px solid #4517a6;\n}\n\n.card-section.expand.has-top-border {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.card-section.detail-trigger {\n  -webkit-transition: background-color 250ms ease;\n  transition: background-color 250ms ease;\n  cursor: pointer;\n}\n\n.card-section.detail-trigger:hover {\n  background-color: #f7fafc;\n}\n\n.card-section.detail-trigger.expand {\n  background-color: #fff;\n}\n\n.card-section.empty {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 500px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.card-section.has-top-border {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card-section.align-left {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.card-section.padded {\n  padding: 32px;\n}\n\n.card-section.padded-x {\n  padding-right: 32px;\n  padding-left: 32px;\n}\n\n.measure-bar {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 16px;\n  min-width: 100px;\n  margin-top: 0px;\n}\n\n.measure-bar.push-right {\n  position: relative;\n  margin-left: 8px;\n}\n\n.measure-bar.push-right.super-long {\n  overflow: hidden;\n  width: 460px;\n  border-radius: 4px;\n}\n\n.measure-bar.push-right.no-margin {\n  width: auto;\n  margin-left: 0px;\n}\n\n.measure-bar.push-down {\n  margin-top: 8px;\n}\n\n.measure-bar.short {\n  height: 8px;\n  border-radius: 4px;\n  background-color: #edf2f7;\n}\n\n.measure-bar.short.push-right {\n  position: relative;\n}\n\n.measure-bar.short.push-right.medium {\n  overflow: hidden;\n  width: 184px;\n  border-radius: 4px;\n}\n\n.measure-bar.short.push-right.super-long {\n  max-width: 400px;\n}\n\n.measure-bar.medium {\n  width: 128px;\n  min-width: 120px;\n}\n\n.measure-bar.tall {\n  height: 24px;\n}\n\n.measure-bar.tall.push-right.medium {\n  width: 184px;\n}\n\n.measure-bar.tall.push-right.med-long {\n  width: 160px;\n}\n\n.measure-bar.tall.push-right.long {\n  width: 100%;\n  max-width: 260px;\n}\n\n.measure-bar.tall.cover {\n  position: static;\n  height: 8px;\n  margin-bottom: 4px;\n  border-radius: 4px;\n  background-color: #edf2f7;\n}\n\n.measure-bar.tall.cover:hover {\n  -webkit-filter: brightness(97%);\n  filter: brightness(97%);\n}\n\n.measure-bar.tall.cover.dark-bg {\n  background-color: #edf2f7;\n}\n\n.measure-bar.scout-picker {\n  height: 40px;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #cbd5e0;\n  border-radius: 4px;\n  background-color: #edf2f7;\n}\n\n.measure-bar.empty {\n  background-color: #cbd5e0;\n}\n\n.measure-bar.empty.push-down {\n  border-radius: 4px;\n}\n\n.measure-bar.dark-bg {\n  background-color: #edf2f7;\n}\n\n.measure-bar.dark-bg.tiny {\n  height: 8px;\n  background-color: #cbd5e0;\n}\n\n.sentiment {\n  height: 100%;\n}\n\n.sentiment.positive {\n  width: 40%;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #40c057;\n}\n\n.sentiment.positive._70 {\n  width: 80%;\n}\n\n.sentiment.positive._20 {\n  width: 20%;\n}\n\n.sentiment.positive._60 {\n  width: 60%;\n}\n\n.sentiment.neutral {\n  width: 20%;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  background-color: #fcc419;\n}\n\n.sentiment.neutral.single {\n  border-radius: 4px;\n}\n\n.sentiment.negative {\n  width: 40%;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: #fa5252;\n}\n\n.sentiment.negative._60 {\n  width: 60%;\n}\n\n.sentiment.negative.single {\n  border-radius: 4px;\n}\n\n.sentiment.negative.single.test-data {\n  width: 30%;\n}\n\n.sentiment.option-1 {\n  width: 40%;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #9775fa;\n}\n\n.sentiment.option-2 {\n  width: 30%;\n  background-color: rgba(151, 117, 250, 0.8);\n}\n\n.sentiment.option-3 {\n  width: 25%;\n  background-color: rgba(151, 117, 250, 0.6);\n}\n\n.sentiment.option-4 {\n  width: 5%;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: rgba(151, 117, 250, 0.4);\n}\n\n.sentiment.option-4._60 {\n  width: 60%;\n}\n\n.sentiment.positive-2 {\n  width: 40%;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #4c6ef5;\n}\n\n.sentiment.positive-2._70 {\n  width: 80%;\n}\n\n.sentiment.positive-2._20 {\n  width: 20%;\n}\n\n.sentiment.positive-2._60 {\n  width: 60%;\n}\n\n.sentiment.positive-2.single {\n  border-radius: 4px;\n}\n\n.sentiment.positive-2.single.test-data {\n  width: 60%;\n}\n\n.sentiment.neutral-2 {\n  width: 20%;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  background-color: #a0aec0;\n}\n\n.sentiment.neutral-2.single {\n  border-radius: 4px;\n}\n\n.sentiment.neutral-2.single.test-data {\n  width: 10%;\n}\n\n.measure-bar-legend {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  padding-top: 4px;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.bar-container {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n  border-radius: 4px;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n}\n\n.bar-container:hover {\n  box-shadow: none;\n}\n\n.bar-container.move-down.justify-content {\n  position: relative;\n  overflow: visible;\n  width: 100%;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.bar-container.justify-content {\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.bar-container.justify-content.small {\n  position: relative;\n  overflow: visible;\n}\n\n.bar-container.justify-content.small.move-down {\n  overflow: visible;\n}\n\n.bar-container.justify-content.small.move-down.stretch {\n  overflow: visible;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.bar-container.has-cover {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.bar-container.has-cover.move-down {\n  overflow: visible;\n}\n\n.bar-container.has-cover.move-down.overflow-show {\n  overflow: visible;\n}\n\n.bar-container.has-cover.nudge-down.static {\n  position: relative;\n  overflow: visible;\n}\n\n.bar-container.has-cover.nudge-down.selected {\n  box-shadow: 0 0 0 2px rgba(121, 80, 242, 0.1);\n}\n\n.bar-container.vertical {\n  min-width: 300px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  box-shadow: none;\n}\n\n.sign-up {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 100vh;\n  padding: 64px 16px 140px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #fff;\n  background-image: none;\n  background-position: 0px 0px;\n  background-size: auto;\n  background-repeat: repeat;\n  text-align: center;\n}\n\n.logo.margin-bottom-spaced {\n  margin-bottom: 32px;\n}\n\n.positive {\n  color: #364fc7;\n}\n\n.bottom-breather {\n  margin-bottom: 32px;\n}\n\n.bottom-breather.big-breath {\n  margin-bottom: 64px;\n}\n\n.form-block {\n  width: 100%;\n  max-width: 400px;\n  margin-bottom: 0px;\n  text-align: left;\n}\n\n.form-block.push-down.full {\n  max-width: 100%;\n}\n\n.progress-container {\n  width: 100%;\n  max-width: 960px;\n}\n\n.primary {\n  color: #320b85;\n}\n\n.primary.brighter {\n  color: #4517a6;\n}\n\n.primary.lighter {\n  color: #4517a6;\n}\n\n.with-icon {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  line-height: 100%;\n  cursor: pointer;\n}\n\n.with-icon.throw-up.fill.align-right {\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.with-icon.muted.active {\n  cursor: pointer;\n}\n\n.top-breather {\n  margin-top: 32px;\n}\n\n.important {\n  color: #f76707;\n}\n\n.push-right {\n  margin-left: 16px;\n}\n\n.push-freeform-right {\n  margin-left: 90px;\n}\n\n.push-right.light {\n  opacity: 0.6;\n}\n\n.main {\n  display: block;\n  color: #2d3748;\n}\n\n.toggle {\n  width: 32px;\n  height: 16px;\n  padding: 2px;\n  border-radius: 16px;\n  background-color: #cbd5e0;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f00e6fef2d5_x-circle.svg\"),\n    url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e4960cec9e35624ce18e0_Shape.png\");\n  background-position: 81% 50%, 5px 50%;\n  background-size: 6px, 8px;\n  background-repeat: no-repeat, no-repeat;\n  cursor: pointer;\n}\n\n.toggle.big {\n  width: 40px;\n  height: 20px;\n  background-size: 8px, 8px;\n}\n\n.toggle.big.on {\n  background-size: 8px, 10px;\n}\n\n.toggle.on {\n  background-color: #4517a6;\n}\n\n.row-2 {\n  margin-top: 20px;\n}\n\n.toggle-switch {\n  width: 12px;\n  height: 12px;\n  border-radius: 10px;\n  background-color: #718096;\n}\n\n.toggle-switch.big {\n  width: 16px;\n  height: 16px;\n}\n\n.toggle-switch.big.on {\n  -webkit-transform: translate(20px, 0px);\n  -ms-transform: translate(20px, 0px);\n  transform: translate(20px, 0px);\n}\n\n.toggle-switch.on {\n  background-color: #fff;\n  -webkit-transform: translate(16px, 0px);\n  -ms-transform: translate(16px, 0px);\n  transform: translate(16px, 0px);\n}\n\n.checkbox-field {\n  text-align: left;\n}\n\n.nav-container {\n  position: fixed;\n  z-index: 10;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  padding-right: 16px;\n  padding-left: 16px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #f7fafc;\n}\n\n.nav-section {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.brand {\n  width: 100px;\n  height: 100%;\n  max-height: 52px;\n  margin-right: 64px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da78d3fac4d6deacd4589d5_Group.png\");\n  background-position: 50% 40%;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.brand.scouts {\n  width: 169px;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b589b37929c5a3a8dce7a0e_Group%2012.png\");\n}\n\n.move-right {\n  margin-left: 8px;\n}\n\n.move-right.display-name {\n  font-weight: 600;\n}\n\n.move-right.display-name.has-object {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.move-right.vertical.align-left {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.move-right.vertical.align-left.sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 64px;\n}\n\n.move-right.move-left.meta {\n  color: #a0aec0;\n}\n\n.move-left {\n  margin-right: 8px;\n}\n\n.move-left.meta {\n  color: #a0aec0;\n}\n\n.move-left.meta.push-left {\n  margin-right: 16px;\n}\n\n.move-down {\n  margin-top: 8px;\n}\n\n.move-up {\n  margin-bottom: 8px;\n}\n\n.push-up {\n  margin-bottom: 16px;\n}\n\n.push-up.top-breather {\n  margin-top: 64px;\n}\n\n.nudge-right {\n  margin-left: 4px;\n}\n\n.nudge-left {\n  margin-right: 4px;\n}\n\n.input.nudge-left {\n  /* margin-right: 4px; */\n  flex-direction: column;\n  justify-content: center;\n  display: flex;\n}\n\n.nudge-left-15 {\n  margin-right: 48px;\n}\n\n.button.with-object.tag.location {\n  height: auto;\n  padding: 8px 16px;\n  margin-top: 8px;\n}\n\n.icon-3 {\n  color: #718096;\n}\n\n.dropdown-list-input.w--open {\n  background-color: #fff;\n  max-height: 80vh;\n  padding: 15px;\n  display: inline;\n  top: 100%;\n  right: 0;\n  overflow: scroll;\n  box-shadow: 0 16px 32px #343a401a;\n}\n\n.nudge-up {\n  margin-bottom: 4px;\n}\n\n.nudge-down {\n  margin-top: 4px;\n}\n\n.section {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 54px 16px 64px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.content {\n  display: block;\n  width: 100%;\n  max-width: 1180px;\n  margin-top: 32px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.content.small {\n  max-width: 760px;\n  padding-right: 32px;\n  padding-left: 32px;\n}\n\n.content.medium {\n  max-width: 960px;\n}\n\n.content.medium {\n  max-width: 940px;\n}\n\n.content.tiny {\n  max-width: 480px;\n}\n\n.content.align-center {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  text-align: center;\n}\n\n.content.half-screen {\n  height: 50vh;\n}\n\n.content.half-screen.flex-center {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 50vh;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.content.full {\n  max-width: 100%;\n  padding-right: 16px;\n  padding-left: 16px;\n}\n\n.content.med {\n  max-width: 940px;\n}\n\n.no-margin {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.no-margin.push-left {\n  margin-right: 16px;\n}\n\n.no-margin.push-left.top-breather {\n  margin-top: 64px;\n}\n\n.no-margin.push-left.move-up {\n  margin-bottom: 8px;\n}\n\n.no-margin.push-left.muted.full {\n  width: 100%;\n  max-width: none;\n}\n\n.no-margin.push-down {\n  margin-top: 16px;\n}\n\n.no-margin.push-down.nudge-up {\n  margin-bottom: 4px;\n}\n\n.no-margin.fill.top-breather {\n  margin-top: 32px;\n}\n\n.throw-down {\n  margin-top: 32px;\n}\n\n.throw-right {\n  margin-left: 32px;\n}\n\n.throw-left {\n  margin-right: 32px;\n}\n\n.throw-up {\n  margin-bottom: 32px;\n}\n\n.donut-chart-container {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.donut-chart-container.move-down.vertical {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.donut-chart-container.align-top {\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.html-embed {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.html-embed.sentiment-chart {\n  width: 100%;\n}\n\n.legend.horizontal {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.legend-item {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n}\n\n.legend-item.horinzontal {\n  margin-top: 0px;\n  margin-right: 16px;\n}\n\n.legend-marker {\n  width: 8px;\n  height: 8px;\n  margin-right: 4px;\n  border-radius: 4px;\n  background-color: #718096;\n}\n\n.legend-marker.brand-1 {\n  background-color: #9775fa;\n}\n\n.legend-marker.brand-2 {\n  width: 8px;\n  height: 8px;\n  margin-top: 0px;\n  margin-left: 0px;\n  background-color: #4dabf7;\n  background-image: none;\n  background-size: auto;\n  background-repeat: repeat;\n}\n\n.legend-marker.brand-3 {\n  background-color: #38d9a9;\n}\n\n.legend-marker.positive {\n  background-color: #40c057;\n}\n\n.legend-marker.neutral {\n  background-color: #fcc419;\n}\n\n.legend-marker.negative {\n  background-color: #fa5252;\n}\n\n.chart-bg {\n  padding: 8px;\n  border-radius: 4px;\n  background-color: #f7fafc;\n}\n\n.sentiment-map {\n  width: 80%;\n}\n\n.inline {\n  display: inline-block;\n}\n\n.muted {\n  max-width: 400px;\n  color: #718096;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.muted.small {\n  font-size: 14px;\n}\n\n.muted.small.with-icon.push-right.bold {\n  font-weight: 600;\n}\n\n.muted.small.with-icon.push-right.bold.active {\n  cursor: pointer;\n}\n\n.muted.white-text {\n  color: hsla(0, 0%, 100%, 0.7);\n}\n\n.muted.with-icon.full {\n  width: 100%;\n  max-width: none;\n}\n\n.muted.with-icon.no-shrink {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.grey-card {\n  position: relative;\n  border-radius: 4px;\n  background-color: #f7fafc;\n}\n\n.grey-card.push-down {\n  -webkit-transition: -webkit-transform 250ms ease;\n  transition: -webkit-transform 250ms ease;\n  transition: transform 250ms ease;\n  transition: transform 250ms ease, -webkit-transform 250ms ease;\n  cursor: pointer;\n}\n\n.grey-card.push-down:hover {\n  -webkit-transform: translate(0px, -4px);\n  -ms-transform: translate(0px, -4px);\n  transform: translate(0px, -4px);\n}\n\n.with-badge {\n  display: inline-block;\n}\n\n.column-header-container {\n  margin-bottom: 4px;\n}\n\n.chart-detail-content {\n  overflow: hidden;\n  width: 100%;\n  padding-top: 8px;\n}\n\n.no-top-padding {\n  padding-top: 0px;\n}\n\n.card-marker {\n  width: 100%;\n  height: 4px;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  background-color: #718096;\n}\n\n.card-marker.positive {\n  background-color: #40c057;\n}\n\n.card-marker.neutral {\n  background-color: #fcc419;\n}\n\n.card-marker.negative {\n  background-color: #fa5252;\n}\n\n.card-marker.active {\n  background-color: #4517a6;\n}\n\n.card-marker.important {\n  background-color: #ff922b;\n}\n\n.card-marker.pink {\n  background-color: #e64980;\n}\n\n.card-marker.blue {\n  background-color: #5c7cfa;\n}\n\n.marker {\n  width: 16px;\n  height: 16px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  border-radius: 100%;\n  background-color: #718096;\n  -webkit-transform: translate(0px, 2px);\n  -ms-transform: translate(0px, 2px);\n  transform: translate(0px, 2px);\n}\n\n.marker.positive {\n  background-color: #40c057;\n  -webkit-transform: translate(0px, 3px);\n  -ms-transform: translate(0px, 3px);\n  transform: translate(0px, 3px);\n}\n\n.marker.neutral {\n  background-color: #fcc419;\n}\n\n.marker.negative {\n  background-color: #fa5252;\n}\n\n.marker.small {\n  width: 8px;\n  height: 8px;\n}\n\n.marker.small.nudge-down.move-left.positive-2 {\n  overflow: scroll;\n}\n\n.marker.positive-2 {\n  background-color: #4c6ef5;\n}\n\n.text-align-center {\n  text-align: center;\n}\n\n.text-align-center.with-icon.justify-center {\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.push-left {\n  margin-right: 16px;\n}\n\n.metric {\n  /* width: 100%; */\n  height: 100%;\n  max-height: 24px;\n  padding-left: 0px;\n  border-radius: 4px;\n  background-color: #cbd5e0;\n  color: #1a202c;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.metric.brand-1 {\n  padding-right: 0px;\n  background-color: #9775fa;\n  text-align: right;\n}\n\n.metric.brand-1._40 {\n  width: 40%;\n}\n\n.metric.brand-1._20 {\n  width: 20%;\n}\n\n.metric.brand-1._3 {\n  width: 30%;\n}\n\n.metric.brand-1._3._20 {\n  width: 20%;\n}\n\n.metric.brand-1._3._50 {\n  width: 50%;\n}\n\n.metric.brand-1._3._2 {\n  width: 2%;\n}\n\n.metric.brand-1._3._5 {\n  width: 5%;\n}\n\n.metric.brand-1._3._18 {\n  width: 18%;\n}\n\n.metric.brand-1._5 {\n  width: 80%;\n}\n\n.metric.brand-1._5.ke {\n  width: 10%;\n  background-color: #9779ef;\n}\n\n.metric.brand-1._6 {\n  width: 70%;\n}\n\n.metric.brand-1._6.et {\n  width: 10%;\n  background-color: #9779ef;\n}\n\n.metric.brand-1._7 {\n  width: 40%;\n}\n\n.metric.brand-1._8 {\n  width: 30%;\n}\n\n.metric.brand-1._9 {\n  width: 6%;\n}\n\n.metric.brand-1._10 {\n  width: 1%;\n}\n\n.metric.brand-1._11 {\n  width: 3%;\n}\n\n.metric.brand-1._80 {\n  width: 80%;\n}\n\n.metric.brand-1._50 {\n  width: 50%;\n}\n\n.metric.brand-2 {\n  width: 60%;\n  background-color: #9775fa;\n}\n\n.metric.brand-2._40 {\n  width: 40%;\n}\n\n.metric.brand-2._30 {\n  width: 30%;\n}\n\n.metric.brand-2._20 {\n  width: 20%;\n}\n\n.metric.brand-2._10 {\n  width: 10%;\n}\n\n.metric.brand-3 {\n  width: 30%;\n  background-color: #9775fa;\n}\n\n.metric.brand-3._20 {\n  width: 20%;\n}\n\n.metric.brand-3._10 {\n  width: 10%;\n}\n\n.metric.stat {\n  padding-right: 0px;\n  background-color: #9775fa;\n  text-align: right;\n}\n\n.metric.stat._40 {\n  width: 40%;\n}\n\n.metric.stat._20 {\n  width: 20%;\n}\n\n.metric.stat._2 {\n  width: 70%;\n}\n\n.metric.stat._4 {\n  width: 95%;\n  background-color: #9775fa;\n}\n\n.metric.stat._4.positive {\n  background-color: #4c6ef5;\n}\n\n.metric.stat._4.negative {\n  background-color: #fa5252;\n}\n\n.metric.stat._4.so {\n  width: 30%;\n  background-color: #9779ef;\n}\n\n.metric.stat.brand-2 {\n  height: auto;\n  margin-top: 0px;\n  margin-left: 0px;\n  background-color: rgba(77, 171, 247, 0.4);\n  background-image: none;\n  background-size: auto;\n  background-repeat: repeat;\n}\n\n.metric.stat.brand-2._2 {\n  height: auto;\n  margin-top: 0px;\n  margin-left: 0px;\n}\n\n.metric.stat.brand-3 {\n  background-color: rgba(56, 217, 169, 0.4);\n}\n\n.metric.stat.asjvbnr {\n  width: 80%;\n}\n\n.metric.stat.aovuber {\n  width: 40%;\n}\n\n.metric.stat.afjovba {\n  width: 32%;\n}\n\n.metric.primary {\n  background-color: #4517a6;\n}\n\n.metric.primary._20 {\n  width: 20%;\n}\n\n.metric.primary._30 {\n  width: 35%;\n}\n\n.metric.primary._0 {\n  width: 0%;\n}\n\n.metric.warning {\n  background-color: #ff922b;\n}\n\n.metric.warning._20 {\n  width: 20%;\n}\n\n.metric.warning._0 {\n  width: 0%;\n}\n\n.metric.grey {\n  background-color: #718096;\n}\n\n.metric.grey._20 {\n  width: 20%;\n}\n\n.metric.grey._50 {\n  width: 50%;\n}\n\n.metric._20 {\n  width: 20%;\n}\n\n.metric._20.red-bg {\n  background-color: rgba(250, 82, 82, 0.2);\n}\n\n.metric._20.purple {\n  background-color: #f3d9fa;\n}\n\n.metric._80 {\n  width: 80%;\n}\n\n.metric._80.green-bg {\n  background-color: rgba(64, 192, 87, 0.2);\n}\n\n.metric._80.pink {\n  background-color: #eebefa;\n}\n\n.metric._80.purple {\n  background-color: #f3d9fa;\n}\n\n.metric._80.purple._60 {\n  width: 60%;\n}\n\n.metric._80.purple._22 {\n  width: 22%;\n}\n\n.metric._40 {\n  width: 40%;\n}\n\n.metric._40.yellow-bg {\n  background-color: rgba(250, 176, 5, 0.2);\n}\n\n.metric._40.purple {\n  background-color: #f3d9fa;\n}\n\n.metric._40.purple._30 {\n  width: 30%;\n}\n\n.metric._40.purple._20 {\n  width: 20%;\n}\n\n.metric._40.purple._10 {\n  width: 10%;\n}\n\n.metric._40.purple._60 {\n  width: 60%;\n}\n\n.metric._40.purple._8 {\n  width: 8%;\n}\n\n.metric._40.purple._4 {\n  width: 4%;\n}\n\n.metric._40.purple._3 {\n  width: 3%;\n}\n\n.metric.violet {\n  padding-right: 0px;\n  background-color: #9775fa;\n  -webkit-transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);\n  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);\n  text-align: right;\n}\n\n.metric.violet._40 {\n  width: 40%;\n}\n\n.metric.violet._20 {\n  width: 20%;\n}\n\n.metric.violet._3 {\n  width: 30%;\n}\n\n.metric.violet._3._20 {\n  width: 20%;\n}\n\n.metric.violet._3._50 {\n  width: 50%;\n}\n\n.metric.violet._3._2 {\n  width: 2%;\n}\n\n.metric.violet._3._5 {\n  width: 5%;\n}\n\n.metric.violet._3._18 {\n  width: 18%;\n}\n\n.metric.violet._5 {\n  width: 80%;\n}\n\n.metric.violet._6 {\n  width: 70%;\n}\n\n.metric.violet._7 {\n  width: 40%;\n}\n\n.metric.violet._8 {\n  width: 30%;\n}\n\n.metric.violet._9 {\n  width: 6%;\n}\n\n.metric.violet._10 {\n  width: 1%;\n}\n\n.metric.violet._11 {\n  width: 3%;\n}\n\n.metric.violet._80 {\n  width: 80%;\n}\n\n.metric.violet._50 {\n  width: 50%;\n}\n\n.metric.violet.ni {\n  width: 50%;\n}\n\n.metric.violet._0 {\n  width: 0%;\n}\n\n.metric.positive {\n  background-color: #4c6ef5;\n}\n\n.metric.positive.advkn {\n  width: 80%;\n}\n\n.metric.positive.aksvn {\n  width: 40%;\n}\n\n.metric.positive.asicn {\n  width: 33%;\n}\n\n.metric.negative {\n  background-color: #fa5252;\n}\n\n.metric.negative.safvr {\n  width: 30%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.metric.negative.safvr._2 {\n  width: 50%;\n}\n\n.metric.comparison {\n  position: absolute;\n  left: 50%;\n  width: 4px;\n  max-height: 16px;\n  margin-left: -4px;\n  background-color: #320b85;\n  -webkit-transform: translate(0px, -4px);\n  -ms-transform: translate(0px, -4px);\n  transform: translate(0px, -4px);\n}\n\n.metric.comparison._70 {\n  left: 70%;\n  -webkit-transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);\n  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);\n}\n\n.metric.comparison._40 {\n  left: 40%;\n}\n\n.metric.comparison._30 {\n  left: 30%;\n}\n\n.metric.comparison._15 {\n  left: 15%;\n}\n\n.metric.comparison._12 {\n  left: 12%;\n}\n\n.metric.comparison._60 {\n  left: 60%;\n}\n\n.metric.comparison._38 {\n  left: 38%;\n}\n\n.metric.comparison._8 {\n  left: 8%;\n}\n\n.metric.comparison._22 {\n  left: 22%;\n}\n\n.metric.comparison._4 {\n  left: 4%;\n}\n\n.metric.comparison._19 {\n  left: 19%;\n}\n\n.metric.comparison._3 {\n  left: 3%;\n}\n\n.metric.comparison._0 {\n  left: 0%;\n}\n\n.metric.purple {\n  background-color: #f3d9fa;\n}\n\n.metric.purple._50 {\n  width: 50%;\n}\n\n.metric.purple._19 {\n  width: 19%;\n}\n\n.metric.blue {\n  background-color: #5c7cfa;\n}\n\n.metric.positive-2 {\n  background-color: #4c6ef5;\n}\n\n.metric.positive-2.aerv {\n  width: 60%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.metric.positive-2.djac {\n  width: 50%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.metric.positive-2.adcvrv {\n  width: 50%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.metric.positive-2.adv {\n  width: 20%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.metric.neutral-2 {\n  background-color: #edf2f7;\n}\n\n.metric.neutral-2._135g {\n  width: 33%;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.scout-option-label {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  border-left: 1px none #cbd5e0;\n  color: #1a202c;\n  font-size: 24px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.scout-option-label:hover {\n  background-color: #cbd5e0;\n}\n\n.scout-option-label.first {\n  border-left-style: none;\n}\n\n.scout-option {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0px;\n  padding-top: 4px;\n  padding-left: 0px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  border-left: 1px solid #cbd5e0;\n  color: #1a202c;\n  font-size: 24px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.scout-option:hover {\n  background-color: #cbd5e0;\n}\n\n.scout-option.first {\n  border-left-style: none;\n}\n\n.form-block-2 {\n  margin-bottom: 0px;\n}\n\n.scout-number {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  font-size: 20px;\n  line-height: 120%;\n  font-weight: 600;\n}\n\n.scout-number.huge {\n  margin-bottom: 16px;\n  font-size: 36px;\n}\n\n.scout-number.huge.no-margin {\n  margin-bottom: 0px;\n}\n\n.scout-number.small {\n  max-width: 346px;\n  font-size: 16px;\n  line-height: 140%;\n}\n\n.scout-number.small.white-text {\n  color: #fff;\n}\n\n.scout-number.small.fill {\n  max-width: 100%;\n}\n\n.scout-number.large {\n  font-size: 28px;\n}\n\n.scout-number.tiny {\n  font-size: 14px;\n}\n\n.scout-number.positive {\n  color: #2b8a3e;\n}\n\n.scout-number.neutral {\n  color: #e67700;\n}\n\n.scout-number.negative {\n  color: #c92a2a;\n}\n\n.scout-number.brand-1 {\n  color: #9775fa;\n}\n\n.scout-number.brand-2 {\n  color: #4dabf7;\n}\n\n.scout-number.brand-3 {\n  color: #38d9a9;\n}\n\n.sidebar {\n  position: fixed;\n  width: 174px;\n  margin-top: 96px;\n  padding: 4px;\n  border-radius: 4px;\n  background-color: #e2e8f0;\n}\n\n.sidebar-link {\n  display: block;\n  margin-bottom: 4px;\n  padding-top: 4px;\n  padding-bottom: 2px;\n  padding-left: 4px;\n  border-radius: 4px;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  color: #2d3748;\n}\n\n.sidebar-link:hover {\n  background-color: #cbd5e0;\n}\n\n.answer-date-header {\n  padding-top: 65px;\n}\n\n.white-text {\n  color: #fff;\n}\n\n.fill {\n  width: 100%;\n  max-width: 100%;\n}\n\n.expand {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.step-1 {\n  overflow: hidden;\n}\n\n.step-1.fill {\n  overflow: visible;\n}\n\n.step-2 {\n  overflow: hidden;\n}\n\n.step-2.fill {\n  overflow: visible;\n}\n\n.step-4 {\n  overflow: hidden;\n}\n\n.step-4.fill {\n  overflow: visible;\n}\n\n.respond-step {\n  overflow: hidden;\n}\n\n.modal-card-content {\n  overflow: hidden;\n}\n\n.modal-card-location-filter {\n  position: relative;\n  overflow: scroll;\n  width: 100%;\n  max-height: 90vh;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #2d3748;\n  min-height: 445px;\n}\n\n.reports {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n\n.report-preview {\n  width: 45%;\n  height: 392px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n}\n\n.pdf-container {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  z-index: 20;\n  display: none;\n  overflow: scroll;\n  padding-top: 64px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: rgba(33, 37, 41, 0.8);\n  color: #fff;\n}\n\n.pdf-container.darker {\n  display: none;\n  background-color: rgba(33, 37, 41, 0.95);\n  color: #718096;\n}\n\n.pdf-container.temp {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.blacklist {\n  opacity: 0.2;\n  text-decoration: line-through;\n}\n\n.justify-center {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.hidden {\n  display: none;\n}\n\n.no-padding {\n  padding: 0px;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.absolute.align-right {\n  right: 0px;\n}\n\n.absolute.align-right.small-text {\n  font-size: 12px;\n}\n\n.has-bottom-border {\n  border-bottom: 1px solid #cbd5e0;\n}\n\n.has-top-border {\n  border-top: 1px solid #cbd5e0;\n}\n\n.details-container {\n  position: relative;\n  display: block;\n  overflow: visible;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  border-top: 1px solid #cbd5e0;\n}\n\n.details-container.mentions {\n  overflow: visible;\n}\n\n.fader {\n  position: relative;\n  z-index: 1;\n  height: 40px;\n  background-image: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#fff),\n    to(hsla(0, 0%, 100%, 0))\n  );\n  background-image: linear-gradient(0deg, #fff, hsla(0, 0%, 100%, 0));\n  -webkit-transform: translate(0px, -40px);\n  -ms-transform: translate(0px, -40px);\n  transform: translate(0px, -40px);\n  text-align: center;\n}\n\n.fader.bottom {\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  height: 40px;\n  background-image: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#fff),\n    to(hsla(0, 0%, 100%, 0))\n  );\n  background-image: linear-gradient(0deg, #fff, hsla(0, 0%, 100%, 0));\n}\n\n.close-detail {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.full-screen {\n  height: 90vh;\n}\n\n.align-center {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.image {\n  margin-bottom: 8px;\n  border-radius: 4px;\n}\n\n.code-block {\n  padding: 8px;\n  border-radius: 4px;\n  background-color: #edf2f7;\n}\n\n.rich-text-block {\n  margin-top: 16px;\n}\n\n.rich-text-block h2 {\n  font-weight: 600;\n}\n\n.rich-text-block p {\n  margin-bottom: 16px;\n}\n\n.image-2 {\n  height: 64px;\n  border-radius: 4px;\n}\n\n.div-block {\n  display: none;\n  padding-bottom: 32px;\n}\n\n.neutral {\n  color: #4a5568;\n}\n\n.negative {\n  color: #c92a2a;\n}\n\n.div-block-2 {\n  display: none;\n}\n\n.div-block-10 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.div-block-11 {\n  position: absolute;\n  top: 50%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 52px;\n  height: 52px;\n  margin-top: -26px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 100px;\n  background-color: #fff;\n  box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.1), 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n}\n\n.card-footer {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 8px 16px;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: #edf2f7;\n}\n\n.static {\n  position: static;\n}\n\n.table-action {\n  position: absolute;\n  top: 50%;\n  right: 0px;\n  margin-top: -8px;\n  cursor: pointer;\n}\n\n.input-2 {\n  height: 36px;\n  margin-bottom: 0px;\n  padding-right: 8px;\n  padding-left: 8px;\n  border: 1px none #adb5bd;\n  border-radius: 4px;\n  background-color: #f1f3f5;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  color: #343a40;\n  line-height: 100%;\n}\n\n.input-2:hover {\n  border-color: #868e96;\n  background-color: #dee2e6;\n}\n\n.input-2:focus {\n  border: 2px solid #be4bdb;\n  background-color: #fff;\n}\n\n.input-2::-webkit-input-placeholder {\n  color: #868e96;\n}\n\n.input-2:-ms-input-placeholder {\n  color: #868e96;\n}\n\n.input-2::-ms-input-placeholder {\n  color: #868e96;\n}\n\n.input-2::placeholder {\n  color: #868e96;\n}\n\n.input-2.select {\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    -webkit-gradient(linear, left top, left bottom, from(#f1f3f5), to(#f1f3f5));\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    linear-gradient(180deg, #f1f3f5, #f1f3f5);\n  background-position: 98% 50%, 0px 0px;\n  background-size: 16px, auto;\n  background-repeat: no-repeat, repeat;\n}\n\n.input-2.select.large {\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    -webkit-gradient(linear, left top, left bottom, from(null), to(null));\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f77ebfef2d7_Group%202.svg\"),\n    linear-gradient(180deg, null, null);\n  background-size: 24px, auto;\n}\n\n.input-2.select.large.multi {\n  height: 128px;\n}\n\n.input-2.textarea {\n  height: 100px;\n  max-width: 400px;\n}\n\n.input-2.textarea.large {\n  height: 120px;\n}\n\n.input-2.textarea.large.fill {\n  max-width: 100%;\n}\n\n.input-2.large {\n  height: 52px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n  font-size: 16px;\n}\n\n.button-3 {\n  position: relative;\n  display: inline-block;\n  margin-top: 16px;\n  margin-bottom: 8px;\n  padding: 8px 16px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border: 2px solid transparent;\n  border-radius: 4px;\n  background-color: rgba(190, 75, 219, 0.1);\n  box-shadow: none;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  color: #9c36b5;\n  font-weight: 600;\n}\n\n.button-3:hover {\n  box-shadow: none;\n  -webkit-transform: translate(0px, -2px);\n  -ms-transform: translate(0px, -2px);\n  transform: translate(0px, -2px);\n}\n\n.button-3:active {\n  border-color: #9c36b5;\n}\n\n.button-3:focus {\n  z-index: 1;\n  border-color: rgba(190, 75, 219, 0.2);\n}\n\n.button-3.with-icon.wide.no-margin {\n  margin-top: 0px;\n}\n\n.button-3.primary {\n  border-color: #be4bdb;\n  background-color: #be4bdb;\n  box-shadow: 0 8px 16px -4px rgba(156, 54, 181, 0.3);\n  color: #fff;\n}\n\n.button-3.primary:hover {\n  box-shadow: 0 12px 20px -4px rgba(156, 54, 181, 0.3);\n}\n\n.button-3.primary:focus {\n  border-color: #e37cff;\n}\n\n.img-box {\n  width: 128px;\n  height: 128px;\n}\n\n.img-box.move-left {\n  border-radius: 8px;\n  background-color: #edf2f7;\n}\n\n.scroll {\n  overflow: scroll;\n}\n\n.max-height-xs {\n  max-height: 156px;\n}\n\n.padding-bottom-huge {\n  padding-bottom: 64px;\n}\n\n.tight {\n  max-width: 200px;\n}\n\n.black-text {\n  color: #1a202c;\n}\n\n.number {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 24px;\n  height: 24px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.grey-text {\n  color: #2d3748;\n}\n\n.question-header {\n  height: 80px;\n}\n\n.full-height {\n  height: 100%;\n}\n\n.full-height.vertical {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.full-height.vertical.center {\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.full-height.vertical.center.padded {\n  padding: 32px;\n}\n\n.full-height.vertical.padded {\n  padding: 32px;\n}\n\n.padded {\n  padding: 16px;\n}\n\n.rounded {\n  border-radius: 4px;\n}\n\n.datepicker-here {\n  height: 300px;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5d5c177340c6bea80285c4fb_Screenshot%202019-08-20%20at%204.52.28%20PM.png\");\n  background-position: -1% 50%;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.nav-container-2 {\n  position: fixed;\n  z-index: 10;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  width: 200px;\n  height: 100%;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  background-color: #f1eef8;\n}\n\n.nav-2 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.brand-2 {\n  width: 100px;\n  height: 32px;\n  max-height: 32px;\n  margin-top: 32px;\n  margin-left: 16px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da78d3fac4d6deacd4589d5_Group.png\");\n  background-position: 50% 50%;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.brand-2.scouts {\n  width: 169px;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b589b37929c5a3a8dce7a0e_Group%2012.png\");\n}\n\n.brand-2.small-brand {\n  display: none;\n  width: 40px;\n  height: 32px;\n  max-height: 32px;\n  background-image: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5da7a082e8ed8a5958595bfa_Shape.svg\");\n}\n\n.section-2 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 100vh;\n  padding: 0px 16px 64px;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: stretch;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  background-color: #fff;\n}\n\n.section-2.center {\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.container-sticky {\n  z-index: 4;\n  background-color: #fff;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: auto;\n  max-width: 1226px;\n  height: auto;\n  margin-left: -24px;\n  padding-top: 32px;\n  padding-left: 32px;\n  padding-right: 32px;\n  display: block;\n  /* position: -webkit-sticky;\n  position: sticky;\n  top: 0; */\n}\n\n.tab-menu {\n  z-index: 3;\n  background-color: #fff;\n  padding-top: 0;\n  top: 284px;\n  height: 84px;\n  /* position: sticky; */\n  width: inherit;\n  margin-left: inherit;\n}\n\n.request-tab-menu {\n  z-index: 3;\n  background-color: #fff;\n  padding-top: 0;\n  top: 262px;\n  height: 84px;\n  /* position: sticky; */\n  width: inherit;\n  margin-left: inherit;\n  margin-right: auto;\n}\n\n.body-2 {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n}\n\n.nav-link-2 {\n  margin: 2px 16px 0px;\n  padding: 12px 0px;\n  background-color: transparent;\n  -webkit-transition: color 250ms ease;\n  transition: color 250ms ease;\n  color: #4a5568;\n  font-size: 16px;\n  line-height: 100%;\n  font-weight: 600;\n}\n\n.nav-link-2:hover {\n  color: #320b85;\n}\n\n.nav-link-2.w--current {\n  border-bottom: 2px solid #4517a6;\n  background-color: transparent;\n  color: #2d3748;\n}\n\n.nav-link-2.with-badge {\n  margin-right: 4px;\n}\n\n.nav-link-2.small {\n  padding-top: 16px;\n  padding-bottom: 8px;\n  font-size: 16px;\n}\n\n.nav-link-2.tiny {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 8px;\n  margin-left: 8px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  font-size: 12px;\n}\n\n.nav-link-2.with-icon {\n  width: 100%;\n  margin-top: 0px;\n  margin-right: 0px;\n  margin-left: 0px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  padding-left: 16px;\n}\n\n.nav-link-2.with-icon:hover {\n  background-color: #e4e0f1;\n  color: #4517a6;\n}\n\n.nav-link-2.with-icon.w--current {\n  border-left: 1px none #000;\n  border-bottom-style: none;\n  background-color: #fcfaff;\n  color: #4517a6;\n}\n\n.side-bar {\n  overflow: hidden;\n  width: 220px;\n  margin-right: 16px;\n  padding-top: 52px;\n  padding-bottom: 16px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  background-color: #fcfaff;\n  box-shadow: inset -20px 0 20px -12px rgba(18, 0, 54, 0.05),\n    inset -10px 0 4px -8px rgba(21, 0, 65, 0.05);\n}\n\n.side-bar.feed {\n  position: fixed;\n  left: auto;\n  top: 0px;\n  right: 0%;\n  bottom: 0%;\n  z-index: 10;\n  overflow: scroll;\n  width: 320px;\n  margin-right: 0px;\n  margin-left: 0px;\n  padding: 32px 16px 0px;\n  border-top: 1px none #e2e8f0;\n  border-left: 1px solid #e4e0f1;\n  background-color: #fff;\n  box-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.1);\n}\n\n.side-bar.feed.padded {\n  padding-right: 32px;\n  padding-bottom: 32px;\n  padding-left: 32px;\n}\n\n.side-bar.fixed {\n  position: fixed;\n  left: 0%;\n  top: 0%;\n  right: auto;\n  bottom: 0%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: scroll;\n  width: auto;\n  height: 100vh;\n  margin-left: 0px;\n  padding-top: 82px;\n  padding-right: 32px;\n  padding-left: 32px;\n}\n\n.side-bar.fixed.temp {\n  left: 210px;\n}\n\n.card-2 {\n  margin-bottom: 16px;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  border-style: none;\n  border-width: 1px;\n  border-color: #cbd5e0;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0 0 4px -2px rgba(0, 0, 0, 0.1),\n    3px 3px 8px -4px rgba(0, 0, 0, 0.2), 0 16px 50px -8px rgba(33, 37, 41, 0.1);\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  text-decoration: none;\n}\n\n.card-2.horizontal {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card-2.horizontal.m-wrap {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card-2.horizontal.m-wrap.full-height {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.card-2.horizontal.m-wrap.expand {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.card-2.vertical {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card-2.active {\n  cursor: pointer;\n}\n\n.card-2.active.selected {\n  border-style: solid;\n  border-color: #4517a6;\n}\n\n.card-2.active:hover {\n  -webkit-transform: translate(0px, -4px);\n  -ms-transform: translate(0px, -4px);\n  transform: translate(0px, -4px);\n}\n\n.card-2.dark {\n  background-color: #1a202c;\n}\n\n.card-2.muted {\n  background-color: #cbd5e0;\n}\n\n.card-2.muted.active {\n  cursor: pointer;\n}\n\n.card-2.m-side-scroll {\n  box-shadow: 0 16px 64px 0 rgba(33, 37, 41, 0.1);\n}\n\n.card-2.m-side-scroll.active {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n  cursor: pointer;\n}\n\n.card-2.m-side-scroll.active.flex {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card-2.m-side-scroll.active.full {\n  height: 100%;\n}\n\n.card-2.m-side-scroll.flex {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card-2.m-side-scroll.flex.full {\n  height: 100%;\n}\n\n.card-2.m-side-scroll.spaced {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.search {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: -8px;\n  margin-left: -8px;\n  padding: 0px 0px 0px 8px;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 8px;\n  background-color: #eeebf7;\n}\n\n.small-text {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  font-size: 12px;\n}\n\n.small-text.nudge-right.bold {\n  color: #2d3748;\n}\n\n.small-text.muted {\n  line-height: 150%;\n}\n\n.small-text.uppercase {\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.nav-section-2 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.nav-section-2.center {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.nav-section-2.right {\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.nav-section-2.left {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.side-bar-link {\n  display: block;\n  margin: 2px -8px;\n  padding: 8px;\n  border-radius: 8px;\n  color: #4a5568;\n  font-size: 12px;\n  line-height: 150%;\n  font-weight: 600;\n}\n\n.side-bar-link:hover {\n  background-color: #e4e0f1;\n}\n\n.side-bar-link.w--current {\n  background-color: #eeebf7;\n  color: #2d3748;\n}\n\n.side-bar-link.active {\n  background-color: #f6f3fd;\n  color: #2d3748;\n}\n\n.card-section-2 {\n  padding: 32px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 auto;\n  -ms-flex: 0 auto;\n  flex: 0 auto;\n}\n\n.card-section-2.w--current {\n  background-color: transparent;\n}\n\n.card-section-2.horizontal {\n  display: inline-block;\n  border-right: 1px solid #cbd5e0;\n}\n\n.card-section-2.horizontal.end {\n  border-right-style: none;\n}\n\n.card-section-2.vertical {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  border-bottom: 1px solid #cbd5e0;\n}\n\n.card-section-2.vertical.has-bottom-border.dark-border {\n  border-bottom-color: #cdd3da;\n}\n\n.card-section-2.center {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.card-section-2.grey {\n  background-color: #f7fafc;\n}\n\n.card-section-2.flex-row {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.card-section-2.flex-row.align-center {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.card-section-2._8-padding {\n  min-width: 120px;\n  padding: 8px;\n}\n\n.card-section-2._8-padding.no-top-padding {\n  padding-top: 0px;\n}\n\n.card-section-2.fill {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.card-section-2.expand {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.card-section-2.expand.horizontal.detail-trigger {\n  background-color: #fff;\n}\n\n.card-section-2.expand.horizontal.detail-trigger.w--current {\n  border-bottom: 2px solid #4517a6;\n}\n\n.card-section-2.expand.detail-trigger.w--current {\n  border-bottom: 2px solid #4517a6;\n}\n\n.card-section-2.expand.has-top-border {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.card-section-2.detail-trigger {\n  -webkit-transition: background-color 250ms ease;\n  transition: background-color 250ms ease;\n  cursor: pointer;\n}\n\n.card-section-2.detail-trigger:hover {\n  background-color: #f7fafc;\n}\n\n.card-section-2.detail-trigger.expand {\n  background-color: #fff;\n}\n\n.card-section-2.empty {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 500px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.card-section-2.has-top-border {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card-section-2.align-left {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.card-section-2.no-shrink {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.card-section-2._50 {\n  width: 50%;\n}\n\n.card-section-2._60 {\n  width: 60%;\n}\n\n.chart-bg-2 {\n  margin-right: -16px;\n  margin-left: -16px;\n  padding: 16px 0px 0px;\n  border-radius: 4px;\n}\n\n.side-spacer {\n  position: relative;\n  width: 320px;\n  margin-right: 0px;\n  margin-left: 0px;\n  padding: 0px 24px 16px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.side-spacer.feed {\n  margin-left: 0px;\n}\n\n.side-spacer.thin {\n  width: 224px;\n}\n\n.side-spacer.thin.left {\n  margin-right: 16px;\n  padding-right: 0px;\n  padding-left: 0px;\n}\n\n.medium-text {\n  position: relative;\n  z-index: 1;\n  font-size: 14px;\n}\n\n.medium-text.medium-weight {\n  font-weight: 500;\n}\n\n.medium-text.nudge-right.huh {\n  -webkit-transform: translate(0px, 0px);\n  -ms-transform: translate(0px, 0px);\n  transform: translate(0px, 0px);\n}\n\n.keep-size {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.psuedo-card {\n  margin-right: -4px;\n  margin-bottom: 16px;\n  margin-left: -4px;\n  padding: 2px 4px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.psuedo-card:hover {\n  background-color: #edf2f7;\n}\n\n.psuedo-card.important {\n  background-color: rgba(230, 119, 0, 0.1);\n  color: #2d3748;\n}\n\n.psuedo-card.padded {\n  padding: 16px;\n}\n\n.psuedo-card.padded.negative {\n  background-color: #fff5f5;\n}\n\n.psuedo-card.padded.purple {\n  background-color: #f8f0fc;\n  color: #320b85;\n}\n\n.psuedo-card.positive {\n  background-color: #edf2ff;\n  color: #364fc7;\n}\n\n.psuedo-card.center {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.source-container {\n  margin-right: -4px;\n  margin-left: -4px;\n}\n\n.modal-2 {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  z-index: 20;\n  display: none;\n  overflow: auto;\n  padding-top: 244px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.modal-2.darker {\n  display: none;\n  background-color: rgba(33, 37, 41, 0.95);\n  color: #718096;\n}\n\n.modal-2.dev {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.modal-2.temp {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.violet-text {\n  color: #5f3dc4;\n}\n\n.pink-text {\n  color: #a61e4d;\n}\n\n.positive-2 {\n  color: #364fc7 !important;\n}\n\n.sidebar-trigger {\n  position: absolute;\n  left: auto;\n  top: 16px;\n  right: 16px;\n  bottom: auto;\n  z-index: 11;\n}\n\n.regular {\n  font-weight: 400;\n}\n\n.inline-message-content-copy {\n  position: absolute;\n  left: 0px;\n  top: 100%;\n  z-index: 10;\n  display: none;\n  overflow: hidden;\n  width: 300px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #cbd5e0;\n  border-radius: 4px;\n  background-color: #fff;\n  box-shadow: 0 16px 32px -8px rgba(33, 37, 41, 0.2);\n  font-size: 14px;\n}\n\n.inline-message-content-copy.sentiment-message {\n  left: 50%;\n  top: 120%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: auto;\n  margin-left: -70px;\n}\n\n.inline-message-content-copy.small {\n  width: auto;\n}\n\n.inline-message-content-copy.top-right {\n  left: 100%;\n  top: 0%;\n}\n\n.inline-message-content-copy.top-right.small {\n  left: 103%;\n}\n\n.inline-message-content-copy.anchor-right {\n  left: auto;\n  right: 0px;\n}\n\n.inline-message-content-copy.anchor-right.temp {\n  display: block;\n}\n\n.inline-message-content-copy.anchor-right.auto {\n  position: fixed;\n  top: auto;\n  right: auto;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: auto;\n}\n\n.inline-message-content-copy.temp {\n  display: block;\n  width: auto;\n}\n\n.inline-message-content-copy.align-center.remp {\n  display: block;\n}\n\n.link-block {\n  width: 100%;\n  color: #2d3748;\n}\n\n.hider {\n  position: absolute;\n  left: 0%;\n  top: auto;\n  right: 0%;\n  bottom: 0%;\n  z-index: 10;\n  height: 287px;\n  margin-left: -10px;\n  background-color: #fff;\n}\n\n.hider.h {\n  height: 322px;\n}\n\n.hider.s {\n  height: 54px;\n}\n\n.hider.s.h {\n  height: 84px;\n}\n\n.hider-2 {\n  position: absolute;\n  left: 0%;\n  top: auto;\n  right: 0%;\n  bottom: 0%;\n  z-index: 10;\n  height: 194px;\n  margin-left: -10px;\n  background-color: #fff;\n}\n\n.hider-2.h {\n  height: 320px;\n}\n\n.hider-2.s {\n  height: 130px;\n}\n\n.hider-2.s.h {\n  height: 120px;\n}\n\n.heading-2 {\n  color: #1a202c;\n}\n\n.div-block-3 {\n  width: 100%;\n  margin-top: 64px;\n}\n\n.profile {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  padding-right: 16px;\n  padding-left: 16px;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.div-block-4 {\n  margin-top: 16px;\n  margin-left: 16px;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  cursor: pointer;\n}\n\n.div-block-4:hover {\n  -webkit-transform: translate(-4px, 0px);\n  -ms-transform: translate(-4px, 0px);\n  transform: translate(-4px, 0px);\n}\n\n.div-block-4.right:hover {\n  -webkit-transform: translate(4px, 0px);\n  -ms-transform: translate(4px, 0px);\n  transform: translate(4px, 0px);\n}\n\n.spacer {\n  width: 184px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.div-block-5 {\n  margin-bottom: 32px;\n}\n\n.div-block-5.right {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 4px;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  cursor: pointer;\n}\n\n.div-block-6 {\n  padding-right: 30px;\n  padding-left: 30px;\n}\n\n.div-block-7 {\n  width: 200px;\n  padding-left: 8px;\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.vertical {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.vertical.align-left {\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n@media (max-width: 991px) {\n  .card.horizontal.m-wrap {\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .row.has-cards {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .row.has-cards.push-down {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .column {\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .column._40 {\n    width: 100%;\n  }\n  .measure-bar.push-right.super-long {\n    width: 240px;\n  }\n  .measure-bar.tall.push-right.med-long {\n    width: 64px;\n    min-width: auto;\n  }\n  .sentiment-map {\n    width: 90%;\n  }\n  .grey-card.push-down {\n    font-size: 12px;\n  }\n  .chart-detail-content {\n    width: auto;\n  }\n  .card-2.horizontal.m-wrap {\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n}\n\n@media (max-width: 767px) {\n  .card {\n    border-radius: 0px;\n  }\n  .row.has-cards {\n    padding-right: 0px;\n    padding-left: 0px;\n  }\n  .row.has-cards.push-down {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .card-wrap {\n    -webkit-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n  }\n  .tab-menu {\n    padding-left: 8px;\n  }\n  .data.huge {\n    font-size: 28px;\n  }\n  .nav-link {\n    margin-right: 8px;\n    margin-left: 8px;\n    font-size: 16px;\n  }\n  .column {\n    padding-right: 0px;\n    padding-left: 0px;\n  }\n  .column.has-grey-cards {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n  .measure-bar.push-right.super-long {\n    width: 100%;\n    margin-left: 0px;\n  }\n  .measure-bar.short {\n    min-width: 80px;\n  }\n  .measure-bar.tall.push-right.med-long {\n    margin-left: 0px;\n  }\n  .measure-bar.tall.push-right.long {\n    margin-left: 0px;\n  }\n  .bar-container.move-down.justify-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n  }\n  .brand {\n    width: 70px;\n    margin-right: 16px;\n  }\n  .section {\n    overflow: hidden;\n  }\n  .brand-2 {\n    width: 70px;\n    margin-right: 16px;\n  }\n  .section-2 {\n    overflow: hidden;\n  }\n  .nav-link-2 {\n    margin-right: 8px;\n    margin-left: 8px;\n    font-size: 16px;\n  }\n  .card-2 {\n    border-radius: 0px;\n  }\n}\n\n@media (max-width: 479px) {\n  h1 {\n    font-size: 20px;\n  }\n  .card.horizontal {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .card.horizontal.m-wrap {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n  .card.m-side-scroll {\n    overflow: scroll;\n  }\n  .row.spaced.in-card {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .row.spaced.align-bottom {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n  }\n  .row.in-card.spaced {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .row.center {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n  }\n  .row.has-cards.move-down.align-top {\n    -webkit-box-align: stretch;\n    -webkit-align-items: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n  }\n  .row.has-cards.m-side-scroll {\n    overflow: scroll;\n  }\n  .row.details {\n    width: 100%;\n  }\n  .row.m-vertical {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .tab-menu {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    padding-right: 8px;\n    padding-left: 8px;\n  }\n  .request-responses-tab-menu {\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .data.small {\n    width: 100%;\n  }\n  .dropdown.user-actions {\n    -webkit-transform: translate(0px, 12px);\n    -ms-transform: translate(0px, 12px);\n    transform: translate(0px, 12px);\n  }\n  .meta.push-left {\n    margin-left: 8px;\n  }\n  .table-header {\n    width: 302px;\n    border-bottom-style: none;\n  }\n  .table-header-cell {\n    width: 140px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .table-header-cell._40 {\n    width: 260px;\n  }\n  .table-row.comfy {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    border-top: 1px solid #cbd5e0;\n    border-radius: 0px;\n  }\n  .table-row.news {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: stretch;\n    -webkit-align-items: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n    border-bottom: 1px solid #cbd5e0;\n    border-radius: 0px;\n  }\n  .table-body-cell {\n    min-width: 140px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .table-body-cell.main {\n    width: 100%;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .table-body-cell.right-align {\n    padding-left: 8px;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -webkit-flex-direction: row-reverse;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n  }\n  .table-body-cell._40 {\n    width: 260px;\n  }\n  .table-body-cell._50 {\n    width: 100%;\n  }\n  .nav {\n    padding-top: 8px;\n  }\n  .nav-link.w--current {\n    margin-left: 0px;\n  }\n  .card-section.horizontal {\n    border-bottom: 1px solid #cbd5e0;\n    border-right-style: none;\n  }\n  .card-section.flex-row {\n    padding: 8px;\n  }\n  .card-section.no-top-padding {\n    padding-right: 8px;\n    padding-bottom: 8px;\n    padding-left: 8px;\n  }\n  .card-section.expand {\n    width: 100%;\n  }\n  .card-section.expand.horizontal {\n    width: 100%;\n  }\n  .card-section.expand.horizontal.has-bottom-border {\n    width: 140px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    border-right-style: solid;\n  }\n  .card-section.expand.horizontal.detail-trigger {\n    width: 140px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    border-right-style: solid;\n  }\n  .card-section.expand.has-bottom-border {\n    width: 140px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .card-section.detail-trigger.expand {\n    width: 140px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .measure-bar.short.push-right.medium {\n    width: 100%;\n    margin-left: 0px;\n  }\n  .measure-bar.tall.push-right.medium {\n    width: 100%;\n    margin-left: 0px;\n  }\n  .bar-container {\n    margin-bottom: 8px;\n  }\n  .bar-container.justify-content.small {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n  }\n  .nav-container {\n    padding-right: 8px;\n    padding-left: 8px;\n  }\n  .nav-section {\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n  .brand {\n    width: 100%;\n    height: 16px;\n    margin-bottom: 8px;\n    background-position: 0px 50%;\n  }\n  .move-right.display-name.has-object {\n    display: none;\n  }\n  .section {\n    padding-right: 9px;\n    padding-left: 8px;\n  }\n  .donut-chart-container.move-down.vertical {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .legend.push-down {\n    margin-top: 0px;\n    margin-left: 16px;\n  }\n  .sentiment-map {\n    width: 100%;\n  }\n  .grey-card.push-down {\n    margin-top: 8px;\n  }\n  .marker {\n    margin-bottom: 8px;\n  }\n  .nav-container-2 {\n    padding-right: 8px;\n    padding-left: 8px;\n  }\n  .nav-2 {\n    padding-top: 8px;\n  }\n  .brand-2 {\n    width: 100%;\n    height: 16px;\n    margin-bottom: 8px;\n    background-position: 0px 50%;\n  }\n  .section-2 {\n    padding-right: 9px;\n    padding-left: 8px;\n  }\n  .nav-link-2.w--current {\n    margin-left: 0px;\n  }\n  .card-2.horizontal {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .card-2.horizontal.m-wrap {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n  .card-2.m-side-scroll {\n    overflow: scroll;\n  }\n  .nav-section-2 {\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n  .card-section-2.horizontal {\n    border-bottom: 1px solid #cbd5e0;\n    border-right-style: none;\n  }\n  .card-section-2.flex-row {\n    padding: 8px;\n  }\n  .card-section-2.no-top-padding {\n    padding-right: 8px;\n    padding-bottom: 8px;\n    padding-left: 8px;\n  }\n  .card-section-2.expand {\n    width: 100%;\n  }\n  .card-section-2.expand.horizontal {\n    width: 100%;\n  }\n  .card-section-2.expand.horizontal.has-bottom-border {\n    width: 140px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    border-right-style: solid;\n  }\n  .card-section-2.expand.horizontal.detail-trigger {\n    width: 140px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    border-right-style: solid;\n  }\n  .card-section-2.expand.has-bottom-border {\n    width: 140px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .card-section-2.detail-trigger.expand {\n    width: 140px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n}\n@font-face {\n  font-family: \"Proxima Nova\";\n  src: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f83c7fef2d1_ProximaNova-Semibold.otf\")\n    format(\"opentype\");\n  font-weight: 600;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Proxima Nova\";\n  src: url(\"https://assets.website-files.com/5b3e1bdab90c1f1276fef2c4/5b3e1bdab90c1f3a38fef2cd_ProximaNova-Regular.otf\")\n    format(\"opentype\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n.h100 {\n  height: 100%;\n}\n.hidden-link-text {\n  line-height: 0;\n  font-size: 0;\n  color: transparent;\n}\nselect {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-indent: 1px;\n  text-overflow: \"\";\n}\n\n.rotate {\n  animation: rotation 2s infinite linear;\n}\n@keyframes rotation {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n.loader-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.75);\n  -webkit-backdrop-filter: blur(16px);\n  -moz-backdrop-filter: blur(16px);\n  -o-backdrop-filter: blur(16px);\n  backdrop-filter: blur(16px);\n}\n\n.loader {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.loader div {\n  animation: loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  transform-origin: 40px 40px;\n}\n.loader div:after {\n  content: \" \";\n  display: block;\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #c04fe1;\n  margin: -4px 0 0 -4px;\n}\n.loader div:nth-child(1) {\n  animation-delay: -0.036s;\n}\n.loader div:nth-child(1):after {\n  top: 63px;\n  left: 63px;\n}\n.loader div:nth-child(2) {\n  animation-delay: -0.072s;\n}\n.loader div:nth-child(2):after {\n  top: 68px;\n  left: 56px;\n}\n.loader div:nth-child(3) {\n  animation-delay: -0.108s;\n}\n.loader div:nth-child(3):after {\n  top: 71px;\n  left: 48px;\n}\n.loader div:nth-child(4) {\n  animation-delay: -0.144s;\n}\n.loader div:nth-child(4):after {\n  top: 72px;\n  left: 40px;\n}\n.loader div:nth-child(5) {\n  animation-delay: -0.18s;\n}\n.loader div:nth-child(5):after {\n  top: 71px;\n  left: 32px;\n}\n.loader div:nth-child(6) {\n  animation-delay: -0.216s;\n}\n.loader div:nth-child(6):after {\n  top: 68px;\n  left: 24px;\n}\n.loader div:nth-child(7) {\n  animation-delay: -0.252s;\n}\n.loader div:nth-child(7):after {\n  top: 63px;\n  left: 17px;\n}\n.loader div:nth-child(8) {\n  animation-delay: -0.288s;\n}\n.loader div:nth-child(8):after {\n  top: 56px;\n  left: 12px;\n}\n@keyframes loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@-moz-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n[data-tooltip],\n.tooltip {\n  position: relative;\n  cursor: pointer;\n}\n/* Base styles for the entire tooltip */\n[data-tooltip]:before,\n[data-tooltip]:after,\n.tooltip:before,\n.tooltip:after {\n  position: absolute;\n  visibility: hidden;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);\n  opacity: 0;\n  transition-delay: 0.8s;\n  -webkit-transition-delay: 0.8s;\n  -moz-transition-delay: 0.8s;\n  -webkit-transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out,\n    -webkit-transform 0.2s ease-in-out;\n  -moz-transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out,\n    -moz-transform 0.2s ease-in-out;\n  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out,\n    transform 0.2s ease-in-out;\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  pointer-events: none;\n}\n/* Show the entire tooltip on hover and focus */\n[data-tooltip]:hover:before,\n[data-tooltip]:hover:after,\n[data-tooltip]:focus:before,\n[data-tooltip]:focus:after,\n.tooltip:hover:before,\n.tooltip:hover:after,\n.tooltip:focus:before,\n.tooltip:focus:after {\n  visibility: visible;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);\n  opacity: 1;\n}\n/* Base styles for the tooltip's content area */\n.tooltip:after,\n[data-tooltip]:after {\n  z-index: 1000;\n  padding: 2px;\n  width: 160px;\n  border-radius: 4px;\n  text-align: center;\n  background-color: #212529;\n  color: #fff;\n  content: attr(data-tooltip);\n  font-size: 14px;\n  line-height: 1.4;\n}\n/* Directions */\n/* Top (default) */\n[data-tooltip]:before,\n[data-tooltip]:after,\n.tooltip:before,\n.tooltip:after,\n.tooltip-top:before,\n.tooltip-top:after {\n  bottom: 100%;\n  left: 50%;\n}\n[data-tooltip]:before,\n.tooltip:before,\n.tooltip-top:before {\n  margin-left: -6px;\n  margin-bottom: -12px;\n  border-top-color: #000;\n  border-top-color: hsla(0, 0%, 20%, 0.9);\n}\n/* Horizontally align top/bottom tooltips */\n[data-tooltip]:after,\n.tooltip:after,\n.tooltip-top:after {\n  margin-left: -80px;\n}\n[data-tooltip]:hover:before,\n[data-tooltip]:hover:after,\n[data-tooltip]:focus:before,\n[data-tooltip]:focus:after,\n.tooltip:hover:before,\n.tooltip:hover:after,\n.tooltip:focus:before,\n.tooltip:focus:after,\n.tooltip-top:hover:before,\n.tooltip-top:hover:after,\n.tooltip-top:focus:before,\n.tooltip-top:focus:after {\n  -webkit-transform: translateY(-12px);\n  -moz-transform: translateY(-12px);\n  transform: translateY(-12px);\n}\n/* Left */\n.tooltip-left:before,\n.tooltip-left:after {\n  right: 100%;\n  bottom: 50%;\n  left: auto;\n}\n.tooltip-left:before {\n  margin-left: 0;\n  margin-right: -12px;\n  margin-bottom: 0;\n  border-top-color: transparent;\n  border-left-color: #000;\n  border-left-color: hsla(0, 0%, 20%, 0.9);\n}\n.tooltip-left:hover:before,\n.tooltip-left:hover:after,\n.tooltip-left:focus:before,\n.tooltip-left:focus:after {\n  -webkit-transform: translateX(-12px);\n  -moz-transform: translateX(-12px);\n  transform: translateX(-12px);\n}\n/* Bottom */\n.tooltip-bottom:before,\n.tooltip-bottom:after {\n  top: 100%;\n  bottom: auto;\n  left: 50%;\n}\n.tooltip-bottom:before {\n  margin-top: -12px;\n  margin-bottom: 0;\n  border-top-color: transparent;\n  border-bottom-color: #000;\n  border-bottom-color: hsla(0, 0%, 20%, 0.9);\n}\n.tooltip-bottom:hover:before,\n.tooltip-bottom:hover:after,\n.tooltip-bottom:focus:before,\n.tooltip-bottom:focus:after {\n  -webkit-transform: translateY(12px);\n  -moz-transform: translateY(12px);\n  transform: translateY(12px);\n}\n/* Right */\n.tooltip-right:before,\n.tooltip-right:after {\n  bottom: 50%;\n  left: 100%;\n}\n.tooltip-right:before {\n  margin-bottom: 0;\n  margin-left: -12px;\n  border-top-color: transparent;\n  border-right-color: #000;\n  border-right-color: hsla(0, 0%, 20%, 0.9);\n}\n.tooltip-right:hover:before,\n.tooltip-right:hover:after,\n.tooltip-right:focus:before,\n.tooltip-right:focus:after {\n  -webkit-transform: translateX(12px);\n  -moz-transform: translateX(12px);\n  transform: translateX(12px);\n}\n/* Move directional arrows down a bit for left/right tooltips */\n.tooltip-left:before,\n.tooltip-right:before {\n  top: 3px;\n}\n/* Vertically center tooltip content for left/right tooltips */\n.tooltip-left:after,\n.tooltip-right:after {\n  margin-left: 0;\n  margin-bottom: -16px;\n}\n\n.option {\n  display: flex;\n  margin-right: 4px;\n  padding: 12px 32px;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border: 2px solid #f1f3f5;\n  border-radius: 8px;\n  background-color: #f1f3f5;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  cursor: default;\n}\n\n.option.active {\n  border-color: #5f3dc4;\n}\n\n.has-icon {\n  display: flex;\n  align-items: center;\n}\n\n.modal-body.pad-top {\n  padding-top: 32px;\n}\n.q-container {\n  position: relative;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  max-width: 100%;\n}\n\n.q-options {\n  position: absolute;\n  padding: 10px;\n}\n\n.q-more {\n  border: solid 2px transparent;\n  width: 40px;\n  cursor: pointer;\n  text-align: center;\n  border-radius: 5px;\n  padding: 4px 3px 1px 3px;\n  background-color: white;\n}\n\n.q-more:hover {\n  border-color: #d7ccec;\n}\n.q-more:focus {\n  border-color: #d7ccec;\n}\n.q-actions {\n  position: absolute;\n  background-color: white;\n  width: 150px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 3px;\n  z-index: 22;\n  top: 50px;\n  right: -100px;\n}\n.q-options {\n  right: 9px;\n  top: 5px;\n}\n.q-actions ul {\n  list-style-type: none;\n  color: #320b85;\n  padding: 0;\n  padding-top: 10px;\n}\n.q-options ul li {\n  padding: 5px 20px;\n  cursor: pointer;\n}\n.q-options ul li:hover {\n  font-weight: bold;\n}\n.q-options ul li span {\n  margin-right: 10px;\n}\n.q-options ul li svg {\n  margin-right: 2px;\n}\n.q-options.arrows button {\n  border: solid 2px transparent;\n  border-radius: 5px;\n  display: block;\n  background-color: white;\n  padding: 4px 3px;\n}\n/* .q-options.arrows button:hover {\n    border-color: #d7ccec;\n  } */\n.q-actions ul li:nth-child(3) {\n  color: #e64980;\n}\n\n.main-color {\n  color: #1c0142;\n}\n\n.main-color_1 {\n  color: #4517a6;\n}\n\n.button-link {\n  text-decoration: underline;\n  border: 0;\n  background-color: white;\n}\n#card-fixed:before {\n  position: \"fixed\";\n  z-index: 9999;\n  background-color: \"#4517A6\";\n  color: \"white\";\n  top: 20px;\n  left: -20px;\n}\n.inline-tooltip-content-settings.left-up:before {\n  background-color: #17a62f;\n  margin-top: 120px;\n  top: 120px;\n  left: -120px;\n  color: white;\n}\n\n.inline-tooltip-content {\n  z-index: 9999;\n  position: absolute;\n  margin-top: 20px;\n  /* Purple */\n  background: #4517a6;\n  color: white;\n}\n.inline-tooltip-content.top-right:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  right: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-content.top-left:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  left: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-content-new-survey {\n  z-index: 9999;\n  position: absolute;\n  margin-top: 20px;\n  right: 0;\n  /* Purple */\n  background: #4517a6;\n  color: white;\n}\n.inline-tooltip-content-new-survey.left-up:before {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  left: -20px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.inline-tooltip-content-new-survey.top-right:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  right: 100px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.inline-tooltip-content-new-survey.bottom-right:before {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  right: 100px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-content-new-survey.left-middle:before {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  left: -20px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.inline-tooltip-content-survey-launch {\n  z-index: 9999;\n  position: fixed;\n  margin-top: 20px;\n  right: 310px;\n  top: 240px;\n  /* Purple */\n  background: #4517a6;\n  color: white;\n}\n.inline-tooltip-content-survey-launch.right-top:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  right: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-content-survey-summary {\n  z-index: 9999;\n  position: fixed;\n  margin-top: 20px;\n  right: 310px;\n  /* Purple */\n  background: #4517a6;\n  color: white;\n}\n\n.inline-tooltip-content-survey-summary.right-top:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  right: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-content-multiple-options {\n  z-index: 9999;\n  position: absolute;\n\n  margin-top: 20px;\n  left: 300px;\n  /* Purple */\n  background: #4517a6;\n  color: white;\n}\n\n.inline-tooltip-content-multiple-options.top-right:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  right: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-content-3 {\n  z-index: 99999;\n  position: absolute;\n  margin-top: 20px;\n  /* Purple */\n  background: #4517a6;\n  color: white;\n}\n.inline-tooltip-content-4 {\n  z-index: 99999;\n  position: fixed;\n  margin-top: 20px;\n  /* Purple */\n  background: #4517a6;\n  color: white;\n  bottom: 50px;\n  left: 120px;\n}\n.inline-tooltip-content-5 {\n  z-index: 99999;\n  position: absolute;\n  margin-top: 20px;\n  /* Purple */\n  background: #4517a6;\n  color: white;\n  top: 50px;\n  right: 50px;\n}\n\n.inline-tooltip-content-5.top-right:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  right: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-content-3.left-up:before {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  left: -20px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.inline-tooltip-content-4.left-up:before {\n  content: \"\";\n  position: absolute;\n  top: 30px;\n  left: -20px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-content-3.left-down:before {\n  content: \"\";\n  position: absolute;\n  bottom: 20px;\n  left: -20px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.inline-tooltip-content-3.top-right:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  right: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.inline-tooltip-content-3.top-left:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  left: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.inline-tooltip-content-3.bottom-right:before {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  right: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.inline-tooltip-button {\n  color: #1c0142;\n}\n.inline-tooltip-content-new-survey.top:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  left: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.inline-tooltip-content.top:before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  left: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-content.left:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -20px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid #4517a6;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.inline-tooltip-frame {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0px;\n  gap: 109px;\n  color: white;\n\n  width: 259px;\n  height: 37px;\n\n  /* Inside auto layout */\n\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n.askFiltersTabs {\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  margin-left: 15px;\n}\n\n.askFiltersTabs input {\n  display: none;\n}\n\n.askFiltersTabs button {\n  background: white;\n  color: #2d3748;\n  transition: 0.25s ease;\n  margin-right: 32px;\n  font-weight: 300;\n  font-size: 14px;\n  width: fit-content;\n}\n\n.grey-border-bottom {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.active-border-bottom {\n  border-bottom: 2px solid #4517a6;\n}\n\n@keyframes fab-anim {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fab-reverse-anim {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.fab {\n  position: fixed;\n  /* top: 77%;\n  left: 93%;\n  right: auto; */\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: 50%;\n  -webkit-box-align: center;\n  -webkit-box-pack: center;\n  box-shadow: 0 1px 8px 0 rgb(0 0 0 / 30%);\n  background-color: #4517a6;\n  animation-name: fab-anim;\n  animation-duration: 4s;\n  bottom: 30px;\n  right: 30px;\n}\n\n.fab svg {\n  color: #fff;\n  opacity: 1;\n}\n.searchContainer {\n  display: flex;\n  background-color: #edf2f7;\n  width: 250px;\n  padding: 0px 0px 0px 0px;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  margin-top: 1rem;\n  -webkit-box-pack: start;\n  justify-content: flex-start;\n  -webkit-box-align: center;\n  align-items: center;\n  border-radius: 8px;\n  gap: 0.5rem;\n  box-sizing: border-box;\n}\n\n.searchContainer input {\n  display: block;\n  width: 100%;\n  height: 36px;\n  margin-bottom: 0px;\n  padding-right: 8px;\n  padding-left: 8px;\n  outline: none;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  background-color: transparent;\n  font-size: 12px;\n  border-style: none;\n  border-radius: 4px;\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  color: #1a202c;\n  line-height: 100%;\n}\n\n.searchContainer input::-webkit-search-cancel-button {\n  background-color: red;\n}\n\n.searchContainer button {\n  background-color: transparent;\n  border-radius: 50%;\n  font-weight: 500;\n}\n\n.active-state {\n  display: flex;\n  flex-direction: row;\n}\n\n.search-border {\n  width: 185px;\n}\n\n.close-btn {\n  opacity: 1;\n  -webkit-transition: color 200ms ease;\n  transition: color 200ms ease;\n  color: #cbd5e0;\n  padding-left: 10px;\n  cursor: pointer;\n  padding-top: 10px;\n}\n\n.states-search-dropdown {\n  position: absolute;\n  background-color: white;\n  margin-left: -8px;\n  border-radius: 3px 3px 4px 4px;\n  border: solid 1px #ddd;\n  max-height: 150px;\n  width: 208px;\n  padding: 2px 5px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  z-index: 100;\n}\n\n.grid-15 {\n  grid-template-rows: auto auto auto auto auto;\n  grid-template-columns: 1fr 1fr 0.5fr;\n  align-items: end;\n  margin-top: 10px;\n  /* margin-bottom: 10px; */\n}\n\n.grid-17 {\n  grid-template-rows: auto auto auto auto;\n  grid-template-columns: 0.3fr 1fr;\n  align-items: end;\n  margin-top: 10px;\n  /* margin-bottom: 10px; */\n}\n\n.grid-16 {\n  grid-template-rows: auto auto auto auto;\n  grid-template-columns: 0.5fr 1fr;\n  align-items: end;\n  margin-top: 10px;\n  /* margin-bottom: 10px; */\n}\n\n.w-layout-grid {\n  /* grid-row-gap: 16px; */\n  grid-column-gap: 16px;\n  /* grid-template-rows: auto auto; */\n  /* grid-template-columns: 1fr 1fr; */\n  grid-auto-columns: 1fr;\n  display: grid;\n}\n\n.dropdown-toggle-2 {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  align-items: stretch;\n  margin-left: 0;\n  margin-right: 0;\n  padding-left: 0;\n  padding-right: 0;\n  display: flex;\n}\n\n.dropdown-list-input {\n  z-index: 900;\n  width: 160px;\n  max-height: 90vh;\n  background-color: #fff;\n  border-radius: 4px;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 8px;\n  /* display: none; */\n  position: absolute;\n  top: 110%;\n  left: 0;\n  overflow: hidden;\n  box-shadow: 0 16px 32px rgba(33, 37, 41, 0.2);\n}\n\n.table-row-other {\n  border-radius: 4px;\n  flex: 0 auto;\n  align-items: baseline;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  transition: all 0.25s;\n  display: flex;\n  position: relative;\n}\n\n.table-row-other.small {\n  flex: 0 auto;\n  align-self: auto;\n  align-items: center;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  font-size: 14px;\n  line-height: 140%;\n}\n\n.table-row-other.small.left-align {\n  /* justify-content: space-between; */\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.table-body-cell.tiny {\n  width: 64px;\n  flex: 1;\n  padding-right: 0;\n  flex: none !important;\n}\n\n.action-btns {\n  grid-column-gap: 16px;\n  grid-row-gap: 16px;\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n}\n\n.image-upload {\n  width: 100%;\n  height: 400px;\n  border: 3.5px dashed var(--grey-faint);\n  color: var(--grey);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.image-upload.push-up {\n  border-color: var(--grey-faint);\n  background-color: var(--grey-background);\n  border-radius: 12px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n\n.image-preview {\n  max-width: 100%;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.helper {\n  color: var(--grey-lighter);\n  text-align: left;\n  margin-top: 4px;\n  margin-bottom: 16px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 120%;\n  display: block;\n}\n\n.response-media {\n  width: 60px;\n  height: 55px;\n  border: solid 2px var(--grey-lighter);\n  border-radius: 5px;\n  margin: 10px 15px 5px 0px;\n  overflow: hidden;\n  text-align: center;\n}\n\n.response-media-no-border {\n  width: 60px;\n  height: 60px;\n  margin: 10px 15px 5px 0px;\n  overflow: hidden;\n}\n\n.embedly-embed {\n  max-width: 100%;\n  height: 300px;\n}\n\n.pagination {\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n}\n\n.page-controls {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  align-items: stretch;\n  display: flex;\n}\n\n.page-counter {\n}\n\n.left-content {\n  align-items: center;\n  display: flex;\n}\n\n.button-7 {\n  box-shadow: none;\n  color: #320b85;\n  background-color: #4517a61a;\n  border: 2px solid #0000;\n  border-radius: 4px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  margin-bottom: 8px;\n  padding: 8px 16px;\n  font-weight: 500;\n  transition: all 0.25s;\n  display: inline-block;\n  position: relative;\n}\n\n.button-7.subtle {\n  color: #320b85;\n  background-color: #0000;\n  border-style: solid;\n  border-color: #0000;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.button-7.subtle.small {\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 0 4px;\n}\n\n.button-7.with-icon.subtle.small {\n  flex: none;\n  justify-content: flex-start;\n}\n\n.button-7:hover {\n  background-color: rgba(121, 80, 242, 0.1);\n  color: #5f3dc4;\n}\n\n.button-7:disabled {\n  background-color: inherit;\n  pointer-events: none;\n}\n\n.center-content {\n  grid-column-gap: 6px;\n  grid-row-gap: 6px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n\n.bold-text-10 {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.icon-5 {\n  opacity: 0.6;\n  flex: none;\n  width: 24px;\n  height: 24px;\n  font-size: 16px;\n  transform: none;\n}\n\n.right-content {\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n  align-items: center;\n  display: flex;\n}\n\n.row-grid {\n  grid-column-gap: 10px;\n  grid-row-gap: 0px;\n  grid-template-rows: auto;\n  grid-template-columns: 0.8fr 1fr 0.5fr;\n  grid-auto-columns: 1fr;\n  justify-content: center;\n  align-items: end;\n  display: grid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
